import { type IMessagesType } from "@domain/intl/translations/de";

const auth = {
    "app.registration.caption": "Регистрация",
    "app.registration.description": "Пожалуйста заполните необходимые поля для создания учетной записи",
    "app.registration.firm": "Название фирмы / Имя",
    "app.registration.agb": "AGB",
    "app.registration.agb.agree": "Да, я принимаю {agbLink}.",
    "app.registration.privacy.agree": "Да, я ознакомился с {datenschutzLink} и с {cookieLink}.",
    "app.registration.message.send_verification_email": "Письмо с подтверждением почты выслано на ваш ящик",
    "app.registration.almost_done": "Почти готовы",
    "app.registration.almost_done_description":
        "Спасибо за Вашу регистрацию в Binale! Пожалуйста, подтвердите Вашу электронную почту. Для этого пройдите по ссылке, которую мы отправили Вам на Ваш электронный адрес.",
    "app.registration.send_again": "Послать еще раз",
    "app.registration.resend_again_in": "Вы можете отправить письмо повторно через",

    "app.login.description": "Добро пожаловать в Binale",
    "app.login.error.fail": "Неверные E-Mail адрес или пароль.",
    "app.login.loose_2fa_app": "Приложение для аутентификации недоступно?",
    "app.login.loose_2fa_app_instructions":
        "Если Ваше приложение для аутентификации больше недоступно, свяжитесь с нами по адресу {email}",

    "app.reset_password.caption": "Забыли пароль?",
    "app.reset_password.description":
        "Пожалуйста введите свой E-mail адрес и нажмите 'Отправить' чтобы сбросить пароль.",
    "app.reset_password.confirmation":
        "Мы отправили ссылку на ваш E-Mail адрес для ввода нового пароля. Пожалуйста проверьте свой почтовый ящик.",

    "app.new_password.caption": "Новый пароль",
    "app.new_password.description": "Ввведите новый пароль.",
    "app.new_password.confirmation": "Новый пароль был сохранен.",

    "app.2fa.button.enable2fa": "Активировать 2FA",
    "app.2fa.button.showPrivateKey": "Показать личный ключ",
    "app.2fa.button.disable2fa": "Отключить 2FA",
    "app.2fa.input_label": "Введите 6-значный код из приложения",
    "app.2fa.step.title": "Включить аутентификатор",
    "app.2fa.confirm_delete": "Вы уверены, что хотите отключить 2FA?",
    "app.2fa.description":
        "Благодаря <b>двухфакторной аутентификации</b> Вы повышаете уровень безопасности своей учетной записи. При входе в систему, помимо пароля, Вы используете случайный код одноразовой проверки, который генерируется приложением для двухфакторной аутентификации.",
    "app.2fa.enabled2fa_description":
        "<b>Двухфакторная аутентификация</b> успешна активирована для Вашей учетной записи!",

    "app.2fa.step.download.title": "Скачать приложение",
    "app.2fa.step.download.description":
        "Скачайте и установите одно из представленных ниже приложений двухфакторной аутентификации на Ваш смартфон.",

    "app.2fa.step.scan.title": "Сканировать QR-код",
    "app.2fa.step.scan.description": "Отсканируйте этот QR-код в приложении",
    "app.2fa.step.scan.manual_enter": "Если вы не можете отсканировать QR-код, введите этот код вручную в приложение.",

    "app.2fa.step.backup.title": "Резервный ключ",
    "app.2fa.step.backup.description":
        "Пожалуйста, сохраните этот ключ на бумаге. Этот ключ позволит вам восстановить доступ к сайту в случае потери телефона.",

    "app.2fa.step.enable.title": "Подключить аутентификатор",
    "app.2fa.token_error": "Неверный код подтверждения 2FA",
    "app.2fa.too_many_attempts": "Слишком много неверных кодов. Попробуйте снова через 15 минут.",
};

const errors = {
    // firebase errors
    "app.firebase.error.auth_requires_recent_login": "Для смены пароля, необходимо перезайти в систему.",
    "app.firebase.error.auth_user_not_found": "В системе нет пользователя с такой почтой. Или пользователь был удален.",
    "app.firebase.error.auth_too_many_requests": "Слишком много запросов.",
    "app.firebase.error.duplicate_email": "E-mail адрес уже используется.",
    "app.firebase.error.auth_weak_password": "Слабый пароль",
    "app.firebase.error.auth_invalid_email": "Неподходящий E-mail",
    "app.firebase.error.auth_invalid_token": "Неподходящий токен",

    // error pages
    "app.error_page.title.something_went_wrong": "Кажется, что-то пошло не так... ",
    "app.error_page.we_already_fix_it": "Мы позаботимся об этом как можно скорее. Пожалуйста, обновите страницу.",
    "app.error_page.button.reload_page": "Обновить",
    "app.error_page.title.problem_with_db": "Кажется, проблема с подключением к базе данных.",
    "app.error_page.fix_problems_with_db.1":
        "Сначала убедитесь, пожалуйста, что Вы не находитесь в так называемом «приватном окне» Вашего браузера. В этом случае данные не могут быть загружены.",
    "app.error_page.fix_problems_with_db.2": "Пожалуйста, перезагрузите страницу еще раз.",
    "app.error_page.fix_problems_with_db.3":
        "Если проблема осталась или появится снова, напишите нам, пожалуйста, короткое сообщение на {email}. Мы позаботимся об этом.",
    "app.error_page.not_found": "Этой страницы не существует.",
    "app.error_page.button.back_home": "На главную",

    // validation
    "app.validation.error.field_empty": "Поле не может быть пустым",
    "app.validation.error.short_password": "Пароль должен быть минимум {length} символов",
    "app.validation.error.passwords_not_match": "Пароли не совпадают",
    "app.validation.error.invalid_email": "Неправильный E-mail адрес",
    "app.validation.error.strictLength": "{length} {length, plural, one {знак} few {знака} other {знаков}}",
    "app.validation.error.consent_required": "Пожалуйста, подтвердите согласие, чтобы продолжить",

    "app.error.message.incomplete_data": "Данные неполные. Пожалуйста, проверьте записи ({reason})",
    "app.error.message.bank_not_available": "Банк не существует в выбранном году",
    "app.error.message.kb_not_available": "Касса не существует в выбранном году",
    "app.error.message.some_incorrect": "Некоторые записи неверны",
};

export const messagesRu: IMessagesType = {
    ...auth,
    ...errors,

    "app.header.workplace": "Рабочий стол",
    "app.header.others": "Другие программы",
    "app.header.navigation": "Навигация",
    "app.header.logout": "Выйти",
    "app.header.login": "Войти",
    "app.releaseNotes.title": "Новости",
    "app.releaseNotes.markAllRead": "Отметить все как прочитанные",
    "app.releaseNotes.clearAll": "Скрыть все",
    "app.releaseNotes.clear": "Скрыть",
    "app.releaseNotes.readMore": "Подробнее",
    "app.releaseNotes.showAll": "Все обновления",
    "app.releaseNotes.empty": "Нет новых обновлений",
    "app.releaseNotes.version": "Версия {version}",
    "app.releaseNotes.unread": "Непрочитано: {count}",
    "app.releaseNotes.germanOnly": "Описание обновлений доступно только на немецком языке.",
    "app.releaseNotes.history.versions": "Версии",
    "app.releaseNotes.history.latest": "Последняя",
    "app.releaseNotes.history.title": "История обновлений",
    "app.releaseNotes.history.empty": "Пока нет описаний обновлений.",
    "app.releaseNotes.history.error": "Не удалось загрузить описания обновлений.",
    "app.settings.button.columns.text": "Столбцы",
    "app.settings.button.columns.title": "Выбрать столбцы",
    "app.companies.view.table.admin": "Главный пользователь",
    "app.companies.view.table.user": "Пользователь",
    "app.companies.filter.datev": "DATEV",
    "app.companies.filter.withDatev": "С DATEV",
    "app.companies.filter.withoutDatev": "Без DATEV",
    "app.companies.filter.lockStatus": "Статус блокировки",
    "app.companies.filter.locked": "Заблокировано",
    "app.companies.filter.unlocked": "Разблокировано",
    "app.companies.loadError": "Не удалось полностью загрузить компании. Пожалуйста, перезагрузите страницу.",
    "app.companies.detail_request.select_skr": "Пожалуйста, выберите SKR вашей компании",
    "app.companies.detail_request.select_kb": "Пожалуйста, выберите или создайте кассовую книгу",
    "app.companies.detail_request.select_bank": "Пожалуйста, выберите или создайте банк",
    "app.companies.permission": "Доступ",
    "app.companies.permission.no": "Нет",
    "app.companies.permission.read": "Аудит (Чтение)",
    "app.companies.permission.write": "Участник (Запись)",
    "app.companies.permission.admin": "Admin",
    "app.companies.permission.admin-read": "Admin Read",

    "app.profile.select.title": "Язык",
    "app.profile.button.change_password": "Сбросить пароль",
    "app.profile.button.re_login": "Войти",
    "app.profile.email_verification.success_message": "Электронная почта успешно подтверждена.",
    "app.profile.email_verification.fail_message": "Ошибка при подтверждении почты",

    "app.messages.no_elements_found": "Элементы не найдены",
    "app.message.no_document_found": "Документ не найден",
    "app.items.create_tag": "Создать Тэг",
    "app.items.create_creditor": "Создать Кредитора",
    "app.items.create_debitor": "Создать Дебитора",
    "app.items.create_category": "Создать Акк./Категорию",
    "app.items.create_article": "Создать Номенклатуру",

    "app.titles.ER": "Входящие Счета",
    "app.titles.ER_A": "Предоплаты",
    "app.titles.Deb": "Исходящие счета",
    "app.titles.FE": "Свободный ввод",
    "app.titles.POS": "Кассовый отчет",
    "app.titles.KB": "Кассовая книга",
    "app.titles.Bank": "Банк",
    "app.titles.Bank.pl": "Банки",
    "app.titles.Common": "Общие данные",
    "app.titles.SuSa": "Суммы и Сальдо",
    "app.titles.Vat": "НДС Отчет",
    "app.titles.KB.pl": "Кассовые книги",
    "app.titles.ER.erfassung": "Входящие документы",
    "app.titles.ER.rechnungen": "Счета",
    "app.titles.ER.auswertung": "Анализ",
    "app.titles.filtern": "Фильтры и поиск",
    "app.titles.ER.festschreibung": "Festschreibung",
    "app.titles.ER.za": "Платежный лист",
    "app.titles.Lager": "Склад",
    "app.titles.LA": "Зарплатные ведомости",
    "app.titles.AVM": "Основные средства",
    "app.titles.OCR": "PDF Инструменты",
    "app.titles.KA": "Обзор счетов",
    "app.titles.calendar": "Календарь",
    "app.titles.Contact": "Контакт",
    "app.titles.Contacts": "Контакты",
    "app.titles.DMS": "Документы",
    "app.titles.Banks": "Банки",
    "app.titles.CashRegister": "Касса",
    "app.titles.Invoices": "Счета",
    "app.titles.payments": "Платежи",
    "app.titles.templates": "Шаблоны",
    "app.titles.data_export": "Экспорт данных",
    "app.titles.data_import": "Импорт данных",
    "app.titles.settings": "Настройки",
    "app.titles.settings.manage": "Управление",
    "app.titles.settings.formSettings": "Настройки формы",
    "app.titles.settings.optionalFields": "Дополнительные поля",
    "app.titles.security": "Безопасность",
    "app.titles.company": "Компания",
    "app.titles.company.pl": "Компании",
    "app.titles.category": "Категория",
    "app.titles.category.pl": "Категории",
    "app.titles.creditor": "Кредитор",
    "app.titles.creditor.pl": "Кредиторы",
    "app.titles.debitor": "Дебитор",
    "app.titles.debitor.pl": "Дебиторы",
    "app.titles.tag": "Тэг",
    "app.titles.tag.pl": "Тэги",
    "app.titles.postingRules": "Правила проводок",
    "app.titles.article": "Номеклатура",
    "app.titles.article.pl": "Номеклатуры",
    "app.titles.profile": "Профиль",
    "app.titles.kontenverwaltung": "Управление счетами",
    "app.titles.import_export": "Импорт/Экспорт",
    "app.titles.accounting": "Бухгалтерия",
    "app.titles.contactPerson": "Контактное лицо",
    "app.titles.legalInformation": "Юридическая информация",
    "app.titles.termsOfPayment": "Условия оплаты",
    "app.titles.communication": "Коммуникация",
    "app.titles.contacts.client": "Клиент",
    "app.titles.contacts.partner": "Поставщик",
    "app.titles.contacts.other": "Прочий (Свободный ввод)",
    "app.titles.contacts.employee": "Сотрудник",
    "app.titles.contacts.shareholder": "Акционер",
    "app.titles.contacts.bankDetails": "Банковские реквизиты",
    "app.titles.contacts.classification": "Классификация",
    "app.titles.bulkEdit": "Множественное редактирование",

    "app.bulkEdit.buGate.mixedScope":
        "Изменение BU без категории невозможно: у выбранных записей счета с разными налоговыми областями (VSt и USt).",
    "app.bulkEdit.buGate.autoBu": "Изменение BU без категории невозможно: хотя бы один счёт является автоматическим.",
    "app.bulkEdit.buGate.noVatScope":
        "Изменение BU без категории невозможно: хотя бы у одного счёта нет налоговой области (VSt/USt).",
    "app.bulkEdit.buGate.nonCategoryItems":
        "Изменение BU без категории невозможно: хотя бы одна запись проведена на кредитора/дебитора, а не на счёт учёта.",
    "app.bulkEdit.buGate.kust": "Изменение BU невозможно: режим малого предприятия (§ 19 UStG).",
    "app.bulkEdit.buGate.unresolvedCategory":
        "Изменение BU без категории невозможно: хотя бы один счёт не удалось найти в плане счетов.",
    "app.bulkEdit.splitHint.question": "Где остальные поля?",
    "app.bulkEdit.splitHint.explanation":
        "В выборке есть разделённые записи с несколькими позициями. Поля, относящиеся к отдельной позиции, невозможно однозначно применить, поэтому они скрыты. Редактировать можно только поля, которые относятся ко всей записи.",

    "app.postingRules.metro.category": "Категория",
    "app.postingRules.metro.default": "По умолчанию",
    "app.postingRules.metro.own": "Собственный счёт",
    "app.postingRules.metro.sentinel": "нет счёта, решает бухгалтер",
    "app.postingRules.hint.metro":
        "Позиции счетов Metro относятся к категории. Счёт берётся из этой таблицы, ИИ не используется.",
    "app.postingRules.direction.incoming": "Входящие счета",
    "app.postingRules.direction.outgoing": "Исходящие счета",
    "app.postingRules.section.corpus": "База данных",
    "app.postingRules.section.patterns": "Шаблоны проводок",
    "app.postingRules.section.corrections": "Исправления",
    "app.postingRules.tile.skr": "План счетов SKR {skr}",
    "app.postingRules.tile.ownRows": "Проверенные проводки",
    "app.postingRules.tile.pending": "Ещё не доступны",
    "app.postingRules.tile.shared": "Проводки других компаний",
    "app.postingRules.tile.shared.active": "активно",
    "app.postingRules.tile.shared.inactive": "неактивно",
    "app.postingRules.tile.corrections": "Исправлений: {total}, в запросе: {inPrompt}",
    "app.postingRules.column.supplier": "Поставщик",
    "app.postingRules.column.customer": "Клиент",
    "app.postingRules.column.sachkonto": "Счёт",
    "app.postingRules.column.bu": "Налоговый ключ",
    "app.postingRules.column.lines": "Строки проводок",
    "app.postingRules.column.share": "Доля",
    "app.postingRules.column.lastBooking": "Последняя проводка",
    "app.postingRules.column.from": "Предложение ИИ",
    "app.postingRules.column.to": "Проведено",
    "app.postingRules.column.count": "Количество",
    "app.postingRules.column.lastSeen": "Последний раз",
    "app.postingRules.column.inPrompt": "Используется в запросе",
    "app.postingRules.column.counterparty": "Контрагент",
    "app.postingRules.column.purpose": "Назначение",
    "app.postingRules.column.rate": "Ставка НДС",
    "app.postingRules.column.status": "Статус",
    "app.postingRules.column.applied": "Применено",
    "app.postingRules.column.updatedBy": "Изменено",
    "app.postingRules.unknownSupplier": "Неизвестный поставщик",
    "app.postingRules.unknownCustomer": "Неизвестный клиент",
    "app.postingRules.purpose.any": "Любая цель",
    "app.postingRules.purpose.general": "Общее",
    "app.postingRules.purpose.shipping": "Доставка",
    "app.postingRules.purpose.pfand": "Залог",
    "app.postingRules.purpose.logistic_surcharge": "Логистическая наценка",
    "app.postingRules.purpose.ec_service_fee": "Комиссия EC-сервиса",
    "app.postingRules.purpose.ec_zero_tax_fee": "Комиссия EC без НДС",
    "app.postingRules.purpose.tip": "Чаевые",
    "app.postingRules.purpose.global_discount": "Общая скидка",
    "app.postingRules.purpose.third_party_funded_discount": "Скидка за счёт третьей стороны",
    "app.postingRules.purpose.authority_fee": "Гос. пошлина",
    "app.postingRules.purpose.other": "Прочее",
    "app.postingRules.rate.any": "Любая ставка",
    "app.postingRules.status.draft": "Черновик",
    "app.postingRules.status.active": "Активно",
    "app.postingRules.status.rejected": "Отклонено",
    "app.postingRules.warning.unknownKonto": "Неизвестный счёт",
    "app.postingRules.applied.never": "{count}×",
    "app.postingRules.applied.withDate": "{count}× посл. {date}",
    "app.postingRules.rules.filter.current": "Активные / черновики",
    "app.postingRules.rules.filter.rejected": "Отклонённые",
    "app.postingRules.rules.hint.status":
        "При контировке применяются только активные правила. Черновики нужно сначала подтвердить, отклонённые правила не применяются никогда.",
    "app.postingRules.rules.loadError": "Не удалось загрузить правила компании.",
    "app.postingRules.rules.empty.title": "Пока нет правил компании",
    "app.postingRules.rules.empty.description": "Для этого направления ещё не настроены правила.",
    "app.postingRules.rules.action.edit": "Редактировать правило",
    "app.postingRules.rules.action.confirm": "Подтвердить правило",
    "app.postingRules.rules.action.reject": "Отклонить правило",
    "app.postingRules.rules.editor.new": "Новое правило",
    "app.postingRules.rules.import": "Импортировать предложения",
    "app.postingRules.rules.import.result":
        "{count, plural, =0 {Новых предложений нет} one {# правило импортировано} few {# правила импортировано} many {# правил импортировано} other {# правил импортировано}}",
    "app.postingRules.rule.create": "Создать правило",
    "app.postingRules.hint.corpus":
        "ИИ учится на проверенных проводках (статус OK, не черновик, не сторнировано). Новые проводки обычно доступны со следующего дня.",
    "app.postingRules.hint.retrieval":
        "Для каждого нового счёта ИИ находит {retrieveK} самых похожих собственных проводок, прежде всего того же поставщика с похожими позициями, и ориентируется на их счета.",
    "app.postingRules.hint.shared":
        "Пока собственных проводок меньше {sharedBelow}, ИИ добавляет анонимизированные проводки других компаний, без имён людей и текстов проводок.",
    "app.postingRules.hint.corrections":
        "Проверенная проводка, отличающаяся от предложения ИИ, считается исправлением. {correctionsLimit} последних исправлений важнее шаблонов проводок.",
    "app.postingRules.hint.confidence":
        "Предложения с уверенностью ниже {confidence} % не применяются, поле остаётся пустым.",
    "app.postingRules.examples.unknown": "Без контакта",
    "app.postingRules.examples.open": "Показать индексированные проводки",
    "app.postingRules.examples.routing": "Счёт {sachkonto}, BU {bu}",
    "app.postingRules.examples.empty": "Нет индексированных проводок для этого шаблона.",
    "app.postingRules.hint.examples":
        "Это индексированные предложения проводок за этим шаблоном. Именно их ИИ сравнивает с новым счётом.",
    "app.postingRules.hint.direction": "Входящие и исходящие счета анализируются отдельно.",
    "app.postingRules.patterns.empty.title": "Пока нет шаблонов проводок",
    "app.postingRules.patterns.empty.description": "Проверенные проводки обычно появляются здесь на следующий день.",
    "app.postingRules.corrections.empty.title": "Пока нет исправлений",
    "app.postingRules.corrections.empty.description":
        "Если проверенная проводка отличается от предложения ИИ по счёту или коду BU, она появится здесь.",
    "app.postingRules.ai.loadError": "Не удалось загрузить данные. Возможно, нет прав на чтение для этого типа счетов.",
    "app.postingRules.metro.loadError": "Не удалось загрузить категории Metro.",
    "app.postingRules.metro.ownLoadError":
        "Не удалось загрузить собственные счета компании, поэтому столбец «Собственный счёт» пуст. Нужны права на чтение входящих счетов.",
    "app.postingRules.truncated": "Показаны только первые {shown} из {total} записей.",
    "app.postingRules.tab.metro": "Категории Metro",
    "app.postingRules.tab.rules": "Правила компании",
    "app.postingRules.tab.ai": "Шаблоны проводок ИИ",
    "app.postingRules.hint.label": "Подсказка",
    "app.postingRules.hint.order":
        "Порядок проводки: сначала категории Metro, затем правила компании, затем ИИ. Автоматический счёт всегда сам задаёт налоговый ключ. Шаблон контакта заполняет только поля, которые после этого остались пустыми.",

    "app.titles.reconciliation": "Авто-связывание",
    "app.titles.copy_data_from": "Скопировать новые счета из",
    "app.titles.bind_to_bank": "Привязать к Банку (Бухгалтерия)",
    "app.titles.bind_to_kb": "Привязать к Кассe (Бухгалтерия)",
    "app.titles.unbind": "Удалить привязку",
    "app.titles.bind_to_banking_bank": "Привязать к банку (Banking)",
    "app.titles.create_kb": "Добавить кассу",
    "app.titles.update_kb": "Редактировать кассу",
    "app.titles.create_bank": "Добавить банк",
    "app.titles.update_bank": "Редактировать банк",
    "app.titles.create_subtype": "Добавить подпапку",
    "app.titles.update_subtype": "Редактировать подпапку",

    "app.button.login": "Войти",
    "app.button.register": "Зарегистрироваться",
    "app.button.confirm": "Подтвердить",
    "app.button.dmsSave": "сохранить",
    "app.button.dmsSaveAndClose": "сохранить и закрыть",
    "app.button.aiReview": "ИИ-проверка",
    "app.button.send": "Отправить",
    "app.button.send_to_dms": "в DMS",
    "app.button.save": "Сохранить",
    "app.button.saveAll": "Сохранить все",
    "app.button.saveSelected": "Сохранить выбранные",
    "app.button.create": "Создать",
    "app.button.add": "Добавить",
    "app.button.cancel": "Отменить",
    "app.button.confAndClose": "Подтвердить и закрыть",
    "app.button.close": "Закрыть",
    "app.button.finish": "Закончить",
    "app.button.done": "Готово",
    "app.button.apply": "Применить",
    "app.button.unselect": "Снять выделение",
    "app.button.buchen": "Записать",
    "app.button.delete": "Удалить",
    "app.button.bind": "Привязать",
    "app.button.unbind": "Удалить привязку",
    "app.button.bind_banking": "Привязать Banking",
    "app.button.unbind_banking": "Удалить Banking-привязку",
    "app.button.bind_cash_register": "Привязать кассу",
    "app.button.unbind_cash_register": "Удалить привязку кассы",
    "app.button.storno": "Отменить запись",
    "app.button.edit": "Редактировать",
    "app.button.view": "Просмотр",
    "app.button.copy": "Копировать",
    "app.button.download": "Скачать",
    "app.button.select": "Выделить",
    "app.button.loading": "Загрузка...",
    "app.button.saving": "Сохранение...",
    "app.title.color": "Цвет",
    "app.button.color.remove_color": "Убрать цвет",
    "app.button.color.red": "Красный",
    "app.button.color.blue": "Голубой",
    "app.button.color.yellow": "Желтый",
    "app.button.color.purple": "Фиолетовый",
    "app.button.color.green": "Зеленый",
    "app.button.reorganise": "Реорганизировать",
    "app.button.upload": "Загрузить",
    "app.button.next": "Дальше",
    "app.button.back": "Назад",
    "app.button.reset": "Сбросить",
    "app.button.default": "По умолчанию",
    "app.button.update": "Обновить",
    "app.button.openInNewTab": "Открыть в новой вкладке",
    "app.button.export": "Экспортировать",

    "app.confirmation.pdf.finish": "Завершить работу?",
    "app.fields.vatNb": "VAT-Номер",
    "app.fields.wIdNr": "W-IdNr.",
    "app.fields.wIdNr.invalid": "Неверный хозяйственный идентификационный номер",
    "app.fields.wIdNr.missingSuffix": "Отсутствует отличительный признак - полный формат: DE123456788-00001",
    "app.fields.taxNumber": "Налоговый номер",
    "app.fields.typeOfRegister": "Тип реестра",
    "app.fields.registerCourt": "Регистрационный суд",
    "app.fields.registerNumber": "Регистрационный номер",

    "app.confirmation.record_remove.body": "Вы действительно хотите удалить запись?",
    "app.confirmation.invoice_remove.body": "Вы действительно хотите удалить счет?",
    "app.confirmation.record_cancel.body": "Вы действительно хотите отменить запись?",
    "app.confirmation.festschreiben_edit.body": "Эта запись зафиксирована! Вы действительно хотите ее отредактировать?",
    "app.kb.journal.no_items_tooltip":
        "Не выбраны записи, среди выбранных есть негативное Сальдо или предыдущие записи не зафиксированы",
    "app.confirmation.header": "Подтверждение",
    "app.confirmation.header.record_delete": "Удалить запись!",
    "app.confirmation.header.record_cancel": "Отмена записи",
    "app.confirmation.header.confirmed_edit": "Измененить подтвержденную запись!",
    "app.confirmation.header.festschreiben_edit": "Измененить зафиксированную запись!",
    "app.confirmation.body": "Подтвердите действие!",
    "app.fields.lfdnr": "№ п/п",
    "app.fields.nr": "Nr.",
    "app.fields.date": "Дата",
    "app.fields.dateTo": "Дата по",
    "app.auswertung.loadedYears.title": "Загруженные годы",
    "app.auswertung.loadedYears.info":
        "В целях производительности загружаются только проводки за выбранный год, а также за предыдущий и следующий год. Чтобы увидеть проводки за другие годы, выберите соответствующий год.",
    "app.fields.date.month": "Месяц",
    "app.fields.date.erfassung": "Период",
    "app.fields.date.year": "Год",
    "app.fields.creditor": "Кредитор",
    "app.fields.debitor": "Дебитор",
    "app.fields.creditor_view": "Обзор Кредиторов",
    "app.fields.konto_view": "Обзор Счетов",
    "app.fields.bezeichnung": "Наименование",
    "app.fields.name": "Название",
    "app.fields.contact": "Контакт",
    "app.fields.bankDetails": "Банковские реквизиты",
    "app.fields.products": "Продукты",
    "app.fields.rechnung_num": "№ счета",
    "app.fields.internal_num": "Внутренний №",
    "app.fields.konto": "Номер",
    "app.fields.gkonto": "Исх. Счет",
    "app.fields.gkonto.full": "Исходящий Счет",
    "app.fields.brutto": "Брутто",
    "app.fields.betrag": "Сумма",
    "app.fields.betragType": "Вид",
    "app.fields.totalAmount": "Общая сумма",
    "app.fields.partialAmount": "Частичная сумма",
    "app.fields.originalAmount": "Сумма ввода",
    "app.fields.currency.rate": "Курс",
    "app.fields.vat%": "НДС, %",
    "app.fields.vat": "НДС",
    "app.fields.netto": "Нетто",
    "app.fields.open": "Откр.",
    "app.fields.buchtext": "Товар/Услуга",
    "app.fields.buchtext2": "Дополнительная информация",
    "app.fields.freigabe": "Согласование",
    "app.fields.skonto": "Скидка",
    "app.fields.zugewiesen": "Назначено",
    "app.fields.deadlineDays": "Отсрочка платежа",
    "app.fields.dueDate": "Дата платежа",
    "app.fields.discountDays": "Дней скидки",
    "app.fields.discountDate": "Дата скидки",
    "app.fields.discountPercent": "Скидка, %",
    "app.fields.discountAmount": "Сумма скидки",
    "app.fields.notes": "Заметки",
    "app.fields.verrechnung": "Предоплата",
    "app.fields.wählen": "выбрать",
    "app.fields.rabatt": "Rabatt",
    "app.fields.offner_betrag": "Непогашенная сумма",
    "app.fields.lastschrift": "Прямое списание/Lastschrift",
    "app.fields.draft": "Черновик",
    "app.fields.uberweisung": "Банковский перевод",
    "app.fields.barzahlung": "Оплата наличными",
    "app.fields.kartenzahlung": "Оплата картой",
    "app.fields.sonstiges": "Другое",
    "app.fields.falligkeit": "Срок оплаты",
    "app.fields.actions": "Действия",
    "app.fields.saldo": "Сальдо",
    "app.fields.payment": "Платеж",
    "app.fields.konto_len": "Длина аккаунта",
    "app.fields.color": "Цвет",
    "app.fields.user": "Пользователь",
    "app.fields.schleppend": "Следовать",
    "app.fields.search": "Поиск",
    "app.fields.address": "Адрес",
    "app.fields.company_name": "Имя компании",
    "app.fields.producer": "Производитель",
    "app.fields.description": "Описание",
    "app.fields.unit": "Единицы",
    "app.fields.taxation": "Налогообложение по НДС",
    "app.fields.favouritePaymentType": "Основное средство платежа",
    "app.fields.datevNrConsultant": "Номер консультанта",
    "app.fields.datevNrCompany": "Номер клиента",
    "app.fields.countryCode": "Страна",
    "app.fields.euroCountryCode": "Страна-ЕС",
    "app.fields.postcode": "Индекс",
    "app.fields.city": "Населенный пункт",
    "app.fields.street": "Улица",
    "app.fields.house": "Номер дома",
    "app.fields.additionalAddress": "Дополнение к адресу",
    "app.fields.13bUStG": "Варианты § 13b UStG",
    "app.fields.paymentPurpose": "Назначение платежа",
    "app.fields.paymentMethod": "Способ оплаты",
    "app.fields.days": "дней",
    "app.fields.phone": "Телефон",
    "app.fields.internalDesignation": "Внутреннее название",
    "app.fields.type": "Тип",
    "app.fields.subType": "Подтип",
    "app.fields.companyName": "Наименование компании",
    "app.fields.companyNameWithLegalForm": "Наименование компании (вкл. форму юр. лица)",
    "app.fields.legalForm": "Юридическая форма",
    "app.fields.createdAt": "Создано",
    "app.fields.salutation": "Обращение",
    "app.fields.title": "Титул",
    "app.fields.firstName": "Имя",
    "app.fields.lastName": "Фамилия",
    "app.fields.customerNumber": "Номер клиента",
    "app.fields.ownerEmail": "E-mail владельца",
    "app.fields.ownerEmail.hint": "Этот человек должен быть уже зарегистрирован. Он станет владельцем этой фирмы.",
    "app.fields.accountOwner": "Владелец счета",
    "app.fields.bankCodeNumber": "Кодовый номер банка (BLZ)",
    "app.fields.bankAccountNumber": "Номер банковского счета",
    "app.fields.bankName": "Наименование банка",
    "app.fields.productService": "Товар/Услуга",
    "app.fields.position": "Позиция",
    "app.fields.department": "Отдел",
    "app.fields.currency": "Валюта",
    "app.fields.comment": "Примечание",
    "app.fields.module": "Модуль",
    "app.fields.attachment": "Приложение",
    "app.fields.invoice": "Счет",
    "app.fields.creditNote": "Кредит-нота",

    "app.fields.recordReview": "Проверка",
    "app.fields.recordReview.ok": "OK",
    "app.fields.recordReview.new": "Новый",
    "app.fields.recordReview.changed": "Изменен",
    "app.fields.recordReview.question": "Вопрос",
    "app.fields.recordReview.error": "Ошибка",
    "app.fields.recordAiReview": "ИИ-контроль",
    "app.fields.recordAiReview.valid": "ИИ подтвердил",
    "app.fields.recordAiReview.invalid": "ИИ расхождение",
    "app.fields.recordAiReview.unchecked": "не проверено",
    "app.fields.recordAiReview.checks.booking_date": "Дата проводки",
    "app.fields.recordAiReview.checks.brutto_amount": "Сумма брутто",
    "app.fields.recordAiReview.checks.vat_amount": "НДС",

    // PDF Stats filters
    "app.pdf.stats.date": "Дата",
    "app.pdf.stats.module": "Модуль",
    "app.pdf.stats.user": "Пользователь",
    "app.pdf.stats.company": "Компания",
    "app.pdf.stats.search": "Поиск...",
    "app.pdf.stats.csv": "CSV",
    "app.pdf.stats.loading": "Загружено {done}/{total}",

    "app.fields.fileUrl": "URL файла",
    "app.fields.numPages": "Количество страниц",
    "app.fields.rowNumber": "#",

    "app.fields.ertrag": "Приход",
    "app.fields.aufwand": "Расход",

    "app.fields.purpose": "Назначение платежа",
    "app.fields.myIban": "Мой IBAN",
    "app.fields.myBankAccount": "Мой банковский счет",
    "app.fields.counterpartyName": "Имя контрагента",
    "app.fields.counterpartyIbanOrAccountNum": "IBAN/Счет контрагента",
    "app.fields.counterpartyBicOrBlz": "BIC/BLZ контрагента",
    "app.fields.transactionType": "Тип транзакции",
    "app.fields.transactionAmount": "Сумма",
    "app.fields.openingBalance": "Начальное сальдо",
    "app.fields.openingBalanceDate": "Дата начального сальдо",
    "app.fields.bankTitle": "Внутренне наименование банка",

    "app.labels.allYear": "Весь год",
    "app.labels.paymentConditions": "Условия оплаты",

    "app.components.split.title": "Раздельный счет",
    "app.components.editing": "Редактирование",
    "app.components.not_selected": "Не выбрано",
    "app.components.all_selected": "Все выбрано",
    "app.components.nselected": "Выбрано",
    "app.components.all": "Все",
    "app.components.all_months": "Все месяцы",
    "app.components.used": "Мой список",
    "app.components.creating": "Создание",
    "app.components.date.range_error": "Дата должна быть в заданном промежутке",
    "app.components.table.no_items": "Нет записей",
    "app.components.form.attachment": "Прикрепить файл",
    "app.components.form.clear": "Очистить форму",

    // "app.cookie": "Возможно, мы будем использовать cookie. Продолжая использование программы, вы соглашаетесь на это.",
    "app.notification.update":
        "Мы выпустили обновление! Пожалуйста, обновите страницу, чтобы получить продолжить работу в обновленном приложении",
    "app.notification.copiedToClipboard": "Поле скопировано",
    "app.notification.copyToClipboardFailed": "Не удалось скопировать в буфер обмена",

    "app.global.email": "E-Mail адрес",
    "app.global.password": "Пароль",
    "app.global.password_repeat": "Подтверждение пароля",
    "app.global.error": "Неизвестная ошибка.",
    "app.global.login_now": "Войти в систему",
    "app.global.register_now": "Зарегистрироваться",
    "app.global.do_not_have_account": "Новый клиент?",
    "app.global.already_have_account": "Уже есть аккаунт?",
    "app.global.not_selected": "Не выбрано",
    "app.global.total": "Общ.",
    "app.global.components.payment_connection.created": "Запись в модуле {module} была автоматически создана.",
    "app.global.components.payment_connection.updated": "Запись в модуле {module} была автоматически изменена.",
    "app.global.components.payment_connection.removed": "Запись в модуле {module} была удалена.",
    "app.global.components.payment_connection.markedRemoved": "Запись в модуле {module} была отмечена удаленной.",
    "app.global.components.num_corrector.title": "Назначение нового номера",
    "app.global.yes": "Да",
    "app.global.no": "Нет",
    "app.global.step": "Шаг",
    "app.global.previous_step": "Предыдущий шаг",
    "app.global.bank": "Банк",
    "app.global.confirmRemoveInfo": "Вы действительно хотите удалить эту информацию?",
    "app.global.confirmSentToTrash": "Отправить документ в корзину",
    "app.global.confirmRemoveDocument": "Удалить навсегда?",
    "app.global.saveChanges": "Сохранить изменения?",
    "app.global.binaleNeedUpdate": "Вышла новая версия Binale. Пожалуйста, обновите программу!",
    "app.global.onlyNumbersHint": "только цифры",

    "app.payments.verrechnungen": "Выбрать предоплату.",
    "app.paymentConnections.record": "Платёжные данные (информация по платежу)",
    "app.paymentConnections": "Привязка платежа",
    "app.paymentConnections.helperText": "Пожалуйста, выберите один или несколько счетов, к которым относится платеж.",
    "app.paymentConnections.deleteAssignment": "Удалить связь",
    "app.paymentConnections.saveAssignment": "Сохранить связь",
    "app.paymentConnections.showAllOpenItems": "Показать все открытые позиции",
    "app.paymentConnections.showClosedItems": "Показать закрытые позиции",
    "app.paymentConnections.multiHint": "На этом шаге можно сопоставить несколько счетов",
    "app.paymentConnections.skontoSignHint":
        "Выбранная запись в {product} использует {sign, select, negative {отрицательную} other {положительную}} сумму. Используйте тот же знак для скидки.",
    "app.paymentConnections.recordsWillBeCreated": "Будет создано записей: {n}",
    "app.paymentConnections.differenz": "Разница",

    "app.contacts.new": "Создать Контакт",
    "app.contacts.type.organization": "Организация",
    "app.contacts.type.individual": "Физическое лицо",
    "app.contacts.type.institution": "Учреждение",
    "app.contacts.add": "Добавить адрес",
    "app.contacts.confirmRemoveContact": "Вы действительно хотите удалить этот контакт?",

    "app.message.progress": "Действие выполняется...",
    "app.message.success": "Действие успешно выполнено",
    "app.dms.delete.movedToTrash":
        "{count, plural, one {1 документ перемещён} few {# документа перемещено} other {# документов перемещено}} в корзину",
    "app.dms.delete.hardDeleted":
        "{count, plural, one {1 документ удалён} few {# документа удалено} other {# документов удалено}} навсегда",
    "app.dms.delete.keptAttached":
        "{count, plural, one {1 документ остаётся} few {# документа остаются} other {# документов остаются}} в корзине - ещё привязан",
    "app.message.userSelectCompany": "Активная компания была изменена",
    "app.message.companyCreateBank": "Банк успешно создан",
    "app.message.companyCreateKB": "Касса успешно создана",
    "app.message.companyUpdateBank": "Банк успешно обновлен",
    "app.message.companyUpdateKB": "Касса успешно обновлена",
    "app.message.companyDeleteBank": "Банк успешно удален",
    "app.message.companyDeleteKB": "Касса успешно удалена",
    "app.message.companySetProducts": "Доступные продукты для компании были обновлены",
    "app.companies.accountingProductsEnabledReload": "Страница будет перезагружена.",
    "app.message.companyCreate": "Компания была создана",
    "app.message.companyUpdate": "Компания была изменена",
    "app.message.companyDelete": "Компания была удалена",
    "app.message.companySaveMember": "Пользователь был удален",
    "app.message.companyDeleteMember": "Пользователь был сохранен",
    "app.message.nothingSelected": "Пожалуйста, выберите тип контакта ({ relations }) в разделе “Общее“.",

    "app.tooltip.manageFavouritePaymentType": "Изменить основное средство платежа",
    "app.tooltip.noOpenItems": "открытых позиций нет",
    "app.tooltip.form.correct": "Скорректируйте {amount} {currency}",

    "app.ocr.button.checkAll": "выделить все",
    "app.ocr.button.deleteEmptyPages": "удалить пустые страницы",
    "app.ocr.button.hideDeletedPages": "скрыть удаленные страницы",
    "app.ocr.button.showDeletedPages": "показать удаленные страницы",
    "app.ocr.button.deletePage": "удалить страницу",
    "app.ocr.button.restorePage": "восстановить страницу",
    "app.ocr.button.rotatePage": "повернуть",
    "app.ocr.button.splitDocs": "разъединить",
    "app.ocr.button.unifyDocs": "соединить",
    "app.ocr.button.uncheckAll": "убрать выделение",
    "app.ocr.button.addDocument": "добавить документ",
    "app.ocr.button.selectDocument": "Выбрать документ",

    "app.ocr.parking": "Паркинг",
    "app.ocr.page": "Страница",
    "app.ocr.document": "Документ",
    "app.ocr.allPages": "Все страницы",
    "app.ocr.totalPages": "Всего страниц",
    "app.ocr.documentsNumber": "Количество документов",
    "app.ocr.selectedPages": "Выделенные страницы",

    "app.ocr.mode.put": "Соединить",
    "app.ocr.mode.qr": "Разъединить (QR-Код)",
    "app.ocr.mode.every": "Разъединить (каждая страница)",
    "app.ocr.mode.second": "Разъединить (каждая вторая страница)",
    "app.ocr.mode.manual": "Ручная обработка",

    "app.ocr.error.encrypted": "Выбранный документ зашифрован или защищён и не может быть обработан.",
    "app.ocr.dragDocument": "Перетащите нужный документ сюда",
    "app.ocr.placeDocumentHere": "Поместить документ здесь",

    "app.titles.taxes": "Налоги",
    "app.titles.contracts": "Контракты",
    "app.titles.year_report": "Годовой отчет",
    "app.titles.uncategorized": "Без категории",

    "app.dms.add_documents": "Добавить {isSingular, select, true {документ} other {документы}}",
    "app.titles.new_documents": "Новые документы",

    "app.dms.typeOfDocuments": "Папка",
    "app.titles.trash": "Удаленные документы",
    "app.dms.add_subtype": "добавить элемент",

    "app.dms.list": "СПИСОК",
    "app.dms.grid": "Карточки",

    "app.dms.empty": "Пусто",
    "app.dms.fileName": "Имя файла",
    "app.dms.documentDate": "Дата",
    "app.dms.documentNumber": "Номер документа",
    "app.dms.userName": "Имя пользователя",
    "app.dms.fileInformation": "Информация о файле",
    "app.dms.createdBy": "Автор",
    "app.dms.createdAt": "Дата создания",
    "app.dms.updatedAt": "Дата обновления",
    "app.dms.hasXRechnung": "E",
    "app.dms.hasMarkdown": "MD",
    "app.dms.comment": "Комментарий",
    "app.dms.status": "Статус",
    "app.dms.closeEditor": "Закрыть редактор",
    "app.dms.total": "Всего",
    "app.dms.totalDocuments":
        "{count, plural, one {# документ} few {# документа} many {# документов} other {# документов}}",

    "app.dms.search.mode.quick": "Быстрый",
    "app.dms.search.mode.fulltext": "Полнотекстовый",
    "app.dms.search.mode.semantic": "ИИ-поиск",
    "app.dms.search.mode.label": "Режим поиска",
    "app.dms.search.placeholder.fulltext": "Полнотекстовый поиск, нажмите Enter",
    "app.dms.search.placeholder.semantic": "ИИ-поиск, нажмите Enter",
    "app.dms.search.noResults": "Документы не найдены",
    "app.dms.search.error": "Поиск не удался",

    "app.dms.selectAll": "Выбрать всё",
    "app.dms.copyId": "Копировать ID",
    "app.dms.datevBeleg": "Документ DATEV",
    "app.dms.eInvoiceBeleg": "Э-счет",
    "app.dms.eInvoiceBelegHint":
        "Этот электронный счет передается в DATEV без изменений. Остальные документы этой проводки не передаются.",
    "app.dms.datevBeleglinkHint": "Первые до 5 документов (макс. 20 МБ) объединяются в один PDF и передаются в DATEV.",
    "app.dms.primaryBeleg": "Основной документ",
    "app.dms.primaryBelegHint": "Этот документ стоит первым и считается основным.",
    "app.dms.documentPosition": "Позиция {position}",
    "app.dms.copyUrl": "Копировать URL",
    "app.dms.idCopied": "ID скопирован",
    "app.dms.idCopyFailed": "Не удалось скопировать ID",
    "app.dms.urlCopied": "URL скопирован",
    "app.dms.clickOrDrag":
        "Нажмите, чтобы выбрать, или перетащите {isSingular, select, true {файл} other {файлы}} (макс. 20 МБ/файл) в эту область, чтобы загрузить их.",
    "app.dms.supportFor": "Возможен множественный выбор",
    "app.dms.identicalFiles": "Идентичные файлы. Выберите файл для загрузки и подтвердите выбор",
    "app.dms.confirmResolving": "Подтвердить выбор",
    "app.dms.deleteAll": "Удалить всё",
    "app.dms.view": "Вид",
    "app.dms.moveTo": "Переместить",
    "app.dms.emptyDate": "без даты",

    "app.dms.complete": "Завершить",
    "app.dms.allDocuments": "Все документы",
    "app.dms.changeModeEnabled": "Режим изменения включен",
    "app.dms.noticeOfDelete": "Уведомление о режиме удаления",
    "app.dms.cantDelete": "Вы не можете удалить этот документ из корзины",
    "app.dms.moveSelectedDocuments": "Переместите выбранные документы в предпочтительный тип!",
    "app.dms.pages": "{count, plural, one {# страница} few {# страницы} many {# страниц} other {# страниц}}",
    "app.dms.mainTypes": "Основные типы",
    "app.dms.tooltipDocumentNumber": "Пожалуйста, используйте следующие символы",
    "app.dms.letters": "Буквы",
    "app.dms.number": "Номер",
    "app.dms.specialSymbols": "Спецсимволы",

    "app.dms.paymentStatus.offen": "открыто",
    "app.dms.paymentStatus.avis": "AVIS",
    "app.dms.paymentStatus.bezahlt": "оплачено",
    "app.dms.paymentStatus.storno": "Сторно",
    "app.dms.vat": "НДС",
    "app.dms.corporation_tax": "Корпоративный налог на прибыль",
    "app.dms.business_tax": "Торговый налог на прибыль",
    "app.dms.statement": "Раздельное и общее распределение",
    "app.dms.income_tax": "Подоходный налог",
    "app.dms.other_taxes": "Прочие налоги",
    "app.dms.tax_office": "Налоговая служба",
    "app.dms.more": "Более",
    "app.dms.isAttached": "связано с бухгалтерией",
    "app.dms.isTransactionAttached": "связано с банковской транзакцией",
    "app.dms.isCashRegisterAttached": "связано с кассовой операцией",
    "app.dms.filterConnected": "связано",
    "app.dms.filterNotConnected": "не связано",
    "app.dms.filterAccountingModule": "Модуль бухгалтерии",
    "app.dms.filterAccountingModuleYearHint":
        "Доступно только при выбранном годе. Проводки загружаются только за выбранный год, поэтому без выбора года фильтр по модулю будет неполным.",
    "app.dms.filterActive": "фильтр активирован",
    "app.dms.selectBank": "выберите банк",
    "app.dms.selectCashJournal": "выберите кассу",
    "app.dms.selectTaxes": "выберите налоги",
    "app.dms.noInternetConnection": "Нет соединения с интернетом",
    "app.dms.addDocumentId": "Добавить ID документа",
    "app.dms.selectInDms": "Выбрать в DMS",
    "app.dms.noAssignment": "Без привязки",
    "app.dms.filterColor": "Фильтр по цвету",
    "app.dms.logs": "Лог",

    "app.dms.payments.title": "Платежи",
    "app.dms.payments.documentAmount": "Сумма счёта",
    "app.dms.payments.openAmount": "Остаток",
    "app.dms.payments.paymentAmount": "Сумма оплаты",
    "app.dms.payments.discountPercent": "Скидка %",
    "app.dms.payments.discountAmount": "Сумма скидки",
    "app.dms.payments.account": "Банк / Касса",
    "app.dms.payments.accountKind.bank": "Банк",
    "app.dms.payments.accountKind.kasse": "Касса",
    "app.dms.payments.source.bankTransaction": "из банковской транзакции",
    "app.dms.payments.source.cashRegisterTransaction": "из кассовой транзакции",
    "app.dms.payments.paymentGroup": "Групповой перевод",
    "app.dms.payments.noPayments": "Платежей пока нет",
    "app.dms.payments.deleteConfirm": "Удалить платёж?",
    "app.dms.payments.deleteConfirmDesc": "Вы действительно хотите удалить этот платёж?",
    "app.dms.payments.lockedTooltip": "Заблокировано групповым переводом",
    "app.dms.payments.viewGroup": "Показать групповой перевод",
    "app.dms.payments.document": "Документ",
    "app.dms.payments.goToBank": "В банк",
    "app.dms.payments.deleteGroupConfirm": "Удалить групповой платёж?",
    "app.dms.payments.deleteGroupConfirmDesc": "Все связанные платежи также будут удалены.",

    "app.invoice.createInvoice": "Создать счет",
    "app.invoice.createInvoiceFormat": "Создать формат номера счета",
    "app.invoice.createInvoiceLineItemTemplate": "Создать шаблон позиции счета",
    "app.invoice.createInvoicePaymentTemplate": "Создать шаблон условий оплаты",
    "app.invoice.invoicesList": "Список счетов",
    "app.invoice.invoicePaymentTemplates": "Шаблоны условий оплаты",
    "app.invoice.invoiceLineItemTemplates": "Шаблоны позиций счета",

    "app.invoice.brutto": "с НДС",
    "app.invoice.netto": "без НДС",

    "app.invoice.contactDetails": "Сведения о клиенте",
    "app.invoice.contact": "Поиск или ввод клиента",
    "app.invoice.address": "Адрес",
    "app.invoice.street": "Улица",
    "app.invoice.houseNumber": "Номер дома",
    "app.invoice.zeep": "Почтовый индекс",
    "app.invoice.city": "Город",
    "app.invoice.countryCode": "Страна",

    "app.invoice.invoiceDetails": "Детали счета",
    "app.invoice.isConfirmed": "Статус",
    "app.invoice.invoiceNumberFormatId": "Формст номера счета",
    "app.invoice.customerNum": "Номер клиента",
    "app.invoice.customerReceiverName": "Получатель",
    "app.invoice.date": "Дата",
    "app.invoice.deliveryDate": "Дата доставки",
    "app.invoice.serviceDate": "Дата обслуживания",
    "app.invoice.servicePeriodDays": "Период работ (Дни)",
    "app.invoice.servicePeriodMonths": "Период работ (Месяцы)",
    "app.invoice.noShowDate": "Не показывать дату доставки",

    "app.invoice.head": "Раздел заголовка",
    "app.invoice.invoiceTitle": "Название счета",
    "app.invoice.introductionText": "Вводный текст",

    "app.invoice.lineItems": "Элементы строки",
    "app.invoice.viewer": "Просмотр счета",
    "app.invoice.position": "Позиция",
    "app.invoice.productService": "Продукт / услуга",
    "app.invoice.quantity": "Количество",
    "app.invoice.price": "Цена",
    "app.invoice.unit": "Юнит",
    "app.invoice.tax": "Налог",
    "app.invoice.discount": "Скидка",
    "app.invoice.total": "Итого",
    "app.invoice.newLine": "Новая строка",
    "app.invoice.subTotalNet": "Промежуточный итог",
    "app.invoice.piece": "Штук",
    "app.invoice.hour": "Час",
    "app.invoice.vat": "Налог",
    "app.invoice.totalAmount": "Общая сумма",

    "app.invoice.foot": "Нижняя часть страницы",
    "app.invoice.paymentTerm": "Срок оплаты",
    "app.invoice.description": "Описание",

    "app.invoice.caching": "Кэширование",
    "app.invoice.goToPreview": "Перейти к предварительному просмотру",
    "app.invoice.save_tooltip":
        "В счете должна быть минимум одна позиция, все позиции должны иметь описание и стоимость",
    "app.invoice.save_contact_tooltip":
        "Вы можете сохранить данные клиента как Контакт. В дальнейшем достаточно будет выбрать Контакт, чтобы все данные запилнились автоматически",
    "app.invoice.contact_tooltip": "Выберите Контакт чтобы автоматически заполнить данные клиента",

    "app.invoiceList.invoiceDate": "Дата выставления счета",
    "app.invoiceList.serviceDescription": "Наименование услуги",
    "app.invoiceList.project": "Проект",
    "app.invoiceList.amountNetto": "Сумма нетто (EUR)",
    "app.invoiceList.amountBrutto": "Сумма брутто (EUR)",

    "app.cash_register.allCashRegisters": "Все кассы",
    "app.cash_register.exportToFibu": "Экспорт в ФИБУ",
    "app.cash_register.countCashRegisters": "Количество касс",
    "app.cash_register.fibuKasse": "Касса ФИБУ",
    "app.cash_register.newCashRegister": "Новая касса",
    "app.cash_register.dmsDocuments": "Документы DMS",
    "app.cash_register.deleteConfirm": "Пожалуйста, подтвердите удаление кассы. Все данные будут безвозвратно удалены.",
    "app.cash_register.fibuExportTitle": "Экспорт в ФИБУ",
    "app.cash_register.fibuExportTooltip": "Создать записи в кассе ФИБУ <b>{name} ({accountNum})</b>",
    "app.cash_register.exportAll": "Экспортировать все",
    "app.cash_register.exportAllInfo": "Будут экспортированы все транзакции.",
    "app.cash_register.exportNewInfo": "Будут экспортированы только новые транзакции.",
    "app.cash_register.upload.aiRunning": "Binale AI работает...",
    "app.cash_register.upload.ocrRunning": "ИИ OCR работает...",
    "app.cash_register.upload.aiDescription": "{count} документов сейчас обрабатываются ИИ, пожалуйста, подождите",
    "app.cash_register.upload.processing": "Обработка...",
    "app.cash_register.upload.processed": "Обработано",
    "app.cash_register.upload.errorCount": "({count} ошибок)",
    "app.cash_register.upload.createTransactions": "Создать транзакции",
    "app.cash_register.fromDocuments.result": "Создано: {created}, уже связано: {linked}, отклонено: {refused}",

    "app.transactionExport.created": "Экспортировано: {count}",
    "app.transactionExport.alreadyExported": "Уже экспортировано, пропущено: {count}",
    "app.transactionExport.invalid": "Не экспортировано: {count} ({message})",
    "app.transactionExport.notFound": "Не найдено: {count}",
    "app.transactionExport.reason.invalidDate": "Неверная дата проводки",
    "app.transactionExport.reason.noAccountForYear": "Нет бухгалтерского счёта для года транзакции",
    "app.transactionExport.reason.noAccountingYear": "Нет бухгалтерского года для года транзакции",
    "app.transactionExport.reason.noAmount": "Транзакция без суммы",
    "app.transactionExport.reason.nothing": "Нечего экспортировать",
    "app.transactionExport.reason.noChart": "Нет периода BU плана счетов для даты проводки",
    "app.transactionExport.suggestionsFailed": "Предложения корр. счёта недоступны: {error}",
    "app.banks.allBanks": "Все банки",
    "app.banks.myBank": "Мой банк",
    "app.banks.transactionInfo": "Информация о транзакции",
    "app.banks.counterparty": "Контрагент",
    "app.banks.newBank": "Новый банк",
    "app.banks.editBank": "Редактировать банк",
    "app.banks.editTransaction": "Редактировать транзакцию",
    "app.banks.editTransactions": "Редактировать транзакции",
    "app.banks.uploadTransactions": "Загрузить банковскую выписку",
    "app.banks.unmapped": "Не назначено",
    "app.banks.selectDataField": "Выберите поле",
    // --- intl migration batch (phases 1-9) ---
    "app.fields.bicSwift": "BIC (SWIFT-код)",
    "app.fields.federalState": "Федеральная земля",
    "app.datev.disconnect": "Удалить подключение DATEV",
    "app.datev.connected": "DATEV подключён",
    "app.datev.connect": "Подключить DATEV",
    "app.datev.refreshToken": "Обновить токен",
    "app.titles.documents": "Документы",
    "app.titles.eInvoice": "Электронный счёт",
    "app.titles.diverse": "разные",
    "app.companies.deleteData": "Удалить данные",
    "app.companies.type.gastronomy": "Гастрономия",
    "app.companies.type.restaurant": "Ресторан",
    "app.companies.type.cafe": "Кафе",
    "app.companies.type.bakery": "Пекарня",
    "app.companies.type.trade": "Торговля",
    "app.companies.type.retail": "Розничная торговля",
    "app.companies.type.wholesale": "Оптовая торговля",
    "app.companies.type.services": "Услуги",
    "app.companies.type.consulting": "Консалтинговые услуги",
    "app.companies.type.servicesOther": "Прочие услуги",
    "app.companies.imageMaxSize": "Изображение (макс. {size})",
    "app.companies.accountingYears": "Учётные годы",
    "app.companies.companyLogo": "Логотип компании",
    "app.companies.validation.range": "должно быть в диапазоне [{min}, {max}]",
    "app.companies.invoice.email": "E-mail для счетов",
    "app.companies.invoice.attention": "Вниманию (необязательно)",
    "app.companies.invoice.receiver": "Получатель счёта",
    "app.companies.invoice.director": "Директор",
    "app.companies.invoice.headquarter": "Местонахождение компании",
    "app.companies.invoice.generalPartner": "Полный товарищ",
    "app.companies.invoice.taxInfo": "{country}: Налоговая информация",
    "app.companies.invoice.commercialRegister": "{country} торговый реестр",
    "app.companies.invoice.invalidTaxNumber": "Неверный налоговый номер",
    "app.companies.onlyAdminCanSetProducts": "Только администратор может устанавливать продукты",
    "app.companies.saldoTransfer": "Перенос сальдо",
    "app.companies.saldoTransfer.feWriteRequired":
        "Для этого выбора платежные черновики записываются в Свободный ввод. Нужен доступ на запись к Свободному вводу.",
    "app.companies.logs": "Журналы",
    "app.companies.go": "Старт",
    "app.companies.updateAdmin": "Изменить администратора",
    "app.companies.selectAtLeastOneProduct": "Выберите хотя бы один продукт",
    "app.companies.createOrUpdateMember": "Создать/изменить пользователя",
    "app.companies.modules": "Модули",
    "app.companies.roles": "Роли",
    "app.companies.noRolesAssigned": "Роли не назначены",
    "app.companies.editRoles": "Редактировать роли",
    "app.companies.role.reviewer": "Проверяющий",
    "app.companies.role.datevExporter": "Экспортёр DATEV",
    "app.companies.role.elsterExporter": "Отправитель ELSTER",
    "app.companies.role.avmApprover": "Подтверждение проводок в учёте основных средств",
    "app.companies.role.dmsAdmin": "Администратор DMS",
    "app.companies.role.dmsNewDocuments": "DMS новые документы",
    "app.companies.role.dmsReviewer": "Проверяющий DMS",
    "app.companies.fiscalYearConfig": "Настройка финансового года",
    "app.companies.noAccountingProductsWarning":
        "Для этой компании не подключены продукты бухгалтерии, поэтому год не может быть создан. Обратитесь к администратору для подключения продуктов бухгалтерии.",
    "app.companies.yearsConfigTable": "Настройка учётных годов",
    "app.companies.col.fiscalYearStart": "Начало фин. года",
    "app.companies.col.ustvaFrequency": "Периодичность УСт-декларации",
    "app.companies.col.dauerfristverlaengerung": "Продление срока подачи",
    "app.companies.col.steuerlichBeraten": "Налоговый консультант",
    "app.companies.filingFrequency.monthly": "Ежемесячно",
    "app.companies.filingFrequency.quarterly": "Ежеквартально",
    "app.companies.filingFrequency.none": "Без УСт-декларации",
    "app.companies.triState.notSet": "Не указано",
    "app.companies.triState.yes": "Да",
    "app.companies.triState.no": "Нет",
    "app.companies.taxPrepayments.title": "Авансовые платежи по налогам",
    "app.companies.taxPrepayments.button": "Авансовые платежи по налогам",
    "app.companies.taxPrepayments.empty": "Авансовые платежи не внесены",
    "app.companies.taxPrepayments.col.taxType": "Вид налога",
    "app.companies.taxPrepayments.col.validFromYear": "Действует с года",
    "app.companies.taxPrepayments.col.amount": "Сумма (за квартал)",
    "app.companies.taxPrepayments.col.note": "Примечание",
    "app.companies.taxPrepayments.col.docRef": "Ссылка на документ",
    "app.companies.taxPrepayments.taxType.est": "Подоходный налог (EST)",
    "app.companies.taxPrepayments.taxType.kst": "Налог на прибыль (KST)",
    "app.companies.taxPrepayments.taxType.gewst": "Промысловый налог (GEWST)",
    "app.companies.taxPrepayments.addNew": "Добавить новый авансовый платёж",
    "app.companies.noSkrForYearWarning":
        "Невозможно создать этот год. Для года {year} не настроен SKR, обратитесь к администратору.",
    "app.companies.dataCopyFromYearInfo": "Данные будут скопированы из года {year}",
    "app.companies.taxation.none": "Без НДС",
    "app.companies.kontoLen.standard": "Стандарт",
    "app.companies.kontoLen.extended": "Расширенный",
    "app.companies.vatNumbers": "Номера НДС",
    "app.admin.metroAccountingCategories.title": "Категории проводок Metro",
    "app.admin.metroAccountingCategories.key": "Ключ",
    "app.admin.metroAccountingCategories.label": "Название",
    "app.admin.metroAccountingCategories.skr03": "SKR03",
    "app.admin.metroAccountingCategories.skr04": "SKR04",
    "app.admin.metroAccountingCategories.articles": "Артикулы",
    "app.admin.metroAccountingCategories.new": "Новая категория",
    "app.admin.metroAccountingCategories.save": "Сохранить",
    "app.admin.metroAccountingCategories.saved": "Категория сохранена",
    "app.companies.metroAccountingCategories": "Категории проводок Metro",
    "app.companies.metroAdministration": "Администрирование Metro",
    "app.companies.metroAccountingCategories.default": "По умолчанию: {konto}",
    "app.companies.metroAccountingCategories.own": "Свой счёт ({digits} цифр)",
    "app.companies.metroAccountingCategories.noExt":
        "Свои счета возможны только с расширенными номерами счетов (kontoExt > 0).",
    "app.companies.metroAccountingCategories.saved": "Сопоставление сохранено",
    "app.admin.metroArticles.title": "Артикулы Metro",
    "app.admin.metroArticles.tab.candidates": "Кандидаты",
    "app.admin.metroArticles.tab.articles": "Артикулы",
    "app.admin.metroArticles.search": "Артикул, EAN или название",
    "app.admin.metroArticles.articleNo": "Артикул",
    "app.admin.metroArticles.ean": "EAN",
    "app.admin.metroArticles.eanSearch": "Искать EAN на metro.de",
    "app.admin.metroArticles.group": "Товарная группа",
    "app.admin.metroArticles.description": "Название",
    "app.admin.metroArticles.taxChar": "Код НДС",
    "app.admin.metroArticles.aiCategories": "Классификация ИИ",
    "app.admin.metroArticles.category": "Категория",
    "app.admin.metroArticles.source": "Источник",
    "app.admin.metroArticles.note": "Заметка",
    "app.admin.metroArticles.documents": "Документы",
    "app.admin.metroArticles.companies": "Компании",
    "app.admin.metroArticles.netVolume": "Нетто",
    "app.admin.metroArticles.lastSeen": "Последний",
    "app.admin.metroArticles.confirm": "Подтвердить",
    "app.admin.metroArticles.save": "Сохранить",
    "app.admin.metroArticles.import": "Импорт (xlsx/csv)",
    "app.admin.metroArticles.importResult": "{inserted} новых, {updated} обновлено, {rejected} отклонено",
    "app.admin.metroArticles.importRejected": "Строка {row}: {reason}",
    "app.admin.metroArticles.total": "{total} артикулов",
    // AG Grid chrome (pagination controls); keys map to AG Grid's own localeText names.
    "app.grid.page": "Страница",
    "app.grid.to": "до",
    "app.grid.of": "из",
    "app.grid.firstPage": "Первая страница",
    "app.grid.previousPage": "Предыдущая страница",
    "app.grid.nextPage": "Следующая страница",
    "app.grid.lastPage": "Последняя страница",
    "app.grid.pageSize": "Строк на странице:",
    "app.grid.pageSizeAria": "Строк на странице",

    "app.admin.metroArticles.truncated": "Показаны только первые {shown} из {total} результатов. Уточните поиск.",
    "app.companies.metroArticles": "Артикулы Metro",
    "app.companies.pending.title": "Ваша компания настраивается",
    "app.companies.pending.description":
        "Мы настраиваем вашу компанию. Как только она будет готова, она появится здесь автоматически - пожалуйста, перезагрузите страницу.",
    "app.companies.pending.contact": "Если у вас есть вопросы, напишите нам на {email}.",
    "app.avv.accept": "Да, я прочитал {avvLink} и принимаю его.",
    "app.avv.modal.description":
        "Почти готово: для {companyName} осталось лишь принять {avvLink} (AVV). Согласно ст. 28 GDPR он описывает, как binale.app обрабатывает ваши данные. Загляните в него и просто подтвердите ниже.",
    "app.button.later": "Позже",
    "app.page.legal.section": "Правовая информация",
    "app.page.legal.compliance": "Конфиденциальность и право",
    "app.page.legal.impressum": "Выходные данные",
    "app.page.legal.haftungsausschluss": "Отказ от ответственности",
    "app.page.legal.agb": "Условия использования",
    "app.page.legal.datenschutz": "Политика конфиденциальности",
    "app.page.legal.avv": "Договор об обработке данных",
    "app.page.legal.cookiePolicy": "Политика использования файлов cookie",
    "app.page.legal.privacy": "Ваша конфиденциальность",
    "app.page.home.temporarilyLocked": "Временно заблокировано",

    "app.home.metrics.title": "Показатели",
    "app.home.metrics.expand": "Показать детали",
    "app.home.metrics.collapse": "Свернуть",
    "app.home.metrics.guv": "ОПиУ",
    "app.home.metrics.revenue": "Выручка",
    "app.home.metrics.costs": "Расходы",
    "app.home.metrics.profit": "Прибыль",
    "app.home.metrics.op": "Открытые позиции",
    "app.home.metrics.op.receivables": "Дебиторы",
    "app.home.metrics.op.payables": "Кредиторы",
    "app.home.metrics.op.count": "{count} откр.",
    "app.home.metrics.vat": "НДС {month}",
    "app.home.metrics.vat.zahllast": "К уплате",
    "app.home.metrics.vat.erstattung": "К возврату",
    "app.home.metrics.cash": "Касса",
    "app.home.metrics.bank": "Банк",
    "app.home.metrics.bank.trend": "Последние 30 дней",
    "app.home.metrics.betriebsergebnis": "Операционный результат",
    "app.home.metrics.overdueReceivables": "Просроченная дебиторская задолженность",
    "app.home.metrics.liquidity": "Ликвидные средства",
    "app.home.aiUsage.title": "Обработка ИИ",
    "app.home.aiUsage.scope": "Область отчёта",
    "app.home.aiUsage.scope.all": "Все",
    "app.home.aiUsage.scope.company": "Фирма",
    "app.home.aiUsage.today": "Сегодня",
    "app.home.aiUsage.week": "7 дней",
    "app.home.aiUsage.window": "{days} дней",
    "app.home.aiUsage.documents": "Документы",
    "app.home.aiUsage.documentsPerDay": "Документов в день",
    "app.home.aiUsage.cost": "Стоимость",
    "app.home.aiUsage.costPerDay": "Стоимость в день (USD)",
    "app.home.aiUsage.tokens": "Токены",
    "app.home.aiUsage.tokens.input": "Ввод",
    "app.home.aiUsage.tokens.cached": "Из кеша",
    "app.home.aiUsage.tokens.output": "Вывод",
    "app.home.aiUsage.tokens.thoughts": "Рассуждения",
    "app.home.aiUsage.tokens.total": "Всего",
    "app.home.aiUsage.models": "Модели",
    "app.home.aiUsage.model": "Модель",
    "app.home.aiUsage.model.unknown": "не указана",
    "app.home.aiUsage.costByStage": "Затраты по этапам (USD)",
    "app.home.aiUsage.stage.EXTRACTION": "Распознавание документов",
    "app.home.aiUsage.stage.METRO_SPLIT": "Разбивка METRO",
    "app.home.aiUsage.stage.OCR": "OCR",
    "app.home.aiUsage.stage.DOCUMENTS_TO_RECORDS": "Документы в проводки",
    "app.home.aiUsage.stage.TRANSACTION_EXPORT": "Экспорт банка/кассы",
    "app.home.aiUsage.stage.TRANSACTION_SUGGESTIONS": "Предложения контрсчетов",
    "app.home.aiUsage.hint":
        "{from} – {to}. Учитывается только последняя обработка каждого документа; повторно обработанные документы перемещаются на более поздний день, стоимость прежних запусков не включена.",
    "app.home.calendar.title": "Сроки",
    "app.home.calendar.summary.today": "Сегодня: {count, plural, one {# срок} other {# сроков}}",
    "app.home.calendar.summary.next": "Следующий срок: {title} через {days, plural, one {# день} other {# дней}}",
    "app.home.calendar.summary.empty": "Нет предстоящих сроков",
    "app.home.calendar.group.heute": "Сегодня",
    "app.home.calendar.group.woche": "На этой неделе",
    "app.home.calendar.group.monat": "В этом месяце",
    "app.home.calendar.group.spaeter": "Позже",
    "app.home.calendar.ustva": "Декларация НДС {month}",
    "app.home.calendar.ustvaQuarter": "Декларация НДС, {quarter} кв.",
    "app.home.calendar.sondervz": "Особый авансовый платёж НДС",
    "app.home.calendar.vzEst": "Авансовый платеж подоходного налога",
    "app.home.calendar.vzKst": "Авансовый платеж налога на прибыль",
    "app.home.calendar.vzGewst": "Авансовый платеж налога на промысел",
    "app.home.calendar.annualUst": "Декларация НДС",
    "app.home.calendar.annualEst": "Декларация подоходного налога",
    "app.home.calendar.annualKst": "Декларация налога на прибыль",
    "app.home.calendar.annualGewst": "Декларация налога на промысел",
    "app.home.calendar.offenlegung": "Раскрытие годовых отчётов",
    "app.home.calendar.softDeadline": "рекомендуется до {date}",
    "app.home.calendar.hardDeadline": "не позднее {date}",
    "app.home.calendar.userEventTitle": "{title}",
    "app.home.calendar.addEvent": "Добавить событие",
    "app.home.calendar.type.meeting": "Встреча",
    "app.home.calendar.type.appointment": "Термин",
    "app.home.calendar.type.reminder": "Напоминание",
    "app.home.calendar.type.delivery": "Поставка",
    "app.home.calendar.type.other": "Другое",
    "app.home.calendar.modal.createTitle": "Создать событие",
    "app.home.calendar.modal.editTitle": "Редактировать событие",
    "app.home.calendar.modal.fields.title": "Название",
    "app.home.calendar.modal.fields.eventDate": "Дата",
    "app.home.calendar.modal.fields.type": "Тип",
    "app.home.calendar.modal.fields.assignee": "Ответственный",
    "app.home.calendar.modal.fields.assigneeNone": "Не назначено",
    "app.home.calendar.modal.fields.contact": "Контакт",
    "app.home.calendar.modal.fields.notes": "Заметки",
    "app.home.calendar.modal.fields.color": "Цвет",
    "app.home.calendar.modal.delete": "Удалить событие",
    "app.home.calendar.state.doneLabel": "Отметить как выполнено",
    "app.home.calendar.state.noteTrigger": "Изменить заметку и цвет",
    "app.home.calendar.state.noteLabel": "Заметка",

    "app.calendar.tabs.month": "Месяц",
    "app.calendar.tabs.agenda": "Повестка",
    "app.calendar.month.badgeLabel": "{count, plural, one {# срок} other {# сроков}}",
    "app.calendar.dayPanel.empty": "Нет событий в этот день",
    "app.calendar.dayPanel.selectPrompt": "Выберите день, чтобы увидеть события",
    "app.calendar.agenda.empty": "Нет событий в этом году",
    "app.home.openPositions.title": "Открытые позиции",
    "app.home.openPositions.empty": "Нет открытых позиций",
    "app.home.openPositions.bucket.ueberfaellig": "Просрочено",
    "app.home.openPositions.bucket.heute": "Срок истёк сегодня",
    "app.home.openPositions.bucket.woche": "На этой неделе",
    "app.home.openPositions.bucket.spaeter": "Позже",
    "app.home.openPositions.debitor": "Дебиторы",
    "app.home.openPositions.kreditor": "Кредиторы",
    "app.page.test.skrTestPage": "Тестовая страница SKR",
    "app.page.auth.confirmingEmail": "Подтверждение e-mail, пожалуйста, подождите...",
    "app.page.profile.theme": "Тема",
    "app.page.profile.theme.system": "Системная",
    "app.page.profile.theme.light": "Светлая",
    "app.page.profile.theme.dark": "Тёмная",
    "app.page.profile.deleteAccount":
        "Хотите удалить аккаунт? Напишите нам на {contact}. Мы удалим аккаунт и связанные данные, если этому не препятствуют установленные законом сроки хранения.",
    "app.page.profile.classicBackground": "Классический фон",
    "app.page.profile.validating": "Проверка...",
    "app.page.datev.deleteCache": "Удалить кэш DATEV",
    "app.page.datev.cache": "DATEV (кэш)",
    "app.page.datev.notConnected": "DATEV не подключён",
    "app.admin.vat.drafts": "Черновики",
    "app.admin.vat.showHidden": "Показать скрытые",
    "app.admin.vat.ibanActive": "IBAN активен",
    "app.admin.vat.searchPlaceholder": "Поиск по УИН НДС, адресу или любому запросу",
    "app.admin.vat.legalName": "Юридическое наименование",
    "app.admin.vat.confirmed": "Подтверждено",
    "app.admin.vat.vatNumber": "Номер плательщика НДС",
    "app.admin.vat.show": "Показать",
    "app.admin.vat.hide": "Скрыть",
    "app.banks.creditCardNumber": "Номер карты",
    "app.banks.deleteBankConfirm":
        "Пожалуйста, подтвердите, что вы хотите удалить банк. Все данные будут безвозвратно удалены.",
    "app.banks.onlyCsv": "только CSV",
    "app.banks.isConnected": "подключено",
    "app.banks.isNotConnected": "не подключено",
    "app.banks.dmsBankLabel": "Банк: {name}",
    "app.banks.dmsBankBindHeading": "Привязать DMS банк",
    "app.banks.bankType": "Тип банка",
    "app.banks.bankTypeCreditCard": "Кредитная карта",
    "app.banks.bankTypePlatform": "Платформа",
    "app.banks.import": "Импортировать",
    "app.banks.stepInitConnection": "Инициализация подключения",
    "app.banks.stepEstablishConnection": "Установить подключение",
    "app.banks.finapiConnection": "Подключение FinAPI",
    "app.banks.linkImportedAccount": "Привязать импортированный счёт",
    "app.banks.connectNewBank": "Подключить новый банк",
    "app.banks.startConnection": "Начать подключение",
    "app.banks.stepUpdateConnection": "Обновить подключение",
    "app.banks.stepImportTransactions": "Импортировать транзакции",
    "app.banks.finapiImport": "Импорт FinAPI",
    "app.banks.lastImportDate": "Дата последнего импорта",
    "app.banks.importFrom": "Импорт с",
    "app.banks.importFromInvalid": "Выберите дату с {min} по {max}",
    "app.banks.onlyNewTransactions": "Только новые транзакции",
    "app.banks.finapiIsConnected": "<b>FinAPI</b> подключён.",
    "app.banks.disconnect": "Отключить",
    "app.banks.accountLinkedSuccess": "Счёт успешно привязан",
    "app.banks.noAvailableAccounts": "Доступных счетов не найдено.",
    "app.banks.stepInitiatePayment": "Инициировать платёж",
    "app.banks.stepFinalizePayment": "Завершить платёж",
    "app.banks.paymentTransfer": "Платёжный перевод",
    "app.banks.recipientName": "Имя получателя",
    "app.banks.amountEur": "Сумма (EUR)",
    "app.banks.startPayment": "Начать платёж",
    "app.banks.paymentInitiatedSuccess": "Платёж успешно инициирован.",
    "app.banks.paymentIdLabel": "ID платежа: {id}",
    "app.banks.transactionsProcessed":
        "{count, plural, one {# транзакция обработана} few {# транзакции обработано} many {# транзакций обработано} other {# транзакций обработано}}",
    "app.banks.transactionsTimeframe": "Период с {from} по {to}",
    "app.banks.findDmsDocument": "Найти DMS документ",
    "app.banks.findAndFillContact": "Найти и заполнить контакт (имя, IBAN)",
    "app.banks.contactSuggestions.button": "Предложить контакты из базовых данных",
    "app.banks.contactSuggestions.scopeHint": "Для выбранных транзакций, без выбора для всех транзакций без контакта.",
    "app.banks.contactSuggestions.title":
        "{count, plural, one {Предложить # контакт из базовых данных} few {Предложить # контакта из базовых данных} other {Предложить # контактов из базовых данных}}",
    "app.banks.contactSuggestions.description":
        "IBAN этих транзакций в базовых данных USt-IdNr. принадлежит ровно одной компании. Отмеченные контакты будут созданы и связаны с их транзакциями.",
    "app.banks.contactSuggestions.transactions":
        "{count, plural, one {# транзакция} few {# транзакции} other {# транзакций}}",
    "app.banks.contactSuggestions.confirm": "Создать контакты",
    "app.banks.contactSuggestions.empty": "Предложений контактов из базовых данных не найдено.",
    "app.banks.contactSuggestions.loadError": "Ошибка загрузки предложений контактов: {error}",
    "app.banks.contactSuggestions.saving": "Контакты создаются",
    "app.banks.contactSuggestions.saveError": "Ошибка создания контактов: {error}",
    "app.banks.contactSuggestions.created":
        "{count, plural, one {# контакт создан} few {# контакта создано} other {# контактов создано}}",
    "app.banks.contactSuggestions.existing": "{count} уже существует",
    "app.banks.contactSuggestions.unavailable": "{count} больше недоступно",
    "app.banks.contactSuggestions.nothing": "Контакты не созданы",
    "app.banks.fibuExportTooltip": "Создать записи в банке FIBU <b>{name} ({accountNum})</b>",
    "app.banks.bookings": "Проводки",
    "app.banks.contactMatched": "сопоставлено с контактом",
    "app.banks.contactMismatch": "не совпадает с контактом",
    "app.banks.finapiTransactionNotDeletable": "Транзакции, импортированные из банка через FinAPI, нельзя удалить",
    "app.banks.bankUndefined": "Банк не определён",
    "app.banks.closeTransactionImport": "Закрыть импорт транзакций",
    "app.banks.hideExistingTransactions": "Скрыть существующие транзакции",
    "app.banks.transactionsRecognized": "Банковские транзакции успешно распознаны",
    "app.banks.goToTransactionData": "Перейти к данным транзакций",
    "app.contacts.basicInformation": "Основная информация",
    "app.contacts.markAsInvoiceAddress": "Отметить как адрес для счетов",
    "app.contacts.commercialRegister": "Торговый реестр",
    "app.contacts.personalIdNr": "Личный налоговый номер",
    "app.contacts.idNrIndividualOnly": "доступно только для типа «физическое лицо»",
    "app.contacts.clearFilters": "Сбросить фильтры",
    "app.contacts.errorSaving": "Ошибка при сохранении контакта",
    "app.contacts.noWritePermission": "У вас нет прав на сохранение.",
    "app.contacts.errorSearching": "Ошибка при поиске контактов",
    "app.contacts.searchTerm": "Поисковый запрос",
    "app.contacts.searchPlaceholder": "Имя, IBAN, ИНН плательщика НДС, налоговый номер...",
    "app.dms.aiLog.title": "Журнал ИИ · {fileName}",
    "app.dms.aiLog.extractionFailed": "Извлечение данных ИИ не удалось",
    "app.dms.aiLog.loadError": "Ошибка загрузки журнала ИИ: {error}",
    "app.dms.aiLog.empty": "Журнал ИИ для этого документа отсутствует.",
    "app.dms.aiLog.copyJson": "Скопировать JSON",
    "app.dms.ibanCheck.unknownIbans": "IBAN не указан у контакта",
    "app.dms.markdown.title": "Распознанный текст: {fileName}",
    "app.dms.markdown.tab.rendered": "Просмотр",
    "app.dms.markdown.tab.raw": "Raw",
    "app.dms.markdown.copy": "Копировать текст",
    "app.dms.markdown.empty": "Текст отсутствует",
    "app.dms.markdown.loadError": "Ошибка загрузки: {error}",
    "app.dms.markdown.tabs.label": "Просмотр Markdown",
    "app.dms.markdown.search": "Поиск по тексту",
    "app.dms.markdown.search.next": "Следующее совпадение",
    "app.dms.markdown.search.previous": "Предыдущее совпадение",
    "app.dms.markdown.search.matches": "{current} из {total}",
    "app.dms.markdown.search.noMatches": "Совпадений нет",
    "app.dms.markdown.search.hint": "Введите минимум 2 символа",
    "app.dms.markdown.breakdown.title": "Расшифровка ИИ",
    "app.dms.markdown.breakdown.loading": "Загрузка расшифровки ИИ",
    "app.dms.markdown.breakdown.error": "Не удалось загрузить расшифровку ИИ",
    "app.dms.markdown.breakdown.empty": "Данные ИИ отсутствуют",
    "app.dms.markdown.breakdown.metroApplied": "Разбивка Metro по категориям",
    "app.dms.markdown.breakdown.checks": "Проверки {passed}/{total}",
    "app.dms.markdown.breakdown.passed": "Пройдена",
    "app.dms.markdown.breakdown.failed": "Не пройдена",
    "app.dms.markdown.breakdown.lines":
        "{count, plural, one {# позиция} few {# позиции} many {# позиций} other {# позиции}}",
    "app.dms.markdown.breakdown.net": "Нетто",
    "app.dms.markdown.breakdown.tax": "НДС",
    "app.dms.markdown.breakdown.gross": "Брутто",
    "app.dms.markdown.breakdown.expected": "Ожидалось",
    "app.dms.markdown.breakdown.actual": "Фактически",
    "app.dms.aiStatus": "Статус ИИ",
    "app.dms.aiStatus.progress": "В обработке",
    "app.dms.aiStatus.success": "Успешно",
    "app.dms.aiStatus.error": "Ошибка",
    "app.dms.documentsEdited": "{count, plural, one {# документ отредактирован} other {# документов отредактировано}}",
    "app.dms.amountMode.input": "Ввод",
    "app.dms.amountMode.tooltipInput": "Ввод: введённая сумма записывается во все выбранные документы.",
    "app.dms.amountMode.tooltipSign":
        "Приход / Расход: каждый документ сохраняет свою сумму, меняется только знак в соответствии с папкой.",
    "app.dms.amountMode.tooltipSkipped":
        "Документы без суммы, вложения и документы вне бухгалтерских папок не изменяются.",
    "app.dms.tagFieldHint.title": "Это поле можно редактировать только когда:",
    "app.dms.tagFieldHint.condition1": "1. дата не пуста и",
    "app.dms.tagFieldHint.condition2": "2. существует бухгалтерская конфигурация для года этой даты.",
    "app.dms.upload.alreadyExisting": "Уже существуют, повторно не загружены: {count}",
    "app.dms.fileInfo.documentType": "Тип документа",
    "app.dms.fileInfo.uploadedAt": "Загружено",
    "app.dms.upload.unsupportedFiles": "Неподдерживаемые файлы: {count}",
    "app.dms.upload.errorLabel": "Ошибка: {error}",
    "app.dms.upload.success":
        "{count, plural, one {# документ загружен} few {# документа загружено} many {# документов загружено} other {# документа загружено}}",
    "app.dms.upload.failed":
        "{count, plural, one {# файл не удалось загрузить} few {# файла не удалось загрузить} many {# файлов не удалось загрузить} other {# файла не удалось загрузить}}",
    "app.dms.payments.createGroup": "Создать групповой платёж",
    "app.dms.fileNameOriginal": "Оригинал",
    "app.dms.fileNameExport": "Экспорт",
    "app.dms.avis.createdAt": "Создано",
    "app.dms.avis.documentsCount": "Документы ({count})",
    "app.dms.contactsCreated": "Контакты созданы.",
    "app.dms.noContactsCreated": "Контакты не созданы.",
    "app.dms.contacts.create": "Создать контакты",
    "app.dms.contacts.create.desc": "Контакты будут созданы по данным выбранных документов.",
    "app.dms.contacts.fill": "Заполнить контакт",
    "app.dms.contacts.fill.desc": "С помощью данных ИИ мы заполним подходящий контакт в выбранных документах.",
    "app.dms.contacts.filled": "{count} документ(ов) связано с контактом.",
    "app.dms.contacts.noneFilled": "Подходящие контакты для выбранных документов не найдены.",
    "app.dms.duplicates.title": "Проверка двойных записей",
    "app.dms.duplicates.tooltip":
        "Проверка двойных записей в выборе: список фильтруется по выбранным документам с одинаковым номером счёта и одинаковой суммой. Нажмите ещё раз, чтобы снять фильтр.",
    "app.dms.duplicates.none": "Дубликаты в выборе не найдены.",
    "app.dms.duplicates.found":
        "{groups, plural, one {# группа} few {# группы} other {# групп}} ({documents, plural, one {# документ} few {# документа} other {# документов}})",
    "app.dms.pdfAi.maxDocs":
        "Binale PDF AI обрабатывает не более {max} документов за один запуск. Сейчас выбрано {selected}.",
    "app.dms.pdfAi.normal": "Обычная обработка",
    "app.dms.pdfAi.normal.desc": "Обрабатывает только документы, которые ИИ ещё не обработал.",
    "app.dms.pdfAi.force": "Принудительная обработка",
    "app.dms.pdfAi.force.desc":
        "Повторно запускает ИИ для уже обработанных документов, расходует лимит ИИ, не более {max} документов.",
    "app.domain.skrLoading": "Загрузка данных... {progress}%",
    "app.domain.skrLoaded": "Данные SKR загружены",
    "app.domain.userDataLoading": "Загрузка данных пользователя…",
    "app.domain.simultaneousLogin.title": "Обнаружен одновременный вход",
    "app.domain.simultaneousLogin.heading": "Кто-то вошёл в систему с вашими учётными данными",
    "app.domain.simultaneousLogin.body":
        "К сожалению, невозможно работать на нескольких компьютерах с одними и теми же учётными данными. Вы будете выведены из системы через 5 секунд.",
    "app.domain.simultaneousLogin.device": "Новый вход с устройства: {device}",
    "app.domain.sessionRevoked.title": "Сеанс завершён",
    "app.domain.sessionRevoked.heading": "Вы завершили этот сеанс",
    "app.domain.sessionRevoked.body": "Выход из системы через 5 секунд.",
    "app.profile.sessions.title": "Активные сеансы",
    "app.profile.sessions.current": "Текущий сеанс",
    "app.profile.sessions.description":
        "Сеансы браузеров для этой учётной записи. Закрытые браузеры исчезают из списка сами.",
    "app.profile.sessions.singleSession": "Автоматически завершать другие сеансы",
    "app.profile.sessions.singleSession.hint":
        "Когда опция включена, каждый вход завершает все остальные сеансы этой учётной записи.",
    "app.profile.sessions.since": "Вход выполнен",
    "app.profile.sessions.end": "Завершить",
    "app.profile.sessions.end.confirm": "Завершить этот сеанс?",
    "app.profile.sessions.empty": "Других сеансов нет.",
    "app.domain.recordUpdated.title": "Запись обновлена",
    "app.domain.recordUpdated.body": "В запись было внесено {count} изменений из прикреплённого документа",
    "app.domain.debitorName": "Наименование дебитора",
    "app.invoice.saveCustomerAsContact": "Сохранить данные клиента как контакт",
    "app.invoice.completed": "Завершено",
    "app.invoice.example": "Пример",
    "app.invoice.finalize": "Завершить",
    "app.invoice.template": "Шаблон",
    "app.invoice.plusVat": "плюс НДС {rate}% ( {amount} )",
    "app.invoice.numberFormat": "Формат номера",
    "app.invoice.invalidCharacters": "Недопустимые символы",
    "app.invoice.prefix": "Префикс",
    "app.invoice.numberLength": "Длина номера",
    "app.invoice.startNumber": "Начальный номер",
    "app.invoice.maxValue": "Макс. {max}",
    "app.invoice.suffix": "Суффикс",
    "app.invoice.formats": "Форматы",
    "app.invoice.lineItemTemplates": "Шаблоны позиций",
    "app.invoice.paymentTemplates": "Шаблоны условий оплаты",
    "app.invoice.pdfWithERechnung": "PDF с E-Rechnung (ZUGFeRD 2.4 / Factur-X)",
    "app.pdf.stats.pages": "Количество страниц",
    "app.pdf.stats.title": "Статистика OCR",
    "app.pdf.ocrOptions": "Параметры OCR",
    "app.pdf.skipQrCheck": "Считать нечитаемые QR-коды разделителями",
    "app.pdf.selectDocument": "Выбрать документ {name}",
    "app.pdf.toast.decodedEncrypted": "Зашифрованный файл расшифрован",
    "app.pdf.viewer.search": "Поиск в документе",
    "app.pdf.viewer.search.next": "Следующее совпадение",
    "app.pdf.viewer.search.previous": "Предыдущее совпадение",
    "app.pdf.viewer.search.matches": "{current} из {total}",
    "app.pdf.viewer.search.noMatches": "Совпадений нет",
    "app.pdf.viewer.search.close": "Закрыть поиск",
    "app.pdf.viewer.search.unavailable": "В этом документе нет текстового слоя",
    "app.components.selectAccount": "Выбрать счёт",
    "app.components.xrechnung.formatDeprecated": "Внимание, этот формат устарел!",
    "app.components.xrechnung.email": "Эл. почта",
    "app.components.xrechnung.paymentDetails": "Платёжные реквизиты",
    "app.components.xrechnung.paymentMethodNotSpecified": "Способ оплаты не указан",
    "app.components.xrechnung.dueDate": "Срок оплаты",
    "app.components.xrechnung.invoiceLines": "Позиции счёта",
    "app.components.xrechnung.bookingLines": "Позиции проводки",
    "app.components.xrechnung.rule": "Правило",
    "app.components.xrechnung.location": "Расположение",
    "app.components.xrechnung.hasErrors": "Электронный счёт содержит ошибки или предупреждения",
    "app.components.xrechnung.validating": "Проверка...",
    "app.components.xrechnung.isValid": "Электронный счёт действителен",
    "app.components.xrechnung.showXml": "Показать XML электронного счёта",
    "app.components.xrechnung.xmlTitle": "XML электронного счёта",
    // --- intl accounting migration ---
    "app.fields.period": "Период",
    "app.button.ok": "OK",
    "app.columns.column2": "Столбец 2",
    "app.columns.column3": "Столбец 3",
    "app.dms.copyFailed": "Не удалось скопировать",
    "app.dms.cashRegister.export": "Перенести в кассу",
    "app.dms.cashRegister.exportConfirm":
        "{count, plural, one {# документ будет создан} few {# документа будут созданы} other {# документов будут созданы}} как кассовые операции в <b>{name}</b>.",
    "app.dms.datev.export": "Отправить выбранные документы в DATEV",
    "app.dms.datev.exportTooltip": "Выбранные документы группируются по месяцу и отправляются в DATEV.",
    "app.dms.datev.notConnected": "Для экспорта требуется активное подключение DATEV.",
    "app.dms.datev.missingDocumentDate": "У всех выбранных документов должна быть указана дата.",
    "app.dms.datev.result": "Экспорт DATEV: загружено {uploaded}, уже существовало {exists}, с ошибкой {failed}.",
    "app.dms.datev.error": "Не удалось отправить документы в DATEV.",
    "app.dms.autoSort.button": "Автосортировка",
    "app.dms.autoSort.failed": "Автосортировка не удалась",
    "app.dms.autoSort.summaryTitle":
        "{moved, plural, =0 {Документы не отсортированы} one {Отсортирован # документ} few {Отсортировано # документа} many {Отсортировано # документов} other {Отсортировано # документа}}",
    "app.dms.autoSort.summaryDescription":
        "Входящие счета: {er} · Исходящие счета: {deb} · Банк: {bank} (связано с транзакцией: {linked}) · Касса: {kb} · осталось в новых документах: {remaining}{skipped, plural, =0 {} other { · пропущено: #}}{failed, plural, =0 {} other { · с ошибкой: #}}",
    "app.dms.bewirtung.title": "Представительские расходы (Bewirtungsbeleg)",
    "app.dms.bewirtung.kind.business": "Деловое угощение",
    "app.dms.bewirtung.kind.employees": "Только сотрудники",
    "app.dms.bewirtung.date": "Дата угощения",
    "app.dms.bewirtung.place": "Место (ресторан, адрес)",
    "app.dms.bewirtung.participants": "Приглашённые лица (по одному на строку, включая принимающую сторону)",
    "app.dms.bewirtung.occasion": "Повод угощения",
    "app.dms.bewirtung.amount": "Сумма расходов",
    "app.dms.bewirtung.tip": "Чаевые",
    "app.dms.bewirtung.host": "Принимающая сторона",
    "app.dms.bewirtung.confirmed": "Подтверждено: {user}, {date}",
    "app.dms.bewirtung.confirmedOn": "Подтверждено {date}",
    "app.dms.bewirtung.save": "Сохранить",
    "app.dms.bewirtung.occasionRequired": "Укажите конкретный повод",
    "app.dms.bewirtung.create": "Создать чек представительских расходов",
    "app.dms.bewirtung.edit": "Изменить",
    "app.dms.bewirtung.staleNotice":
        "Чек представительских расходов тем временем изменён. Для сохранения обновите его.",
    "app.dms.bewirtung.reload": "Обновить",
    "app.dms.bewirtung.saveFailed": "Не удалось сохранить чек представительских расходов",
    "app.dms.bewirtung.removeFailed": "Не удалось удалить чек представительских расходов",
    "app.dms.bewirtung.removeConfirm": "Действительно удалить чек представительских расходов?",
    "app.dms.bewirtung.discardUnsaved": "Отменить несохранённые изменения в чеке представительских расходов?",
    "app.dms.bewirtung.discardConfirm": "Отменить изменения",
    "app.dms.bewirtung.remove": "Удалить чек представительских расходов",
    "app.dms.bewirtung.aiLoadFailed": "Не удалось загрузить данные ИИ",
    "app.dms.bewirtung.virtualSigned": "Подписан",
    "app.dms.bewirtung.virtualUnsigned": "Не подписан",
    "app.dms.bewirtung.virtualAria": "Показать Bewirtungsbeleg ({state})",
    "app.dms.bewirtung.virtualHint": "Создан из данных Bewirtung этого документа",
    "app.dms.bewirtung.viewPdf": "Открыть PDF",
    "app.dms.bewirtung.viewPdfLocked": "Открыть подписанный Bewirtungsbeleg в PDF",
    "app.dms.bewirtung.pdfFailed": "Не удалось создать PDF",
    "app.dms.bewirtung.column": "BW",
    "app.dms.bewirtung.amountHint":
        "Чек должен быть напечатан кассой и защищён сертифицированным модулем (TSE). При сумме свыше 250 € брутто в счёте также должны быть имя приглашающего как получателя счёта, налоговый номер или USt-IdNr. ресторана и последовательный номер счёта (письмо BMF от 19.11.2025).",
    "app.dms.bewirtung.hostHint":
        "Имя приглашающего лица, например «Max Muster (управляющий Muster GmbH)», не адрес электронной почты. В счетах свыше 250 € это имя должно быть указано в счёте.",
    "app.dms.bewirtung.missingHint":
        "Этот документ похож на представительские расходы. Для вычета расходов своевременно укажите повод и участников (§ 4 абз. 5 № 2 EStG).",
    "app.dms.bewirtung.sign": "Подписать и зафиксировать",
    "app.dms.bewirtung.signConfirm":
        "Вы подписываете как {name}. После подписания Bewirtungsbeleg фиксируется и больше не может быть изменён или удалён.",
    "app.dms.bewirtung.signConfirmButton": "Подписать",
    "app.dms.bewirtung.signed": "Bewirtungsbeleg подписан и зафиксирован",
    "app.dms.bewirtung.signFailed": "Не удалось подписать",
    "app.dms.bewirtung.alreadyLocked": "Bewirtungsbeleg уже подписан и зафиксирован",
    "app.dms.bewirtung.lockedBy": "Подписано и зафиксировано: {user}, {date}",
    "app.dms.bewirtung.lockedOn": "Подписано и зафиксировано {date}",
    "app.dms.bewirtung.signatureChecking": "Проверка подписи …",
    "app.dms.bewirtung.signatureValid": "Подпись действительна: содержание не менялось после фиксации",
    "app.dms.bewirtung.signatureInvalid": "Подпись недействительна: содержание не совпадает с подписанной версией",
    "app.dms.bewirtung.signatureUnavailable": "Не удалось проверить подпись",
    "app.dms.sortAssistant.title": "Помощник сортировки",
    "app.dms.sortAssistant.progress": "Шаг {current} из {total}",
    "app.dms.sortAssistant.showDocument": "Показать документ",
    "app.dms.sortAssistant.hideDocument": "Скрыть документ",
    "app.dms.sortAssistant.skip": "Пропустить",
    "app.dms.sortAssistant.close": "Закрыть помощника",
    "app.dms.sortAssistant.bewirtungQuestion": "Что это было?",
    "app.dms.sortAssistant.noBewirtung": "Не деловое угощение (поездка, личное)",
    "app.dms.sortAssistant.bankPickQuestion": "К какой транзакции относится документ?",
    "app.dms.sortAssistant.noneOfThem": "Ни одна из них",
    "app.dms.sortAssistant.whereQuestion": "Куда относится документ?",
    "app.dms.sortAssistant.toKasse": "Касса",
    "app.dms.sortAssistant.toBank": "Банк без транзакции",
    "app.dms.sortAssistant.toEr": "Входящие счета",
    "app.dms.sortAssistant.stay": "Оставить в новых документах",
    "app.dms.fibu.export.title": "Экспорт в ФИБУ",
    "app.dms.fibu.export.disabled.not_accounting_type": "Это не бухгалтерский документ.",
    "app.dms.fibu.export.disabled.too_many_documents": "Выбрано слишком много документов (макс. 200).",
    "app.dms.fibu.export.disabled.mixed_types": "Пожалуйста, выбирайте документы только одного типа.",
    "app.dms.fibu.export.disabled.no_type": "Тип документа не определён.",
    "app.dms.fibu.export.disabled.documents_not_ready": "Не все документы заполнены (статус: черновик).",
    "app.dms.fibu.export.disabled.no_group_id": "Сначала выберите счёт (банк или касса).",
    "app.dms.fibu.export.disabled.missing_document_date": "У одного или нескольких документов отсутствует дата.",
    "app.dms.fibu.export.disabled.not_a_receipt":
        "Информационный документ, не первичный документ: проводка не создаётся.",
    "app.dms.fibu.export.disabled.year_not_in_accounting_years":
        "Дата документа выходит за пределы настроенных бухгалтерских лет ({years}).",

    "app.mailbox.button": "Импорт с почты",
    "app.mailbox.title": "Подключить почтовый ящик",
    "app.mailbox.description":
        "Подключите почтовый ящик, чтобы автоматически импортировать счета (PDF-вложения) в управление документами каждый час.",
    "app.mailbox.provider": "Провайдер",
    "app.mailbox.provider.imap": "IMAP",
    "app.mailbox.provider.microsoft365": "Microsoft 365",
    "app.mailbox.provider.googleWorkspace": "Google Workspace",
    "app.mailbox.provider.comingSoon": "Скоро",
    "app.mailbox.m365.connect": "Подключить Microsoft 365",
    "app.mailbox.m365.connectedAs": "Подключено как",
    "app.mailbox.m365.reconnect": "Переподключить",
    "app.mailbox.m365.connecting": "Подключение Microsoft 365…",
    "app.mailbox.host": "Сервер (host)",
    "app.mailbox.port": "Порт",
    "app.mailbox.secure": "Защищённое соединение (SSL/TLS)",
    "app.mailbox.username": "Имя пользователя",
    "app.mailbox.folder": "Папка (необязательно)",
    "app.mailbox.folder.placeholder": "INBOX",
    "app.mailbox.password.configured": "Пароль сохранён",
    "app.mailbox.password.change": "Изменить пароль",
    "app.mailbox.password.new": "Новый пароль",
    "app.mailbox.enabled": "Автоматический импорт включён",
    "app.mailbox.testConnection": "Проверить соединение",
    "app.mailbox.testSuccess": "Соединение успешно установлено",
    "app.mailbox.testFailed": "Не удалось установить соединение",
    "app.mailbox.status.title": "Статус",
    "app.mailbox.status.connection": "Статус соединения",
    "app.mailbox.status.lastPolled": "Последний опрос",
    "app.mailbox.status.neverPolled": "ещё не опрашивался",
    "app.mailbox.status.lastError": "Последняя ошибка",
    "app.mailbox.status.untested": "Не проверено",
    "app.mailbox.status.ok": "OK",
    "app.mailbox.status.error": "Ошибка",
    "app.mailbox.delete": "Удалить конфигурацию",
    "app.mailbox.delete.confirm": "Вы действительно хотите удалить конфигурацию почтового ящика?",
    "app.mailbox.template": "Шаблон",
    "app.mailbox.template.custom": "Вручную",
    "app.mailbox.template.gmail": "Gmail",
    "app.mailbox.template.yahoo": "Yahoo",
    "app.mailbox.template.gmx": "GMX",
    "app.mailbox.template.webde": "WEB.DE",
    "app.mailbox.template.aol": "AOL",
    "app.mailbox.hint.openGuide": "Открыть инструкцию",
    "app.mailbox.hint.gmail":
        "Gmail требует двухфакторной аутентификации и пароля приложения - обычный пароль для IMAP не подойдёт. Включите 2FA в аккаунте Google, создайте пароль приложения и введите его здесь.",
    "app.mailbox.hint.yahoo":
        "Yahoo требует пароль приложения. Войдите в раздел безопасности аккаунта Yahoo, выберите «Создать пароль приложения», задайте имя (например, Binale) и введите полученный пароль здесь.",
    "app.mailbox.hint.aol":
        "AOL требует пароль приложения. Создайте пароль приложения в настройках безопасности AOL и введите его здесь.",
    "app.mailbox.hint.gmx":
        "Для GMX необходимо сначала включить доступ по IMAP в настройках почтового ящика. Затем используйте полный адрес GMX и обычный пароль от почты.",
    "app.mailbox.hint.webde":
        "Для WEB.DE необходимо сначала включить доступ по IMAP в настройках почтового ящика. Затем используйте полный адрес WEB.DE и обычный пароль от почты.",

    "app.fields.drag": "Перетащить",
    "app.invoicing.lineItemTemplate": "Шаблон",
    "app.titles.banks": "Банки",
    "app.titles.buchungen": "Проводки",
    "app.titles.cashRegisters": "Кассы",
    "app.titles.invoicing": "Счета",
    "app.validation.pattern": "Неверный формат",
    "app.validation.required": "Обязательное поле",
    "app.datev.configTitle": "Конфигурация DATEV",
    "app.datev.group": "Группа",
    "app.datev.exportOptions": "Параметры экспорта",
    "app.datev.exportTabs": "Вкладки экспорта",
    "app.datev.exportResults": "Результаты экспорта DATEV",
    "app.datev.exportDocuments": "Экспортировать документы",
    "app.datev.exportBelegfeld2": "Экспортировать Belegfeld2",
    "app.datev.exportKostenstelle": "Экспортировать место возникновения затрат",
    "app.datev.transferDocuments": "Передавать документы",
    "app.datev.exportFormatMonthly": "Экспорт в формате DATEV (помесячно)",
    "app.datev.exportFormatCombined": "Экспорт в формате DATEV (периоды объединены)",
    "app.datev.sendToDatev": "Отправить в DATEV (сервис учётных данных)",
    "app.datev.documentsTitle": "Документы DATEV",
    "app.datev.step1DocumentTable": "1. Таблица документов DATEV CSV",
    "app.datev.step2DocumentsZip": "2. Документы ZIP",
    "app.datev.step3Download": "3. {label}",
    "app.datev.missingFilesInZip": "Отсутствующие файлы в ZIP",
    "app.datev.invalidAmount": "неверная сумма",
    "app.datev.errorColumnCount": "Все строки должны содержать 40-{max} столбцов",
    "app.datev.errorPeriodDecode": "Распознан неверный период: {period}, допустимые значения [1, 12]",
    "app.datev.documentsAttached": "Прикреплено {attached} из {total} документов",
    "app.datev.unattachedDocuments": "{count} непривязанных документов также будут импортированы",
    "app.datev.creditorsToCreate": "Кредиторы для создания при сохранении: {list}",
    "app.datev.debitorsToCreate": "Дебиторы для создания при сохранении: {list}",
    "app.datev.categoriesToCreate": "Счета для создания при сохранении: {list}",
    "app.datev.missingKostenstelle": "Отсутствует место возникновения затрат: {list}",
    "app.datev.missingBanks": "Отсутствуют банки: {list}",
    "app.datev.missingKassen": "Отсутствуют кассы: {list}",
    "app.datev.annotation": "Примечание",
    "app.datev.unassignedGroup": "Без банка/кассы",
    "app.datev.importError.missingBank": "Банк {value} не создан - эта строка не может быть импортирована",
    "app.datev.importError.missingKasse": "Касса {value} не создана - эта строка не может быть импортирована",
    "app.datev.selectedForImport": "Выбрано {selected} из {total} проводок для импорта",
    "app.datev.loadingDocuments": "Загрузка документов",
    "app.items.sinceYear": "(с {year})",
    "app.overview.bwa.umsatzerloese": "Выручка",
    "app.overview.bwa.bestandsveraenderung": "Изменение запасов ГП/НП",
    "app.overview.bwa.aktivierteEigenleistungen": "Капитализированные собственные затраты",
    "app.overview.bwa.gesamtleistung": "Совокупный объём",
    "app.overview.bwa.materialWareneinkauf": "Закупка материалов/товаров",
    "app.overview.bwa.rohertrag": "Валовая прибыль",
    "app.overview.bwa.sonstigeBetrieblicheErloese": "Прочие операционные доходы",
    "app.overview.bwa.betrieblicherRohertrag": "Операционная валовая прибыль",
    "app.overview.bwa.personalkosten": "Расходы на персонал",
    "app.overview.bwa.raumkosten": "Расходы на помещения",
    "app.overview.bwa.betrieblicheSteuern": "Операционные налоги",
    "app.overview.bwa.versicherungenBeitraegeAbgaben": "Страхование, взносы и сборы",
    "app.overview.bwa.besondereKosten": "Особые расходы",
    "app.overview.bwa.fahrzeugkosten": "Расходы на транспорт (без налога)",
    "app.overview.bwa.werbeReisekosten": "Расходы на рекламу и командировки",
    "app.overview.bwa.kostenWarenabgabe": "Расходы на отгрузку товаров",
    "app.overview.bwa.abschreibungen": "Амортизация",
    "app.overview.bwa.reparaturenInstandhaltungen": "Ремонт и техническое обслуживание",
    "app.overview.bwa.sonstigeKosten": "Прочие расходы",
    "app.overview.bwa.gesamtkosten": "Совокупные расходы",
    "app.overview.bwa.betriebsergebnis": "Операционный результат",
    "app.overview.bwa.zinsaufwendungen": "Процентные расходы",
    "app.overview.bwa.sonstigerNeutralerAufwand": "Прочие нейтральные расходы",
    "app.overview.bwa.neutralerAufwand": "Нейтральные расходы",
    "app.overview.bwa.zinsertraege": "Процентные доходы",
    "app.overview.bwa.sonstigerNeutralerErtrag": "Прочие нейтральные доходы",
    "app.overview.bwa.verrechneteKalkKosten": "Распределённые расчётные расходы",
    "app.overview.bwa.neutralerErtrag": "Нейтральные доходы",
    "app.overview.bwa.kontenklasseUnbesetzt": "Нераспределённые счета",
    "app.overview.bwa.ergebnisVorSteuern": "Результат до налогообложения",
    "app.overview.bwa.steuernEinkommenErtrag": "Налоги на доход и прибыль",
    "app.overview.bwa.vorlaeufigesErgebnis": "Предварительный результат",
    "app.overview.bwa.footerSelected": "Сумма выбранных",
    "app.overview.bwa.pdf.title": "Экономический анализ (BWA)",
    "app.overview.bwa.pdf.berichtsposition": "Позиция отчёта",
    "app.overview.bwa.pdf.unit": "Значения в EUR",
    "app.overview.bwa.pdf.range": "{from} - {to}",
    "app.overview.bwa.pdf.quarter": "{n}-й квартал {year}",
    "app.overview.bwa.pdf.saldenvortrag": "01.01.{year} (входящее сальдо)",
    "app.overview.bwa.pdf.abschluss": "31.12.{year} (заключительные проводки)",
    "app.overview.bwa.pdf.created": "Создано {date} в Binale-Buchhaltung (версия {version})",
    "app.overview.bwa.pdf.createdOn": "Создано {date}",
    "app.overview.bwa.pdf.disclaimer": "Предварительный результат отражает текущее состояние бухгалтерского учёта.",
    "app.overview.bwa.pdf.page": "Страница {page} из {total}",
    "app.overview.reconciliation.startPrompt": "Нажмите OK для запуска (всего {count})",
    "app.overview.reconciliation.manual.title": "Ручное связывание",
    "app.overview.reconciliation.manual.approvalNeeded":
        "Затронута закреплённая или подтверждённая проводка. Свяжите её в таблице и подтвердите там.",
    "app.overview.reconciliation.manual.body":
        "{count, plural, =1 {2 выбранные записи будут связаны платежом.} other {Счёт будет связан с репрезентациями платежа (#), по одному платежу на каждую.}}",
    "app.overview.reconciliation.tooltip.auto":
        "Автоматически (по умолчанию): число на кнопке показывает количество репрезентаций платежа (банк, касса, свободный ввод), для которых есть предложение. Предложение появляется, если:",
    "app.overview.reconciliation.tooltip.select":
        "Кнопка «Выделить» на вкладке «Быстро» выделяет в таблице все записи этих предложений.",
    "app.overview.reconciliation.tooltip.manual":
        "Вручную: если выделены репрезентация платежа и ровно один счёт, кнопка становится красной и после подтверждения связывает эту пару - без проверки суммы, так как выбор сделан осознанно. Условия:",
    "app.overview.reconciliation.tooltip.split":
        "Несколько счетов: если к одной репрезентации платежа выделено несколько счетов, репрезентация разделяется на строки по одной на счёт, а исходная строка удаляется. Дополнительно требуется:",
    "app.overview.reconciliation.split.title": "Разделить платёж",
    "app.overview.reconciliation.split.body":
        "Репрезентация платежа будет разделена на {count} строк - по одной на счёт, - а исходная строка удалена.",
    "app.overview.reconciliation.tooltip.multi":
        "Несколько репрезентаций платежа: если к одному счёту выделено несколько репрезентаций платежа, каждая связывается со счётом отдельным платежом. Дополнительно требуется:",
    "app.overview.reconciliation.tooltip.mixed":
        "Несколько счетов вместе с несколькими репрезентациями платежа нельзя связать вручную.",
    "app.overview.reconciliation.criteria.selectedSumEqualsOpen":
        "сумма выделенных репрезентаций платежа точно равна открытой сумме счёта",
    "app.overview.reconciliation.criteria.sumEqualsBrutto":
        "сумма открытых сумм точно равна сумме репрезентации платежа",
    "app.overview.reconciliation.criteria.singleItemNotJournaled":
        "у репрезентации платежа одна позиция и она не зафиксирована (Festschreibung)",
    "app.overview.reconciliation.criteria.unbound": "репрезентация платежа ещё не связана",
    "app.overview.reconciliation.criteria.matchingSource": "найден подходящий счёт (ER, авансовый, дебиторский)",
    "app.overview.reconciliation.criteria.sumEqualsOpen":
        "сумма всех связанных репрезентаций платежа точно равна открытой сумме счёта",
    "app.overview.reconciliation.criteria.pairSelection":
        "ровно один счёт (ER, авансовый, дебиторский) и одна репрезентация платежа",
    "app.overview.reconciliation.criteria.sourceOpen": "у счёта ещё есть открытая сумма",
    "app.overview.reconciliation.tab.quick": "Быстро",
    "app.overview.reconciliation.tab.advanced": "Расширенно",
    "app.overview.reconciliation.quick.criteria": "Номер счёта ↔ Belegfeld1",
    "app.overview.reconciliation.summary":
        "{payments, plural, one {# платёжная запись} few {# платёжные записи} other {# платёжных записей}} для {invoices, plural, one {# счёта} other {# счетов}}",
    "app.overview.reconciliation.select": "Выделить",
    "app.overview.reconciliation.connect": "Связать",
    "app.overview.reconciliation.key.label": "Связывать по",
    "app.overview.reconciliation.key.belegfeld1": "Belegfeld1",
    "app.overview.reconciliation.key.belegfeld2": "Belegfeld2",
    "app.overview.reconciliation.advanced.hint":
        "Связь создаётся, если ровно один открытый счёт и платёжные записи с тем же значением на том же счёте точно закрывают открытую сумму.",
    "app.overview.reconciliation.skipped.title":
        "{count, plural, one {# группа пропущена} few {# группы пропущены} other {# групп пропущено}}",
    "app.overview.reconciliation.skipped.multipleSources": "{count} открытых счёта с этим значением",
    "app.overview.reconciliation.skipped.noSource": "нет открытого счёта с этим значением",
    "app.overview.reconciliation.skipped.sumMismatch": "Разница {diff} €",
    "app.overview.reconciliation.advanced.prompt":
        "Будет связано: {payments} платёжных записей с {invoices} счетами. Нажмите OK для запуска.",
    "app.overview.reconciliation.outcome.applied": "Связано счетов: {count}",
    "app.overview.reconciliation.outcome.changed": "Изменились после предпросмотра и не связаны: {count}",
    "app.overview.reconciliation.outcome.alreadyApplied": "Уже были связаны: {count}",
    "app.overview.reconciliation.outcome.failed": "Ошибок: {count}: {message}",
    "app.overview.reconciliation.tooltip.advanced":
        "Расширенно: счёт и платёжные записи группируются по выбранному полю (Belegfeld1, Belegfeld2, Zusatz-Info). Группы без точного совпадения показываются с причиной.",
    "app.accounting.buInsteadOfUst": "BU вместо USt",
    "app.accounting.useCurrency": "Использовать валюту",
    "app.accounting.moreFields": "Дополнительные поля",
    "app.accounting.datev.openInCompanyList": "Открыть в списке компаний",
    "app.accounting.datev.noBuchungsdatenservice": "В этой компании не активирован Buchungsdatenservice",
    "app.accounting.datev.searchByIdOrName": "Поиск по ID или имени",
    "app.accounting.datev.filterService": "Фильтр по сервису",
    "app.accounting.datev.expired": "Истёк",
    "app.accounting.datev.connectedAt": "Подключено",
    "app.accounting.datev.verifyWithDatev": "Проверить через Datev",
    "app.accounting.datev.connectedApps": "Подключённые приложения",
    "app.accounting.sinceYear": "С (год)",
    "app.accounting.searchPlaceholder": "Поиск...",
    "app.accounting.verrechnung.available": "Доступно",
    "app.accounting.verrechnung.connectionInfo": "Есть записи, которые можно привязать к этому платежу",
    "app.accounting.verrechnung.ignore": "Игнорировать",
    "app.accounting.verrechnung.assign": "Привязать",
    "app.accounting.remainingAmount": "Остаток",
    "app.accounting.paymentDate": "Дата платежа",
    "app.accounting.records": "Записи",
    "app.accounting.noPaymentsYet": "Платежей пока нет",
    "app.accounting.paymentList": "Платежный лист",
    "app.accounting.dueDates": "Сроки оплаты",
    "app.accounting.keyboardShortcuts": "Горячие клавиши",
    "app.accounting.toFirstField": "к первому полю",
    "app.accounting.toLastField": "к последнему полю",
    "app.accounting.recordOrigin.badge": "ИИ",
    "app.accounting.recordOrigin.ai": "Предложение ИИ",
    "app.accounting.recordOrigin.ai.hint": "Черновик проводки создан автоматически из документа.",
    "app.accounting.bruttoNettoMode": "Режим брутто/нетто",
    "app.accounting.doppelerfassungWarning":
        "<b>Внимание! </b>Этот номер счёта уже использовался. Пожалуйста, проверьте на дублирование!",
    "app.accounting.notesStatus.done": "Готово",
    "app.accounting.notesStatus.inProgress": "В работе",
    "app.accounting.notesStatus.task": "Задача",
    "app.notes.trigger": "Открыть заметки",
    "app.notes.placeholder": "Написать заметку",
    "app.notes.send": "Отправить",
    "app.notes.sendHint": "отправить",
    "app.notes.statusNone": "Без",
    "app.notes.edit": "Изменить заметку",
    "app.notes.delete": "Удалить заметку",
    "app.notes.deleteConfirm": "Удалить заметку?",
    "app.notes.deleteAll": "Удалить все",
    "app.notes.deleteAllConfirm": "Удалить все заметки?",
    "app.notes.deleteAllConfirmDesc": "Вся история будет удалена.",
    "app.notes.emptyTitle": "Заметок пока нет",
    "app.notes.emptyBody": "Напишите первую заметку.",
    "app.notes.emptyReadOnly": "Заметок нет.",
    "app.notes.readOnly": "Только чтение. Заметки нельзя изменить.",
    "app.notes.loadError": "Не удалось загрузить заметки.",
    "app.notes.retry": "Повторить",
    "app.notes.edited": "изменено",
    "app.notes.imported": "Импортировано",
    "app.notes.you": "Вы",
    "app.accounting.notes.unsaved": "Заметки доступны после сохранения проводки.",
    "app.accounting.ok": "Ок",
    "app.accounting.selectContact": "Выбрать контакт",
    "app.accounting.addContactWithName": "Создать контакт с этим именем в модуле «Контакты»",
    "app.accounting.copyTemplatesFromPreviousYear": "Скопировать шаблоны из прошлого года",
    "app.accounting.contactsWithoutTemplates": "Контакты без шаблонов",
    "app.accounting.festschreibenCount": "Зафиксировать ({done}/{total})",
    "app.table.summe": "Сумма:",
    "app.table.modulLabel": "Модуль:",
    "app.table.bankingTransaction": "Банковская транзакция",
    "app.table.bankingTransactionId": "ID банковской транзакции",
    "app.table.cashRegisterReceipt": "Кассовый чек",
    "app.table.cashRegisterReceiptId": "ID кассового чека",
    "app.table.autoRecord": "Автоматическая проводка",
    "app.table.saldoTransferRecord": "Перенос сальдо",
    "app.table.expected": "ожидалось",
    "app.table.actual": "фактически",
    "app.table.avis.remove": "Удалить авизо платежа",
    "app.table.avis.change": "Изменить авизо платежа",
    "app.table.moveToFE": "Переместить в FE",
    "app.table.moveToPOS": "Переместить в POS",
    "app.table.unsplit": "Отменить разделение",
    "app.table.toPeriod0": "В период 0",
    "app.table.toPeriod13": "В период 13",
    "app.table.payment.journaledWarning":
        "Из-за этого изменения платежа некоторые связанные <strong>зафиксированные</strong> записи будут сторнированы.",
    "app.table.payment.confirmedWarning":
        "Из-за этого изменения платежа некоторые связанные <strong>подтверждённые</strong> записи также обновляются и/или удаляются.",
    "app.toolbar.aiImport.importPdf": "Импорт PDF с ИИ",
    "app.toolbar.aiImport.fibuRunning": "AI FIBU выполняется...",
    "app.automation.d2r.running": "Создаются черновики проводок ({done}/{total})",
    "app.automation.d2r.summary":
        "{created} создано, {withoutAccount} без счета, {alreadyBooked} уже проведено, {refused} отклонено, {failed} с ошибкой",
    "app.automation.d2r.failed": "Не удалось завершить операцию.",
    "app.automation.d2r.more": "и еще {count}",
    "app.automation.d2r.reason.DOCUMENT_NOT_FOUND": "Документ не найден",
    "app.automation.d2r.reason.IN_TRASH": "Документ находится в корзине",
    "app.automation.d2r.reason.IN_NEW_DOCUMENTS": "Документ еще в новых документах",
    "app.automation.d2r.reason.MISSING_DOCUMENT_DATE": "Не указана дата документа",
    "app.automation.d2r.reason.MISSING_GROUP": "Не выбран банковский счет или касса",
    "app.automation.d2r.reason.YEAR_NOT_IN_ACCOUNTING_YEARS": "Год документа не входит в учетные годы компании",
    "app.automation.d2r.reason.PRODUCT_NOT_ALLOWED": "Для этого раздела проводки из документов невозможны",
    "app.automation.d2r.reason.MIRROR_SYNC_FAILED": "Проведено, но синхронизация не удалась",
    "app.automation.d2r.reason.CONVERSION_FAILED": "Не удалось прочитать документ",
    "app.automation.d2r.reason.NOT_A_RECEIPT": "Информационный документ, не первичный документ",
    "app.automation.d2r.reason.SAVE_FAILED": "Не удалось сохранить проводку",
    "app.automation.d2r.reason.PERMISSION_DENIED": "Нет прав на запись в этом разделе",
    "app.toolbar.fillBank.unifyTwo.title": "Объединить транзакцию с записями",
    "app.toolbar.fillBank.unifyTwo.description":
        "Объединяет одну запись, экспортированную из транзакции, с одной или несколькими записями, созданными вручную, сумма которых равна транзакции, по следующим критериям:",
    "app.toolbar.fillBank.unifyMultiple.title": "Объединить несколько записей",
    "app.toolbar.fillBank.unifyMultiple.description":
        "Объединяет записи, созданные из транзакций, и записи, созданные вручную с заполненным контактом, по следующим критериям:",
    "app.toolbar.fillBank.connectByDocs.title": "Связать по документам",
    "app.toolbar.fillBank.connectByDocs.description":
        "Связывает выбранные банковские проводки с их исходным счётом (ER, ER_A, Deb) по общим документам по следующим критериям:",
    "app.toolbar.fillBank.connectByDocs.skipNote": "Уже связанные банковские проводки пропускаются.",
    "app.toolbar.fillBank.outcome.matched": "Сопоставлено: {count}",
    "app.toolbar.fillBank.outcome.ambiguous": "Неоднозначно, без изменений: {count}",
    "app.toolbar.fillBank.outcome.ambiguousZuordnung":
        "Неоднозначно, не связано; кредитор/дебитор дополнен при возможности: {count}",
    "app.toolbar.fillBank.outcome.noMatch": "Без совпадений: {count}",
    "app.toolbar.fillBank.outcome.alreadyLinked": "Уже связано: {count}",
    "app.toolbar.fillBank.outcome.journaled": "Зафиксировано, без изменений: {count}",
    "app.toolbar.fillBank.outcome.notFound": "Не найдено: {count}",
    "app.toolbar.fillBank.classification.step1":
        "1. Заполнить кредитора или дебитора из шаблонов в ER или AR на основе <b>контакта</b>",
    "app.toolbar.fillBank.classification.step2":
        "2. Связывает банковские проводки из импорта Banking напрямую с открытым счётом (ER, ER_A, Deb) по следующим критериям:",
    "app.toolbar.fillBank.classification.step3":
        "3. Иначе: объединяет записи, созданные из транзакций, и записи, созданные вручную с заполненным контактом, по следующим критериям:",
    "app.toolbar.fillBank.criteria.sumBetrag": "Сумма записей = сумма транзакции",
    "app.toolbar.fillBank.criteria.invoiceNumInPurpose": "Номер счёта в назначении платежа (Verwendungszweck)",
    "app.toolbar.fillBank.criteria.belegfeld1": "Belegfeld1",
    "app.toolbar.fillBank.criteria.sharedDocument": "Общий документ",
    "app.toolbar.fillBank.criteria.openEqualsBank": "Открытая сумма = сумма банка",
    "app.toolbar.fillBank.criteria.creditorDebitor": "Кредитор/Дебитор",
    "app.toolbar.chainEdit.title": "Цепное редактирование",
    "app.toolbar.chainEdit.description":
        "Сохраняет текущую запись по + и сразу загружает следующую выбранную запись в порядке таблицы.",
    "app.toolbar.chainEdit.completed.title": "Цепное редактирование завершено",
    "app.toolbar.chainEdit.completed.message": "Выбранные проводки полностью обработаны.",
    "app.toolbar.duplicateCheck.title": "Проверка дубликатов",
    "app.toolbar.duplicateCheck.description":
        "Фильтрует выбранные записи с одинаковым номером счета и одинаковой суммой брутто.",
    "app.toolbar.journal.title": "Журнал",
    "app.toolbar.showRemovedRecords": "показать удалённые проводки",
    "app.toolbar.paymentStatus.avis": "Авизо",
    "app.toolbar.ust13b.with": "С § 13b",
    "app.toolbar.ust13b.without": "Без § 13b",
    "app.toolbar.export.csvDescription": "файл с разделителями-запятыми",
    "app.toolbar.export.pdfDescription": "печатный PDF-файл",
    "app.toolbar.actions": "Действия",
    "app.toolbar.actions.saldoDescription": "Перенести остаток прошлого года",
    "app.toolbar.actions.aiReviewDescription": "Проверяет выбранные проводки по данным ИИ связанного документа.",
    "app.toolbar.actions.saldoTransfer": "Перенос остатка",
    "app.toolbar.actions.saldoConfirm": "Перенести остаток {yearFrom} года в {yearTo}?",
    "app.ustva.shortDescription": "Краткое описание",
    "app.ustva.drilldown.kennzahl": "Показатель {route}",
    "app.ustva.drilldown.calculated": "Расчётный показатель. Прямой проводки нет.",
    "app.ustva.drilldown.showBookings": "Показать проводки по показателю {route}, {period}",
    "app.ustva.drilldown.composition.drill": "Разложить показатель {route}",
    "app.ustva.drilldown.composition.subtracted": "вычитается",
    "app.ustva.drilldown.composition.rate": "Ставка налога {rate, number, percent}",
    "app.ustva.drilldown.composition.total": "Итого",
    "app.ustva.drilldown.composition.deltaTotal": "Разница с переданными данными",
    "app.ustva.drilldown.composition.rateNote":
        "Округление выполняется по итогу периода, а не по каждой проводке. Поэтому налог по отдельной проводке не показывается.",
    "app.ustva.bmgAbbr": "Налог. база",
    "app.ustva.stAbbr": "Налог",
    "app.ustva.bemessung": "Налоговая база",
    "app.ustva.steuer": "Налог",
    "app.ustva.quartal": "{quartalNum}-й квартал {year}",
    "app.ustva.transferticket": "Transferticket",
    "app.ustva.exports.journalRest": "Зафиксировать",
    "app.ustva.exports.allJournaled": "Все проводки этой декларации уже зафиксированы",
    "app.ustva.exports.filedBy": "Отправил",
    "app.ustva.exports.zahllast": "К уплате / возврат",
    "app.ustva.exports.export": "Экспорт",
    "app.ustva.exports.inDms": "Сохранено в DMS: Налоги / НДС",
    "app.ustva.exports.inAccounting": "Проведено в бухгалтерии (FE)",
    "app.ustva.exportSave.title": "Сохранить протокол",
    "app.ustva.exportSave.open": "Сохранить (DMS/FIBU)",
    "app.ustva.exportSave.dms": "DMS: Налоги / НДС",
    "app.ustva.exportSave.dmsDone": "Уже сохранено",
    "app.ustva.exportSave.accounting": "Бухгалтерия: свободный ввод (черновик)",
    "app.ustva.exportSave.accountingDone": "Уже проведено",
    "app.ustva.exportSave.preview": "{soll} на {haben} · {amount} · {text} · {date} · черновик",
    "app.ustva.exportSave.noFeWrite": "Нет прав на запись в свободный ввод",
    "app.ustva.exportSave.noKz83": "Нет суммы к уплате или возврату",
    "app.ustva.exportSave.noConfig": "Бухгалтерский год {year} не создан",
    "app.ustva.exportSave.unsupportedSkr":
        "План счетов {skr} не поддерживается; проверьте план счетов бухгалтерского года",
    "app.ustva.exportSave.noPermission": "Для сохранения нужны права на запись в DMS или свободный ввод",
    "app.ustva.exportSave.pdfMissing": "Не удалось загрузить протокол передачи",
    "app.ustva.exportSave.hashFailed": "Не удалось прочитать протокол передачи. Пожалуйста, перезагрузите страницу.",
    "app.ustva.filings.title": "Включено в предварительные декларации по НДС",
    "app.ustva.filings.empty": "Эта проводка не включена ни в одну отправленную предварительную декларацию.",
    "app.ustva.filings.showPdf": "Показать PDF",
    "app.ustva.filings.transmittedBy": "отправил",
    "app.ustva.filings.columnHeader": "Предварительная декларация по НДС",
    "app.ustva.bookings.module": "Модуль",
    "app.ustva.bookings.amount": "Сумма",
    "app.ustva.bookings.status": "Статус",
    "app.ustva.bookings.manual": "Ручная корректировка",
    "app.ustva.bookings.total": "Итого",
    "app.ustva.bookings.totalFiltered": "Итого (с фильтром)",
    "app.ustva.bookings.onlyDeviations": "Только расхождения ({count})",
    "app.ustva.bookings.search": "Поиск по документу или счёту",
    "app.ustva.bookings.prevDeviation": "Предыдущее расхождение",
    "app.ustva.bookings.nextDeviation": "Следующее расхождение",
    "app.ustva.bookings.status.added": "Новая",
    "app.ustva.bookings.status.storno": "Сторно",
    "app.ustva.bookings.status.removed": "Удалена",
    "app.ustva.bookings.status.changed": "Изменена",
    "app.ustva.bookings.status.unchanged": "Без изменений",
    "app.ustva.reconciliation.filed": "Передано",
    "app.ustva.reconciliation.difference": "Разница",
    "app.ustva.reconciliation.today": "Значение сейчас",
    "app.ustva.reconciliation.complete": "Эти причины полностью объясняют разницу.",
    "app.ustva.reconciliation.rest":
        "{count, plural, one {# ещё проводка} few {# ещё проводки} other {# ещё проводок}}",
    "app.ustva.deviation.summary.scope": "Затронуто показателей: {kzCount}, проводок: {recordCount}",
    "app.ustva.deviation.summary.openDeviations": "Показать расхождения",
    "app.ustva.deviation.export": "Расхождения в PDF",
    "app.ustva.deviation.export.title": "Расхождения с декларацией по НДС",
    "app.ustva.deviation.export.filtered": "Отфильтрованный список: показаны не все строки.",
    "app.ustva.deviation.export.total": "Итого разница",
    "app.ustva.deviation.export.generated": "Создано",
    "app.ustva.diff.title": "Изменения в {beleg}",
    "app.ustva.diff.identical": "Эта проводка не менялась.",
    "app.ustva.deviation.warning": "При передаче сегодня декларация была бы другой.",
    "app.ustva.deviation.unchanged": "Без изменений с момента передачи {date}.",
    "app.ustva.deviation.filedForQuarter": "Эта декларация была передана за {quartalNum} квартал {year} года.",
    "app.ustva.deviation.showQuarter": "Показать квартал",
    "app.ustva.deviation.noBaseline":
        "Для этой передачи расшифровка по кодам не сохранялась. Сравнение с текущими данными невозможно.",
    "app.ustva.deviation.filedOn": "Передано {date}, отправил",
    "app.ustva.deviation.filed": "передано",
    "app.ustva.deviation.current": "сейчас",
    "app.ustva.deviation.delta": "разница",
    "app.ustva.deviation.cause.added": "проведено после передачи",
    "app.ustva.deviation.cause.storno": "сторнирующая проводка после передачи",
    "app.ustva.deviation.cause.removed": "сторнировано или удалено после передачи",
    "app.ustva.deviation.cause.changed": "изменено после передачи",
    "app.ustva.deviation.cause.manual": "ручная корректировка при передаче",
    "app.ustva.journalAfterExport.title": "Зафиксировать проводки",
    "app.ustva.journalAfterExport.body":
        "Передача прошла успешно. Зафиксировать {count} проводок, вошедших в эту декларацию? Зафиксированные проводки можно исправить только через Storno.",
    "app.ustva.journalAfterExport.confirm": "Зафиксировать",
    "app.ustva.journalAfterExport.dismiss": "Позже",
    "app.ustva.journalAfterExport.hint": "Это можно сделать позже в списке передач.",
    "app.ustva.journalAfterExport.done": "Проводки зафиксированы",
    "app.ustva.groupA": "A. Облагаемые поставки, прочие услуги и безвозмездная передача",
    "app.ustva.taxableSales19": "Облагаемые обороты 19 %",
    "app.ustva.taxableSales7": "Облагаемые обороты 7 %",
    "app.ustva.taxableSales0": "Облагаемые обороты 0 %",
    "app.ustva.otherTaxRates": "Прочие налоговые ставки",
    "app.ustva.agriculturalWithVatId": "Сельскохозяйственные предприятия с USt-ID",
    "app.ustva.salesPara24":
        "Обороты, по которым налог уплачивается согласно § 24 UStG (продукция лесопилок, напитки и алкогольные жидкости, напр. вино)",
    "app.ustva.groupB": "B. Освобождённые от налога поставки, прочие услуги и безвозмездная передача",
    "app.ustva.intraCommunityDeliveriesWithVatId": "Внутрисоюзные поставки с USt-ID",
    "app.ustva.newVehiclesToBuyerWithoutVatId": "Новые транспортные средства покупателям без USt-ID",
    "app.ustva.newVehiclesOutsideBusiness": "Новые транспортные средства вне предприятия (§ 2a UStG)",
    "app.ustva.otherTaxFreeWithInputTax":
        "Прочие освобождённые обороты с вычетом входного налога (напр. экспортные поставки, обороты по § 4 № 2–7 UStG)",
    "app.ustva.taxFreeWithoutInputTax":
        "Освобождённые обороты без вычета входного налога (напр. обороты по § 4 № 8–29 UStG)",
    "app.ustva.groupC": "C. Внутрисоюзные приобретения",
    "app.ustva.taxFreeEuAcquisitions":
        "Освобождённые приобретения в ЕС определённых товаров и инвестиционного золота (§§ 4b и 25c UStG)",
    "app.ustva.taxableEuAcquisitions19": "Облагаемые приобретения в ЕС 19 %",
    "app.ustva.taxableEuAcquisitions7": "Облагаемые приобретения в ЕС 7 %",
    "app.ustva.taxableEuAcquisitions0": "Облагаемые приобретения в ЕС 0 %",
    "app.ustva.newVehiclesFromSuppliersWithoutVatId":
        "Новые транспортные средства (§ 1b абз. 2 и 3 UStG) от поставщиков без USt-ID",
    "app.ustva.groupD": "D. Получатель услуг как должник по налогу (§ 13b UStG)",
    "app.ustva.otherServicesPara3a":
        "Прочие услуги по § 3a абз. 2 UStG предпринимателя, учреждённого на остальной территории Сообщества (§ 13b абз. 1 UStG)",
    "app.ustva.salesUnderGrEStG": "Обороты, подпадающие под GrEStG (§ 13b абз. 2 № 3 UStG)",
    "app.ustva.otherServicesPara13b": "Прочие услуги (§ 13b абз. 2 № 1, 2, 4–12 UStG)",
    "app.ustva.groupE": "E. Дополнительные сведения об оборотах",
    "app.ustva.firstBuyerTriangularTransactions":
        "Поставки первого покупателя при внутрисоюзных трёхсторонних сделках (§ 25b UStG)",
    "app.ustva.taxableSalesRecipientOwesTax":
        "Облагаемые обороты исполнителя, по которым налог должен получатель услуг согласно § 13b абз. 5 UStG",
    "app.ustva.nonTaxableOtherServicesPara18b": "Необлагаемые прочие услуги согласно § 18b предл. 1 № 2 UStG",
    "app.ustva.otherNonTaxableSales": "Прочие необлагаемые обороты (место оказания услуги не на территории страны)",
    "app.ustva.groupF": "F. Вычитаемые суммы входного налога и корректировка вычета входного налога",
    "app.ustva.inputTaxFromInvoices":
        "Суммы входного налога по счетам других предпринимателей (§ 15 абз. 1 предл. 1 № 1 UStG), по услугам в смысле § 13a абз. 1 № 6 UStG (§ 15 абз. 1 предл. 1 № 5 UStG) и по внутрисоюзным трёхсторонним сделкам (§ 25b абз. 5 UStG)",
    "app.ustva.inputTaxFromIntraCommunityAcquisition":
        "Суммы входного налога по внутрисоюзному приобретению товаров (§ 15 абз. 1 предл. 1 № 3 UStG)",
    "app.ustva.importVat": "Возникший импортный НДС (§ 15 абз. 1 предл. 1 № 2 UStG)",
    "app.ustva.inputTaxFromPara13b":
        "Суммы входного налога по услугам в смысле § 13b UStG (§ 15 абз. 1 предл. 1 № 4 UStG)",
    "app.ustva.inputTaxAverageRates": "Суммы входного налога, рассчитанные по общим средним ставкам (§ 23a UStG)",
    "app.ustva.inputTaxNewVehiclesSmallBusiness":
        "Вычет входного налога по внутрисоюзным поставкам новых транспортных средств вне предприятия (§ 2a UStG), а также малыми предпринимателями в смысле § 19 абз. 1 UStG (§ 15 абз. 4a UStG)",
    "app.ustva.inputTaxCorrectionPara15a": "Корректировка вычета входного налога (§ 15a UStG)",
    "app.ustva.inputTax": "Входной налог",
    "app.ustva.remainingAmount": "Остаток суммы",
    "app.ustva.groupG": "G. Прочие суммы налога",
    "app.ustva.taxFromChangeOfTaxationForm":
        "Налог вследствие смены формы налогообложения, а также доначисление налога на обложенные авансы и подобное из-за изменения налоговой ставки",
    "app.ustva.incorrectlyShownTaxPara14c":
        "Суммы налога, неверно или необоснованно указанные в счетах (§ 14c UStG), а также суммы налога, причитающиеся по § 6a абз. 4 предл. 2, § 17 абз. 1 предл. 7, § 25b абз. 2 UStG или с лица, изымающего товар со склада, либо складского хранителя по § 13a абз. 1 № 6 UStG",
    "app.ustva.groupH": "H. Авансовый платёж по НДС / превышение",
    "app.ustva.deductionSpecialPrepayment":
        "Вычет установленного специального авансового платежа за постоянное продление срока",
    "app.ustva.remainingVatPrepayment": "Оставшийся авансовый платёж по НДС / превышение (отрицательное)",
    "app.ustva.groupI":
        "I. Дополнительные сведения о снижениях согласно § 17 абз. 1 предл. 1, 2 в сочетании с абз. 2 № 1 предл. 1 UStG",
    "app.ustva.reductionOfTaxBase": "Снижение налоговой базы",
    "app.ustva.reductionOfDeductibleInputTax": "Снижение вычитаемых сумм входного налога",
    "app.ustva.aiCheckFailed": "Проверка ИИ не удалась",
    "app.ustva.elsterUstvaOk": "Elster UStVA ok",
    "app.ustva.missingTaxInfo": "чтобы продолжить, укажите налоговую информацию в настройках вашей компании",
    "app.ustva.selectSpecificPeriod": "чтобы продолжить, выберите конкретный период",
    "app.ustva.yearWithoutUstva":
        "В настройках года для этого года выбрано «Без УСт-декларации». Подаётся только годовая декларация, поэтому отправка предварительной декларации через ELSTER отключена.",
    "app.ustva.missingElsterRole":
        "У вас нет прав на отправку в ELSTER. Для этого нужна роль «Отправитель ELSTER», которую может выдать администратор компании.",
    "app.ustva.correctedReturn": "Исправленная декларация",
    "app.ustva.documentsSubmittedSeparately": "Документы подаются отдельно",
    "app.ustva.checkReturnWithAi": "Проверить декларацию с помощью ИИ",
    "app.ustva.aiCheckExperimentalHint": "Экспериментально - проверьте правдоподобность показателей с помощью ИИ",
    "app.ustva.aiCheckReviewNotice":
        "Проверка ИИ является необязательной проверкой правдоподобия и не заменяет профессиональную проверку. Передача в ELSTER выполняется только после вашей проверки и явного действия.",
    "app.ustva.followUpQuestions": "Уточняющие вопросы:",
    "app.ustva.certificateInvalid": "Сертификат .pfx повреждён",
    "app.ustva.pinInvalid": "Неверный PIN",
    "app.ustva.encrypting": "Шифрование",

    "avm.nav.dashboard": "Обзор",
    "avm.nav.assets": "Основные средства",
    "avm.nav.movements": "Движения",
    "avm.nav.import": "Импорт",
    "avm.nav.restwert": "Реестр остаточной стоимости",
    "avm.nav.spiegel": "Ведомость движения ОС",
    "avm.nav.forecast": "Прогноз амортизации",
    "avm.nav.inventory": "Инвентарный список",
    "avm.nav.batches": "Пакеты проводок",
    "avm.nav.rules": "Правила расчёта",
    "avm.rules.title": "Правила расчёта реестра основных средств",
    "avm.rules.search": "Поиск по правилу, термину или ID",
    "avm.rules.statute": "Правовая основа",
    "avm.rules.statute.none": "Правило реестра без отдельного требования закона",
    "avm.rules.example": "Пример",
    "avm.rules.status.planned": "запланировано",
    "avm.rules.status.unsupported": "не поддерживается",
    "avm.rules.glossary.title": "Варианты выбора в реестре",
    "avm.rules.noResults": "Ни одно правило и ни один термин не соответствуют поиску.",
    "avm.rules.graph.toggle": "Взаимосвязи",
    "avm.rules.graph.label": "Взаимосвязи правил в разделе {topic}",
    "avm.rules.graph.stub": "Правила в разделе {topic}",
    "avm.rules.graph.hint":
        "Стрелка указывает на правило, на котором основано правило. Нажмите на правило, чтобы перейти к нему.",
    "avm.rules.loading": "Загрузка",
    "avm.rules.chart.toggle": "Пример в виде диаграммы",
    "avm.rules.chart.linear": "Линейная",
    "avm.rules.chart.degressive": "Дегрессивная",
    "avm.rules.chart.bookValue": "Балансовая стоимость на конец финансового года, рассчитанная реестром",
    "avm.rules.chart.afa": "Амортизация за финансовый год, рассчитанная реестром",
    "avm.rules.chart.afaSeries": "Амортизация",

    "avm.dashboard.title": "Обзор",
    "avm.dashboard.kpi.bookValueEnd": "Балансовая стоимость на конец года",
    "avm.dashboard.kpi.bookValueStart": "Балансовая стоимость на начало года",
    "avm.dashboard.kpi.afa": "АфА {year}",
    "avm.dashboard.kpi.gwgShare": "из них малоценные активы {value}",
    "avm.dashboard.kpi.additions": "Поступления",
    "avm.dashboard.kpi.disposals": "Выбытия",
    "avm.dashboard.kpi.cost": "Стоимость приобретения",
    "avm.dashboard.kpi.count": "{count} объектов",
    "avm.dashboard.lastAdditions": "Последние поступления",
    "avm.dashboard.todo.title": "Требует внимания",
    "avm.dashboard.todo.usefulLifeEndsNextYear": "{count} объектов будут полностью самортизированы в {year}",
    "avm.dashboard.todo.iabDeadlineDue": "Инвестиционный вычет за {year} нужно закрепить за объектом в этом году",
    "avm.dashboard.todo.iabDeadlineReached": "Инвестиционный вычет за {year} просрочен и подлежит восстановлению",
    "avm.dashboard.todo.batchReady": "Пакет проводок за {year} ожидает передачи",
    "avm.dashboard.todo.yearNotClosed": "{year} передан, но ещё не закрыт",
    "avm.dashboard.todo.poolPolicyWithoutGroup": "Правило сборного пула активно, но группа сборного пула не создана",
    "avm.dashboard.todo.poolAssetWrongGroup": "{count} объектов сборной позиции находятся не в группе сборной позиции",
    "avm.dashboard.todo.snapshotDrift": "Отклонение от закрытия года {year}",
    "avm.dashboard.todo.none": "Нет задач",

    "avm.iab.title": "Инвестиционные вычеты",
    "avm.iab.lead":
        "Согласно §7g Abs. 1 EStG можно заранее вычесть до 50 процентов ожидаемых расходов на приобретение. Сумма должна быть закреплена за активом до конца третьего года, следующего за годом образования, иначе вычет подлежит отмене.",
    "avm.iab.add": "Добавить инвестиционный вычет",
    "avm.iab.col.formationYear": "Год образования",
    "avm.iab.col.deadlineYear": "Срок",
    "avm.iab.col.amount": "Сумма",
    "avm.iab.col.asset": "Закреплён за",
    "avm.iab.col.status": "Статус",
    "avm.iab.status.assigned": "закреплён",
    "avm.iab.status.open": "открыт",
    "avm.iab.status.dueThisYear": "Срок истекает в {year}",
    "avm.iab.status.overdue": "Срок просрочен",
    "avm.iab.noFiscalYear":
        "Без вычислимых хозяйственных лет вычеты на инвестиции вести нельзя. Причина указана в верхней части страницы.",
    "avm.iab.empty": "Инвестиционные вычеты не зарегистрированы",
    "avm.iab.form.formationYear": "Год образования",
    "avm.iab.form.amount": "Сумма",
    "avm.iab.form.asset": "Основное средство",
    "avm.iab.form.assetNone": "Не закреплён",
    "avm.iab.form.note": "Примечание",
    "avm.iab.form.ceiling": "не более {amount}, это 50 процентов расходов на приобретение",
    "avm.iab.error.amount": "Сумма должна быть больше 0",
    "avm.iab.error.ceiling": "Инвестиционный вычет не может превышать 50 процентов расходов на приобретение",
    "avm.iab.error.assigned": "Этот инвестиционный вычет уже назначен другому объекту",
    "avm.iab.error.yearLocked":
        "Финансовый год {year} закрыт. Изменить закрепление можно только после его повторного открытия.",
    "avm.iab.error.yearLockedBefore":
        "Финансовый год {year} предшествует закрытому финансовому году {latest}. Изменить закрепление можно только после повторного открытия года {latest}.",
    "avm.iab.delete": "Удалить инвестиционный вычет",

    "avm.settings.fiscalYears.title": "Начало хозяйственного года",
    "avm.settings.fiscalYears.lead":
        "Учёт основных средств ведётся по календарному году, пока не указано начало. Начало действует для каждого года; последующая смена вводится как изменение с определённого года.",
    "avm.settings.fiscalYears.add": "Добавить изменение",
    "avm.settings.fiscalYears.year": "С года",
    "avm.settings.fiscalYears.calendarYear": "{month} (календарный год)",
    "avm.settings.fiscalYears.change": "с {year}: {month}",
    "avm.settings.fiscalYears.month": "Месяц",
    "avm.settings.fiscalYears.accountingDiffers":
        "В бухгалтерии хозяйственный год начинается в месяце {accountingMonth}, в учёте основных средств в месяце {avmMonth}.",
    "avm.settings.fiscalYears.takeOver": "Взять начало из бухгалтерии",
    "avm.settings.fiscalYears.base": "Хозяйственный год начинается в месяце: {month}",
    "avm.settings.fiscalYears.baseMonth": "Начало хозяйственного года",
    "avm.settings.fiscalYears.baseSave": "Сохранить начало",
    "avm.settings.fiscalYears.baseDelete": "Удалить начало",
    "avm.settings.fiscalYears.baseDelete.confirm":
        "Удалить начало хозяйственного года? После этого действует календарный год.",
    "avm.settings.fiscalYears.closed": "Закрыт",
    "avm.settings.fiscalYears.delete": "Удалить изменение",
    "avm.settings.fiscalYears.delete.confirm": "Удалить изменение с {year} из учёта основных средств?",

    "avm.settings.title": "Настройки учёта основных средств",
    "avm.settings.gwgPolicy": "Правило для малоценных активов",
    "avm.settings.gwgPolicy.immediate": "Немедленное списание",
    "avm.settings.gwgPolicy.pool": "Сборный пул",
    "avm.settings.roundingMode": "Округление новых основных средств (по умолчанию)",
    "avm.settings.roundingMode.floorEuro": "Округлять до полного евро",
    "avm.settings.roundingMode.hint":
        "Подставляется в мастере и при импорте для новых основных средств. Существующие основные средства сохраняют своё округление; оно меняется в карточке основного средства.",
    "avm.settings.roundingMode.cent": "До цента",
    "avm.settings.memoValue": "Остаточная стоимость новых основных средств (по умолчанию)",
    "avm.settings.memoValue.hint":
        "Предзаполняется в мастере и при импорте для новых основных средств. Существующие основные средства сохраняют своё значение; оно меняется в карточке основного средства.",
    "avm.settings.vatDefault": "НДС по умолчанию",
    "avm.settings.vatDefault.net": "Нетто",
    "avm.settings.vatDefault.gross": "Брутто",
    "avm.settings.vatDefault.partial": "Частично с вычетом НДС",
    "avm.settings.vatDefault.kust": "Малый бизнес (§19 UStG)",
    "avm.settings.usedByEnabled": "Учитывать пользователя / место",
    "avm.settings.save": "Сохранить",
    "avm.settings.roles.title": "Роли",
    "avm.settings.roles.description": "Определяет, кто может подтверждать проводки в учёте основных средств.",
    "avm.settings.taxParameters.title": "Налоговые параметры",
    "avm.settings.taxParameters.hint":
        "Показанные значения действуют с указанной даты. Изменение законодательства отражается новой строкой с собственной датой начала действия, а не правкой этой строки.",
    "avm.settings.taxParameters.validFrom": "Действует с",
    "avm.settings.taxParameters.immediateExpenseLimit": "Порог немедленного списания",
    "avm.settings.taxParameters.gwgLimit": "Порог малоценных активов",
    "avm.settings.taxParameters.poolMin": "Минимум пула",
    "avm.settings.taxParameters.poolMax": "Максимум пула",
    "avm.settings.taxParameters.poolYears": "Годы амортизации пула",
    "avm.settings.taxParameters.specialRate": "Ставка специальной амортизации",
    "avm.settings.taxParameters.specialYears": "Годы специальной амортизации",
    "avm.settings.taxParameters.iabDeadline": "Срок IAB",

    "avm.settings.anonymize.title": "Анонимизировать пользователя",
    "avm.settings.anonymize.lead":
        "Заменяет имя в поле Используется на значением anonymisiert у всех затронутых основных средств. Действие является окончательным и фиксируется в журнале изменений.",
    "avm.settings.anonymize.person": "Используется",
    "avm.settings.anonymize.action": "Анонимизировать",
    "avm.settings.anonymize.confirm":
        "{count, plural, one {1 основное средство будет безвозвратно анонимизировано} few {# основных средства будут безвозвратно анонимизированы} other {# основных средств будут безвозвратно анонимизированы}}. Это действие нельзя отменить. Продолжить?",
    "avm.settings.anonymize.done":
        "{count, plural, one {1 основное средство анонимизировано} few {# основных средства анонимизировано} other {# основных средств анонимизировано}}",
    "avm.settings.anonymize.empty": "Имена не указаны",
    "avm.settings.anonymize.approverOnly": "Анонимизировать может только роль AVM-утверждающий.",

    "avm.groups.title": "Группы основных средств",
    "avm.groups.new": "Новая группа",
    "avm.groups.seed": "Создать стандартные группы",
    "avm.groups.seed.confirm":
        "Создать стандартные группы? Существующие группы остаются без изменений. Счета проводок создаются только при передаче в бухгалтерию.",
    "avm.groups.seed.skipped": "Не созданы, название уже занято: {names}",
    "avm.groups.name": "Название",
    "avm.groups.assetKonto": "Счёт актива",
    "avm.groups.afaKonto": "Счёт амортизации",
    "avm.groups.specialAfaKonto": "Счёт специальной амортизации",
    "avm.groups.specialAfaKonto.hint":
        "Без счёта специальной амортизации специальную амортизацию этой группы нельзя передать в бухгалтерию.",
    "avm.groups.writeDownKonto": "Счёт списания до стоимости (Teilwertabschreibung)",
    "avm.groups.writeDownKonto.hint": "Без этого счёта списание до стоимости в этой группе нельзя передать в учёт.",
    "avm.groups.afaaKonto": "Счёт AfaA",
    "avm.groups.afaaKonto.hint":
        "Счёт для чрезвычайного технического или экономического износа. Без него AfaA в этой группе нельзя передать в учёт.",
    "avm.groups.writeUpKonto": "Счёт дооценки",
    "avm.groups.writeUpKonto.hint": "Без счёта дооценки дооценка в этой группе невозможна.",
    "avm.groupAccounts.title": "Счета проводок",
    "avm.groupAccounts.hint":
        "Счета проводок нужны только для передачи в бухгалтерию. Каждый счёт необязателен; строка проводки без своего счёта не передаётся.",
    "avm.groupAccounts.skr": "План счетов",
    "avm.groupAccounts.skr.hint":
        "Счета проводок этой группы относятся к этому плану счетов; он должен совпадать с планом счетов бухгалтерии.",
    "avm.groupAccounts.skr.clears": "При смене плана счетов счета этой группы очищаются.",
    "avm.groupAccounts.save": "Сохранить счета проводок",
    "avm.groupAccounts.drawer.title": "Счета проводок: {name}",
    "avm.groups.kind": "Вид",
    "avm.groups.kind.movable": "Движимое имущество",
    "avm.groups.kind.intangible": "Нематериальные активы",
    "avm.groups.kind.nonDepreciable": "Неамортизируемое имущество",
    "avm.groups.kind.building": "Здания",
    "avm.groups.kind.immovable": "Недвижимое имущество (наружные сооружения)",
    "avm.groups.kind.pool": "Сборная позиция (Sammelposten)",
    "avm.groups.role": "Роль",
    "avm.groups.role.none": "нет",
    "avm.groups.role.goodwill": "Деловая репутация (Geschäfts- oder Firmenwert)",
    "avm.groups.role.land": "Земля застроенного участка",
    "avm.groups.role.hint":
        "Роль несёт правила: деловая репутация не дооценивается, а при разделении покупки доля земли попадает в группу с этой ролью.",
    "avm.groups.role.seeded": "Стандартная группа сохраняет свою роль, даже если её переименовать.",
    "avm.groups.role.kind":
        "Эта роль не подходит к виду: деловая репутация только для нематериальных, земля только для неамортизируемых активов.",
    "avm.groups.kind.hint":
        "Вид определяет допустимые методы амортизации и возможность специальной амортизации по § 7g EStG.",
    "avm.groups.kind.locked":
        "К группе отнесены основные средства. Вид можно изменить только после их перевода в другую группу или сторно их переносов в эту группу.",
    "avm.groups.disposalGainKonto": "Счёт прибыли от выбытия",
    "avm.groups.disposalLossKonto": "Счёт убытка от выбытия",
    "avm.assets.method.kindNotAllowed": "Недопустимо в этой группе",
    "avm.assets.method.notInBand": "Недопустимо для этой стоимости приобретения",
    "avm.assets.method.error.kind":
        "Этот метод недопустим в выбранной группе. Выберите допустимый метод или другую группу.",
    "avm.wizard.error.methodKind":
        "Этот метод недопустим в выбранной группе. Выберите допустимый метод или другую группу.",
    "avm.wizard.error.specialKind":
        "Специальная амортизация по § 7g EStG возможна только для движимого имущества. Снимите отметку или выберите группу движимого имущества.",
    "avm.wizard.special.kindUnavailable":
        "Выбранная группа не предназначена для движимого имущества; специальная амортизация по § 7g EStG невозможна.",
    "avm.movements.error.specialKind":
        "Специальная амортизация по § 7g EStG возможна только для движимого имущества, а это средство относится к группе другого вида. Переведите его в группу движимого имущества или выберите другой вид движения.",
    "avm.movements.error.specialKindTransferred":
        "Специальная амортизация по § 7g EStG возможна только для движимого имущества, а это средство переведено в группу другого вида. Сначала сторнируйте перевод или выберите другой вид движения.",
    "avm.movements.form.targetGroup.kindNotAllowed": "Недопустимо для метода амортизации этого средства",
    "avm.movements.form.targetGroup.specialNotAllowed":
        "Недопустимо: по средству проведена специальная амортизация по § 7g EStG",
    "avm.assets.method.none": "Без амортизации",
    "avm.wizard.method.none": "Без амортизации (неизнашиваемый актив)",
    "avm.wizard.method.noneDesc":
        "для земли, незавершённого строительства, авансов и финансовых вложений: балансовая стоимость не меняется до выбытия, обесценения или перевода",
    "avm.inventory.status.nonDepreciable": "Неизнашиваемый",
    "avm.movements.error.specialNone":
        "Специальная амортизация по § 7g EStG невозможна для неизнашиваемого актива. Обесценение, пожалуйста, проведите как внеплановое списание.",
    "avm.movements.error.noneBlocked":
        "Этот тип движения невозможен для неизнашиваемого актива. Пожалуйста, выберите другой тип движения.",
    "avm.movements.form.targetGroup.completed": "Недопустимо: актив введён в эксплуатацию и амортизируется",
    "avm.movements.form.targetGroup.iabNotAllowed": "Недопустимо: к активу привязан инвестиционный вычет",
    "avm.movements.error.completionLife":
        "С этим переводом начинается амортизация. Пожалуйста, укажите срок использования в месяцах, не меньше 1.",
    "avm.movements.form.completionLife": "Срок использования с ввода в эксплуатацию (месяцы)",
    "avm.movements.form.completionLifeHint": "Дата перевода является началом амортизации.",
    "avm.wizard.error.iabKind":
        "Инвестиционный вычет по § 7g EStG возможен только для движимых активов. Пожалуйста, снимите выбор или выберите группу для движимых активов.",
    "avm.wizard.iab.kindUnavailable":
        "Выбранная группа не предназначена для движимых активов; инвестиционный вычет по § 7g EStG привязать нельзя.",
    "avm.wizard.preview.noneMethod":
        "Без амортизации: балансовая стоимость не меняется до выбытия, обесценения или перевода.",
    "avm.import.row.error.noneBookValue":
        "Неизнашиваемый актив с балансовой стоимостью ниже стоимости приобретения. Пожалуйста, импортируйте строку с балансовой стоимостью, равной стоимости приобретения, а затем проведите обесценение как внеплановое списание.",
    "avm.iab.form.assetKindNotAllowed":
        "Недопустимо: актив входит или входил в группу без инвестиционного вычета по § 7g EStG",
    "avm.groups.defaultUsefulLife": "Срок полезного использования по умолчанию",
    "avm.groups.sortOrder": "Порядок сортировки",
    "avm.groups.empty": "Группы основных средств отсутствуют",
    "avm.groups.delete.confirm": "Удалить эту группу основных средств?",

    "avm.assets.title": "Основные средства",
    "avm.assets.new": "Новое основное средство",
    "avm.assets.search": "Поиск",
    "avm.assets.group": "Группа основных средств",
    "avm.assets.allGroups": "Все группы",
    "avm.assets.inventoryNum": "Инвентарный номер",
    "avm.assets.name": "Название",
    "avm.assets.supplier": "Поставщик",
    "avm.assets.acquisitionDate": "Дата приобретения",
    "avm.assets.acquisitionDate.error.tooEarly":
        "Основные средства с датой приобретения до 01.01.2018 не поддерживаются.",
    "avm.assets.cost": "Стоимость приобретения",
    "avm.assets.bookValueStart": "Балансовая стоимость на начало",
    "avm.assets.additions": "Поступления",
    "avm.assets.disposals": "Выбытия",
    "avm.assets.afa": "Амортизация",
    "avm.assets.bookValueEnd": "Балансовая стоимость на конец",
    "avm.assets.quantity": "Количество",
    "avm.assets.method": "Метод амортизации",
    "avm.assets.method.linear": "Линейный",
    "avm.assets.method.gwg": "Малоценный актив",
    "avm.assets.method.pool": "Пул",
    "avm.assets.method.degressive": "Дегрессивный",
    "avm.assets.method.degressiveUnavailable":
        "Недоступно: дата приобретения не попадает в установленный законом период дегрессивной амортизации.",
    "avm.assets.usefulLife": "Срок полезного использования",
    "avm.assets.location": "Местоположение",
    "avm.assets.costCenter": "Место возникновения затрат",
    "avm.assets.usedBy": "Используется",
    "avm.assets.note": "Примечание",
    "avm.assets.vatTreatment": "Режим НДС",
    "avm.assets.opening": "Начальный остаток",
    "avm.assets.openingYear": "Год открытия остатка",
    "avm.assets.openingBookValue": "Начальная балансовая стоимость",
    "avm.assets.openingRemainingMonths": "Оставшиеся месяцы",
    "avm.assets.total": "Итого",
    "avm.assets.groupSum": "Итого по группе",
    "avm.assets.empty": "Основные средства отсутствуют",
    "avm.assets.tag.gwg": "Малоценный",
    "avm.assets.tag.memo": "Памятная стоимость",
    "avm.assets.tag.addition": "Поступление",
    "avm.assets.tag.disposal": "Выбытие",
    "avm.assets.delete.confirm": "Удалить это основное средство?",

    "avm.movements.title": "Движения",
    "avm.movements.eyebrow": "Последующие изменения",
    "avm.movements.lead":
        "Каждое изменение основного средства фиксируется как датированное движение и влияет на амортизацию, балансовую стоимость и отчёты. Ничего не перезаписывается, история остаётся прослеживаемой.",
    "avm.movements.yearTable": "Движения в хозяйственном году {year}",
    "avm.movements.add": "Зафиксировать движение",
    "avm.movements.noAssets":
        "Для этой компании ещё не заведено ни одного основного средства. Движение всегда изменяет существующее основное средство, поэтому его можно зафиксировать только после первого заведения.",
    "avm.movements.noAssets.action": "Завести основное средство",
    "avm.movements.empty": "Нет движений в хозяйственном году {year}",
    "avm.movements.closedYear": "Хозяйственный год {year} закрыт. Движения возможны после его повторного открытия.",
    "avm.movements.col.asset": "Основное средство",
    "avm.movements.col.type": "Вид",
    "avm.movements.col.amount": "Сумма",
    "avm.movements.col.effect": "Влияние на балансовую стоимость",
    "avm.movements.type.zugang": "Поступление",
    "avm.movements.type.disposal": "Выбытие",
    "avm.movements.type.partialDisposal": "Частичное выбытие",
    "avm.movements.type.costAddition": "Последующие затраты",
    "avm.movements.type.transfer": "Перенос",
    "avm.movements.type.writeDown": "Внеплановая амортизация",
    "avm.movements.type.writeUp": "Дооценка",
    "avm.movements.type.specialDepreciation": "Специальная амортизация",
    "avm.movements.type.storno": "Сторно",
    "avm.movements.desc.disposal":
        "Продажа, изъятие или списание. Амортизация начисляется пропорционально до месяца выбытия, остаточная стоимость списывается, определяется прибыль или убыток.",
    "avm.movements.desc.partialDisposal":
        "Выбывает часть многоединичного объекта. Стоимость и накопленная амортизация списываются пропорционально, объект остаётся с остатком.",
    "avm.movements.desc.costAddition":
        "Расширение или улучшение после приобретения. Увеличивает базу амортизации с года затрат, оставшийся срок можно скорректировать.",
    "avm.movements.desc.transfer":
        "Смена группы основных средств. Значения сохраняются, меняется только представление.",
    "avm.movements.desc.writeDown":
        "Постоянное обесценение по § 253 Abs. 3 HGB. Уменьшает балансовую стоимость дополнительно к плановой амортизации, не ниже памятной стоимости; оставшийся срок полезного использования можно скорректировать.",
    "avm.movements.desc.writeUp":
        "Восстановление стоимости после ранее проведённой внеплановой амортизации. Не более балансовой стоимости, которую имело бы основное средство без этой амортизации.",
    "avm.movements.desc.specialDepreciation":
        "Специальная амортизация по § 7g Abs. 5 EStG. В год приобретения и в течение четырёх последующих лет, всего не более {rate} процентов от базы начисления.",
    "avm.movements.desc.specialDepreciationAny":
        "Специальная амортизация по § 7g Abs. 5 EStG. В год приобретения и в течение четырёх последующих лет, всего не более процента, действующего для года приобретения, от базы начисления.",
    "avm.movements.effect.zugang": "Принято к учёту по стоимости приобретения",
    "avm.movements.effect.disposal":
        "Амортизация до месяца выбытия {afa}, остаточная стоимость {bookValue} списана, выручка {proceeds}: {gainLoss}",
    "avm.movements.effect.gain": "прибыль {amount}",
    "avm.movements.effect.loss": "убыток {amount}",
    "avm.movements.effect.partialDisposal":
        "{leaving} из {before} единиц выбывают, стоимость {cost} списана пропорционально, остаётся {after}",
    "avm.movements.effect.costAddition":
        "База с {before} до {after}, амортизация {year} {afa}, стоимость на конец года {bookValue}",
    "avm.movements.effect.transfer": "Перенос из группы {from} в {to}, балансовая стоимость {bookValue} без изменений",
    "avm.movements.effect.writeDown":
        "Балансовая стоимость без амортизации {before}, с ней {after}, применено {applied}",
    "avm.movements.effect.writeUp":
        "Дооценка {applied} из {requested}, верхний предел {ceiling}, балансовая стоимость на конец года {bookValue}",
    "avm.movements.effect.specialDepreciation":
        "Специальная амортизация {applied}, оставшийся максимум {cap}, балансовая стоимость на конец года {bookValue}",
    "avm.movements.effect.notApplied": "не действует",
    "avm.movements.effect.cancelled": "сторнировано",
    "avm.movements.effect.storno": "отменяет движение от {date}",
    "avm.movements.effect.none": "Нет влияния в выбранном хозяйственном году",
    "avm.movements.effect.kontoMissing":
        "У группы этого средства нет счетов прибыли и убытка от выбытия. Выбытие позже создаст строку проводки без счёта; укажите счета в счетах проводок группы.",
    "avm.movements.form.asset": "Основное средство",
    "avm.movements.form.type": "Вид движения",
    "avm.movements.form.amount": "Сумма",
    "avm.movements.form.maxAmount": "не более {amount}",
    "avm.movements.form.remainingMonthsRequired":
        "Требуется оставшийся срок полезного использования, иначе сумма будет сразу списана полностью",
    "avm.movements.form.noTargetGroup": "Невозможно: нет другой группы основных средств для перемещения.",
    "avm.movements.form.proceeds": "Выручка",
    "avm.movements.form.quantity": "Количество",
    "avm.movements.form.quantityHint": "пропорциональное списание стоимости и накопленной амортизации",
    "avm.movements.form.targetGroup": "Целевая группа",
    "avm.movements.form.remainingMonths": "Новый оставшийся срок (месяцы)",
    "avm.movements.form.remainingMonthsHint": "оставьте пустым, чтобы сохранить текущий оставшийся срок",
    "avm.movements.form.note": "Заметка",
    "avm.movements.form.effectTitle": "Влияние",
    "avm.movements.form.writeDownKind": "Вид внеплановой амортизации",
    "avm.movements.form.writeDownKind.teilwert": "Списание до стоимости (Teilwertabschreibung)",
    "avm.movements.form.writeDownKind.teilwertHint": "только при ведении баланса (Betriebsvermögensvergleich)",
    "avm.movements.form.writeDownKind.afaa": "AfaA (чрезвычайный износ)",
    "avm.movements.form.writeDownKind.afaaNone":
        "Невозможно, пока актив не амортизируется (§ 7 Abs. 1 Satz 7 EStG); оформите как списание до стоимости (Teilwertabschreibung).",
    "avm.movements.error.date": "Требуется дата",
    "avm.movements.error.amount": "Требуется сумма",
    "avm.movements.error.quantity": "Количество от 1 до текущего остатка",
    "avm.movements.error.targetGroup": "Требуется целевая группа",
    "avm.movements.error.writeUpCeiling": "Дооценка не более {amount}",
    "avm.movements.error.specialCap": "Специальная амортизация не более {amount}",
    "avm.movements.error.specialWindow":
        "Специальная амортизация только в год приобретения и в течение четырёх последующих лет",
    "avm.movements.error.writeDownAmount": "Внеплановая амортизация не более {amount}",
    "avm.movements.error.writeDownKind": "Выберите списание до стоимости или AfaA.",
    "avm.movements.error.taxParametersMissing":
        "Невозможно определить максимум: налоговые параметры не заданы. Обратитесь в поддержку.",
    "avm.movements.error.periodMissing": "Для этой даты не настроен хозяйственный год",
    "avm.movements.error.yearLocked":
        "Финансовый год {year} закрыт. Движение можно зафиксировать только после его повторного открытия.",
    "avm.movements.error.yearLockedBefore":
        "Финансовый год {year} предшествует закрытому финансовому году {latest}. Движение можно зафиксировать только после повторного открытия года {latest}.",
    "avm.movements.error.specialMethod":
        "Специальная амортизация возможна только при линейной амортизации (§ 7a Abs. 4 EStG). Переведите объект на линейную амортизацию или выберите другой тип движения.",
    "avm.movements.error.poolSpecial":
        "Специальная амортизация невозможна для сборной позиции: сборная позиция амортизируется как группа, а не как отдельный объект. Выберите другой тип движения.",
    "avm.movements.error.poolWriteDown":
        "Внеплановая амортизация невозможна для сборной позиции: сборная позиция амортизируется как группа, а не как отдельный объект. Выберите другой тип движения.",
    "avm.movements.error.poolWriteUp":
        "Дооценка невозможна для сборной позиции: сборная позиция амортизируется как группа, а не как отдельный объект. Выберите другой тип движения.",
    "avm.movements.error.poolCostAddition":
        "Последующие затраты на приобретение невозможны для сборной позиции: сборная позиция амортизируется как группа, а не как отдельный объект. Выберите другой тип движения.",
    "avm.movements.error.writeUpFirmenwert":
        "Дооценка приобретённой деловой репутации (Geschäfts- oder Firmenwert) запрещена § 253 абз. 5 предл. 2 HGB. Восстановление стоимости не проводится.",
    "avm.movements.error.writeUpUnknownGroup":
        "Группа основных средств, к которой объект относится на эту дату, не найдена. Перезагрузите страницу.",
    "avm.movements.storno.title": "Сторнировать движение",
    "avm.movements.storno.date": "Дата сторно",
    "avm.movements.storno.text":
        "Движение отменяется сторнирующим движением. Оба остаются видимыми, ни одно не имеет эффекта.",

    "avm.detail.plan": "План амортизации",
    "avm.detail.plan.year": "Год",
    "avm.detail.plan.months": "Месяцы",
    "avm.detail.plan.status.closed": "Закрыт",
    "avm.detail.plan.status.current": "Текущий",
    "avm.detail.plan.status.plan": "Плановый",
    "avm.detail.plan.cumulativeAfaEnd": "Накопленная АфА на конец",
    "avm.detail.plan.status": "Статус",
    "avm.detail.plan.empty": "План амортизации отсутствует",
    "avm.detail.chart": "График",
    "avm.detail.stammdaten": "Основные данные",
    "avm.detail.edit": "Редактировать",
    "avm.detail.delete": "Удалить",
    "avm.detail.bookValue": "Балансовая стоимость",
    "avm.detail.bookValue.noRowForYear": "За этот год не учтено",
    "avm.detail.kontierung": "Контировка",
    "avm.detail.kontierung.missing":
        "Для этой группы основных средств не задан счёт. Пакет проводок не может провести эту строку.",
    "avm.assetDetail.iabReduction": "Инвестиционный вычет {amount} уменьшает базу начисления до {base}",
    "avm.documents.title": "Документы",
    "avm.documents.addFile": "Файл",
    "avm.documents.open": "открыть",
    "avm.documents.unlink": "Удалить связь",
    "avm.documents.tag.avm": "Реестр ОС",
    "avm.documents.tag.record": "Бухгалтерия",
    "avm.documents.empty": "Документов пока нет",
    "avm.documents.recordHint": "Документ связанной проводки",
    "avm.documents.recordLoading": "Документы связанной проводки загружаются",
    "avm.documents.missing": "Документ {id} не найден",
    "avm.documents.noDmsAccess": "Для документов нужен доступ на чтение к модулю документов",
    "avm.documents.noWriteAccess": "Для документов нужен доступ на запись к реестру ОС",
    "avm.detail.changeLog": "Журнал изменений",
    "avm.detail.changeLog.empty": "Изменений пока нет",
    "avm.detail.notFound": "Основное средство не найдено",

    "avm.restwert.title": "Реестр остаточной стоимости",
    "avm.restwert.subtitle": "Обзор остаточной стоимости на отчётную дату",
    "avm.restwert.legend": "Легенда",
    "avm.restwert.empty": "Данные отсутствуют",
    "avm.export.csv": "Экспорт CSV",
    "avm.export.pdf": "Экспорт PDF",
    "avm.export.xlsx": "Экспорт Excel",

    "avm.spiegel.title": "Ведомость движения ОС",
    "avm.spiegel.subtitle": "Отчётный год",
    "avm.spiegel.col.group": "Группа основных средств",
    "avm.spiegel.col.costStart": "Стоимость приобретения на начало",
    "avm.spiegel.col.additions": "Поступления",
    "avm.spiegel.col.disposals": "Выбытия",
    "avm.spiegel.col.transfers": "Перемещения",
    "avm.spiegel.col.costEnd": "Стоимость приобретения на конец",
    "avm.spiegel.col.cumAfaStart": "Накопленная амортизация на начало",
    "avm.spiegel.col.afa": "Амортизация за год",
    "avm.spiegel.col.writeUps": "Дооценка",
    "avm.spiegel.col.cumAfaDisposals": "Накопленная амортизация выбытий",
    "avm.spiegel.col.cumAfaTransfers": "Накопленная амортизация перемещений",
    "avm.spiegel.col.cumAfaEnd": "Накопленная амортизация на конец",
    "avm.spiegel.col.bookValueEnd": "Балансовая стоимость на конец",
    "avm.spiegel.col.bookValuePrevEnd": "Балансовая стоимость на конец предыдущего года",
    "avm.spiegel.total": "Итого",
    "avm.spiegel.empty": "За этот год основных средств нет",

    "avm.forecast.title": "Прогноз амортизации",
    "avm.forecast.window": "Период",
    "avm.forecast.window.years": "{count} лет",
    "avm.forecast.col.name": "Наименование",
    "avm.forecast.col.total": "Итого",
    "avm.forecast.pool": "Сборная позиция {year}",
    "avm.forecast.empty": "Нет плановой амортизации за выбранный период",

    "avm.pool.settings.noGroup":
        "Политика сборной позиции активна, но нет группы активов со счётом сборной позиции. Создайте группы по умолчанию или добавьте группу вида «сборная позиция».",
    "avm.pool.settings.hint":
        "Сборные позиции равномерно списываются в течение {years} лет независимо от месяца приобретения.",
    "avm.pool.asset.noPlan":
        "У объектов сборной позиции нет собственного плана амортизации. Балансовая стоимость указана в строке сборной позиции.",

    "avm.inventory.title": "Инвентарная опись",
    "avm.inventory.filter.applied": "отфильтровано",
    "avm.inventory.filter.location": "Местоположение",
    "avm.inventory.filter.status": "Статус",
    "avm.inventory.status.active": "Активно",
    "avm.inventory.status.writtenOff": "Списано",
    "avm.inventory.status.disposed": "Выбыло",
    "avm.inventory.export.xlsx": "Excel",
    "avm.inventory.export.sheet": "Инвентаризационная ведомость",
    "avm.inventory.sheet.counted": "Учтено",
    "avm.inventory.sheet.note": "Примечание",
    "avm.inventory.empty": "Нет основных средств на балансе",

    "avm.batches.title": "Пакеты проводок",
    "avm.batches.tab.afa": "Пакет АфА",
    "avm.batches.tab.disposal": "Пакет выбытий",
    "avm.batches.kpi.total": "Сумма",
    "avm.batches.kpi.lines": "Строки",
    "avm.batches.status.none": "Нет пакета",
    "avm.batches.status.ready": "Готов",
    "avm.batches.status.transferred": "Передан",
    "avm.batches.create": "Создать пакет",
    "avm.batches.createDifference": "Создать пакет разницы",
    "avm.batches.createDifference.hint": "Проводит только изменение.",
    "avm.batches.createReplacement": "Сторно и новый пакет",
    "avm.batches.createReplacement.hint": "Сторнирует переданный пакет и заново проводит текущее состояние.",
    "avm.batches.transfer": "Передать пакет",
    "avm.batches.transfer.confirm": "Передать {count} строк на сумму {total} как черновики в Freie Erfassung?",
    "avm.batches.transfer.lockYear":
        "С передачей финансовый год {year} будет закрыт. После этого движения и изменения стоимости в {year} заблокированы.",
    "avm.batches.transfer.closedYear": "Финансовый год {year} закрыт.",
    "avm.batches.transfer.remaining": "Финансовый год {year} будет закрыт, как только будет передан также {batch}.",
    "avm.batches.transfer.stillOpen": "Финансовый год {year} ещё не закрыт. Закройте его ниже в разделе закрытия года.",
    "avm.batches.transfer.stale":
        "{count, plural, one {{batches} {year} был передан} other {{batches} {year} были переданы}} до более позднего изменения; разница ещё не попала в бухгалтерию. Финансовый год остаётся открытым. Выберите «Создать пакет разницы» или «Сторно и новый пакет» и передайте пакет; после этого финансовый год закроется.",
    "avm.batches.transfer.stale.join": " и ",
    "avm.batches.transfer.alsoLocks":
        "{count, plural, one {Тем самым блокируется и финансовый год {last}.} =2 {Тем самым блокируются и финансовые годы {first} и {last}.} other {Тем самым блокируются и финансовые годы с {first} по {last}.}}",
    "avm.batches.delete": "Удалить пакет",
    "avm.batches.recreate": "Удалить и создать заново",
    "avm.batches.csv": "Как CSV",
    "avm.batches.stale": "Сохранённый пакет отличается от текущего расчёта",
    "avm.batches.staleTransferred":
        "Реестр изменился с момента передачи этого пакета. Показаны фактически переданные строки, а не текущий расчёт. Выберите «Создать пакет разницы» или «Сторно и новый пакет» и передайте пакет.",
    "avm.batches.difference.empty":
        "Переданные строки совпадают с текущим расчётом; разницы для проводки нет. Пакет разницы без строк фиксирует текущее состояние реестра.",
    "avm.batches.empty": "В этом году проводок не возникает",
    "avm.batches.goToFe": "Открыть черновики в Freie Erfassung",
    "avm.batches.goToFeHint": "Выберите там фильтр Черновик, чтобы подтвердить переданные проводки.",
    "avm.batches.goToFeNoAccess": "Переданные черновики находятся в Freie Erfassung; у вас нет туда доступа на чтение.",
    "avm.batches.transfer.blocked.fe": "Для этого нужен доступ на запись к Freie Erfassung",
    "avm.batches.notice.transfer":
        "Для перемещений между группами реестр основных средств не создаёт проводку. При необходимости отразите смену счёта в Freie Erfassung.",
    "avm.batches.notice.disposalGroup":
        "Выбытие проводится по группе на дату выбытия, тогда как реестр учитывает объект в группе на конец года.",
    "avm.batches.notice.poolExit":
        "Сборный пул покидает реестр; ведомость движения основных средств показывает выбытие по стоимости приобретения, но проводка для этого не создаётся.",
    "avm.batches.notice.missingKonto":
        "Для этой строки не указан счёт. Дополните группу основных средств перед созданием пакета.",
    "avm.batches.missingKonten.title": "У групп основных средств не заданы счета",
    "avm.batches.missingKonten.body":
        "Передача в бухгалтерию возможна только после того, как у этих групп основных средств появятся счета их строк проводки. Щелчок по группе открывает её счета проводок.",
    "avm.batches.chartMismatch.title": "Счета проводок другого плана счетов",
    "avm.batches.chartMismatch.body":
        "Бухгалтерия {year} ведётся по SKR 0{skr}. Счета проводок этих групп относятся к другому плану счетов; выберите в их счетах проводок SKR 0{skr} и укажите счета этого плана:",
    "avm.batches.accounts.none": "Для передачи в бухгалтерию каждой группе основных средств нужны счета проводок.",
    "avm.batches.accounts.noChart":
        "В бухгалтерии нет плана счетов SKR 03 или SKR 04. Укажите счета проводок для каждой группы вручную.",
    "avm.batches.accounts.seed": "Создать счета проводок",
    "avm.batches.accounts.fillable":
        "У некоторых стандартных групп ещё не заданы все счета проводок их плана счетов. При дополнении введённые счета не меняются.",
    "avm.batches.accounts.fill": "Дополнить счета проводок",
    "avm.batches.accounts.unconfigured.title": "Группы основных средств без счетов проводок",
    "avm.batches.accounts.unconfigured.body":
        "Для этих групп нет стандартных счетов. Группа без строки проводки в пакете не задерживает передачу.",
    "avm.batches.accounts.unconfigured": "не настроено",
    "avm.batches.fiscalYearMismatch.title": "Начало финансового года различается",
    "avm.batches.fiscalYearMismatch.body":
        "Финансовый год {year} начинается {avmStart} в реестре основных средств и {accountingStart} в бухгалтерии. Передача всё равно возможна.",
    "avm.batches.fiscalYearMismatch.consequences":
        "<li>Проводки получают дату {avmEnd} из финансового года реестра основных средств и попадают в бухгалтерский год {recordYear}.</li><li>Периодом проводки станет месяц {postingMonth}, поэтому месячные отчёты покажут всю годовую амортизацию в этом месяце.</li><li>Период, который бухгалтерия ведёт как финансовый год {year}, не получит амортизацию именно этого периода, и каждый следующий год сместится так же.</li>",
    "avm.batches.fiscalYearMismatch.culprit":
        "Сначала проверьте бухгалтерию: неверное начало вероятнее там, ведь неверный финансовый год в реестре основных средств был бы ошибочным уже с первой проводки.",
    "avm.batches.col.date": "Дата",
    "avm.batches.col.soll": "Дебет",
    "avm.batches.col.haben": "Кредит",
    "avm.batches.col.text": "Текст",
    "avm.batches.col.amount": "Сумма",

    "avm.closing.title": "Закрытие года",
    "avm.closing.close": "Закрыть год",
    "avm.closing.reopen": "Снова открыть год",
    "avm.closing.closed": "Закрыто {date}",
    "avm.closing.reopened": "Снова открыто {date}",
    "avm.closing.totalAfa": "АфА всего",
    "avm.closing.totalBookValue": "Балансовая стоимость на конец года",
    "avm.closing.blocked.batch": "Ещё не все пакеты проводок года переданы",
    "avm.closing.blocked.earlier": "Отсутствует закрытие года {year}",
    "avm.closing.blocked.locked":
        "Финансовый год {year} предшествует закрытому финансовому году {latest}. Сначала откройте {latest} заново.",
    "avm.closing.blocked.empty": "Закрытие за {year} не содержит объектов",
    "avm.closing.blocked.role": "Для этого нужно право «Подтверждение проводок в учёте основных средств»",
    "avm.closing.blocked.write": "Для этого нужен доступ на запись к модулю основных средств",
    "avm.closing.confirm.close": "Закрыть {count} объектов с АфА {total}?",
    "avm.closing.confirm.stale": "Закрывайте, только если разница вручную проведена в бухгалтерии.",
    "avm.closing.confirm.reopen":
        "Закрытие останется как подтверждение. Переданные проводки остаются в бухгалтерии; исправление проводится там. Снова открыть год?",
    "avm.closing.drift": "Отклонение от закрытия года {year}",
    "avm.closing.drift.field": "Поле",
    "avm.closing.drift.stored": "Сохранено",
    "avm.closing.drift.computed": "Рассчитано",
    "avm.closing.drift.onlyComputed": "Добавлено после закрытия",
    "avm.closing.drift.onlyStored": "Удалено после закрытия",

    "avm.restricted.title": "Нет доступа",
    "avm.restricted.description": "Нет прав на чтение модуля основных средств.",

    "avm.error.periods": "Хозяйственные годы этой компании непоследовательны: {message}",
    "avm.error.outsideRange":
        "{count, plural, one {# основное средство находится} few {# основных средства находятся} many {# основных средств находятся} other {# основных средств находятся}} вне рассчитанных хозяйственных лет и будет учитываться без амортизации.",
    "avm.error.planFailed":
        "{count, plural, one {Для # основного средства не удалось рассчитать план амортизации. Оно отсутствует} few {Для # основных средств не удалось рассчитать план амортизации. Они отсутствуют} many {Для # основных средств не удалось рассчитать план амортизации. Они отсутствуют} other {Для # основных средств не удалось рассчитать план амортизации. Они отсутствуют}} в ведомости движения, ведомости остаточной стоимости, инвентарной описи, пакете амортизации и годовом закрытии. До устранения создание пакета и закрытие года заблокированы.",
    "avm.error.planFailed.action":
        "Откройте указанное основное средство и измените метод амортизации в основных данных, например на линейный. Если основное средство относится к уже закрытому хозяйственному году, сначала откройте этот год заново.",
    "avm.error.writeUpAboveCap":
        "Дооценка от {date} на сумму {amount} превышает допустимый предел {cap}. Сторнируйте дооценку и проведите заново не более {cap}; если она относится к закрытому хозяйственному году, сначала откройте этот год заново.",
    "avm.error.writeUpUnimpairedMissing":
        "Для дооценки от {date} предел задаёт балансовая стоимость без частичного списания, так как здание принято с собственной базой амортизации. Укажите балансовую стоимость без частичного списания в основных данных.",
    "avm.fiscalYear.action": "Перейти к настройкам AVM",
    "avm.yearSelect.label": "Хозяйственный год",
    "avm.error.noTaxParameters": "Для этого хозяйственного года налоговые параметры не заданы.",
    "avm.error.noGroups":
        "Для этой компании ещё не созданы группы основных средств, без группы основное средство внести нельзя. Группы создаются один раз в настройках, там действие создания стандартных групп добавляет их вместе со счетами прибыли и убытка от выбытия в соответствии с планом счетов.",
    "avm.error.noGroups.action": "Открыть настройки",
    "avm.error.loadFailed": "Не удалось загрузить данные учёта основных средств.",
    "avm.loading": "Загрузка...",

    "avm.classify.expense": "Сразу списывается как расход",
    "avm.classify.gwg": "Малоценный актив",
    "avm.classify.pool": "Сборный пул",
    "avm.classify.linear": "Линейная амортизация",

    "avm.wizard.eyebrow": "Мастер ввода",
    "avm.wizard.title": "Новое основное средство",
    "avm.wizard.lead":
        "Четыре шага. Срок полезного использования, метод амортизации и счёт предлагает система, любое значение можно изменить.",
    "avm.wizard.step1": "Что приобретено?",
    "avm.wizard.step2": "Стоимость и дата",
    "avm.wizard.step3": "Амортизация",
    "avm.wizard.step4": "Проверить и сохранить",
    "avm.wizard.save": "Сохранить основное средство",
    "avm.wizard.field.name": "Наименование",
    "avm.wizard.field.supplier": "Поставщик / происхождение",
    "avm.wizard.field.group": "Группа основных средств",
    "avm.wizard.field.groupHint": "определяет счёт и предлагаемый срок использования",
    "avm.wizard.field.location": "Местонахождение",
    "avm.wizard.field.costCenter": "Центр затрат",
    "avm.wizard.field.costCenterNone": "без центра затрат",
    "avm.wizard.field.quantity": "Количество",
    "avm.wizard.field.quantityHint":
        "от 2 единиц образуется составной объект, частичные выбытия списываются пропорционально",
    "avm.wizard.field.usedBy": "Использует / ответственный",
    "avm.wizard.field.amountNet": "Стоимость приобретения нетто",
    "avm.wizard.field.amountGross": "Стоимость приобретения брутто (сумма счёта)",
    "avm.wizard.field.amountPartial": "Сумма к учёту (нетто плюс невычитаемый НДС)",
    "avm.wizard.field.incidental": "Сопутствующие расходы",
    "avm.wizard.field.incidentalHint": "доставка, монтаж, сборка",
    "avm.wizard.field.date": "Дата приобретения",
    "avm.wizard.field.dateHint": "определяющей является готовность к эксплуатации",
    "avm.wizard.field.vat": "Входящий НДС",
    "avm.wizard.field.vatHint": "значение по умолчанию из настроек",
    "avm.wizard.vat.net": "полностью вычитается, учёт по нетто",
    "avm.wizard.vat.gross": "не вычитается, учёт по брутто",
    "avm.wizard.vat.partial": "частично вычитается, указать долю",
    "avm.wizard.vat.kust": "без НДС (§ 19 UStG), сумма счёта",
    "avm.wizard.field.record": "Документ из бухгалтерии",
    "avm.wizard.record.none": "Привязать документ позже",
    "avm.wizard.classification.expense": "До {limit} нетто: сразу в расходы. Включение в реестр не требуется.",
    "avm.wizard.classification.recordAnyway": "Всё равно учесть как основное средство",
    "avm.wizard.classification.gwg":
        "Малоценный объект. До {limit} нетто полностью амортизируется в году приобретения, объект остаётся в реестре.",
    "avm.wizard.classification.pool": "Пул. От {min} до {max} нетто, списание за {years} лет.",
    "avm.wizard.classification.linear":
        "Учёт и амортизация в течение срока использования. Свыше {limit} нетто: плановая амортизация пропорционально с месяца приобретения.",
    "avm.wizard.method.linear": "Линейная амортизация",
    "avm.wizard.method.linearDesc": "равномерно в течение срока использования, пропорционально в первом году",
    "avm.wizard.method.gwg": "Малоценный объект, единовременное списание",
    "avm.wizard.method.gwgDesc": "полная амортизация в году приобретения",
    "avm.wizard.method.pool": "Пул (Sammelposten)",
    "avm.wizard.method.degressive": "Дегрессивная амортизация",
    "avm.wizard.method.poolDesc": "списание за {years} лет независимо от выбытия отдельных объектов",
    "avm.wizard.method.degressiveDesc":
        "тройная линейная ставка, не более 30 процентов, только для приобретений в установленный законом период",
    "avm.wizard.field.usefulLifeYears": "Срок использования (годы)",
    "avm.wizard.field.usefulLifeMonths": "Срок использования (месяцы)",
    "avm.wizard.field.usefulLifeHint": "предложение из группы основных средств",
    "avm.wizard.field.usefulLifeHintBuilding": "определяется использованием и датой (§ 7 Abs. 4 EStG)",
    "avm.wizard.field.usefulLifeHintLease": "определяется окончанием договора аренды",
    "avm.wizard.field.usefulLifeHintBuildingGroup":
        "определяется использованием и датой (§ 7 Abs. 4 EStG) или окончанием договора аренды",
    "avm.wizard.special.label": "Специальная амортизация по § 7g Abs. 5 EStG",
    "avm.wizard.special.description":
        "{amount} полностью в год приобретения дополнительно к плановой амортизации, не более {rate} процентов базы; возможно в первые {years} лет с момента приобретения.",
    "avm.wizard.special.windowUnavailable":
        "Для этой даты приобретения специальная амортизация по § 7g Abs. 5 EStG невозможна.",
    "avm.wizard.iab.label": "Назначить инвестиционный вычет",
    "avm.wizard.iab.empty": "Нет неназначенного инвестиционного вычета.",
    "avm.memoValue.label": "Остаточная стоимость в конце срока полезного использования",
    "avm.memoValue.one": "1,00 (памятная стоимость)",
    "avm.memoValue.zero": "0,00",
    "avm.memoValue.wizardHint":
        "Предзаполнено из настроек компании; значение по умолчанию можно изменить там, и оно действует только для новых основных средств.",
    "avm.memoValue.assetHint":
        "Действует только для этого основного средства. Изменение значения по умолчанию в настройках не меняет это значение.",
    "avm.roundingMode.label": "Округление амортизации",
    "avm.roundingMode.wizardHint":
        "Округление подставлено из настроек компании; значение по умолчанию меняется там и действует только для новых основных средств.",
    "avm.roundingMode.assetHint":
        "Действует только для этого основного средства. Изменение значения по умолчанию в настройках не меняет это округление.",
    "avm.oneYear.hardwareQuestion": "Это компьютерное оборудование или периферия (письмо BMF от 22.02.2022)?",
    "avm.oneYear.hardware.yes": "Да",
    "avm.oneYear.hardware.no": "Нет",
    "avm.oneYear.hardwareHint":
        "Компьютеры, ноутбуки, планшеты, тонкие клиенты, рабочие станции, док-станции, небольшие серверы, внешние блоки питания и периферия.",
    "avm.oneYear.label": "Срок службы по письму BMF от 22.02.2022",
    "avm.oneYear.term.one": "1 год",
    "avm.oneYear.term.oneDesc": "Полная амортизация в хозяйственном году приобретения, независимо от месяца",
    "avm.oneYear.term.three": "3 года",
    "avm.oneYear.term.threeDesc": "36 месяцев, помесячно с месяца приобретения",
    "avm.oneYear.beforeCutoff":
        "«1 год» применяется только к хозяйственным годам, заканчивающимся после 31.12.2020 (письмо BMF от 22.02.2022); это приобретение амортизируется за 3 года.",
    "avm.import.row.error.fullYearAfaCutoff":
        "1 год применяется только к хозяйственным годам после 31.12.2020; выберите 3 года",
    "avm.oneYear.saasHint": "Подписки SaaS и облачные подписки не являются основными средствами и не вносятся в реестр",
    "avm.businessUse90.label":
        "В хозяйственном году инвестиции и в следующем сдаётся в аренду или используется в бизнесе не менее чем на 90 % в отечественном постоянном учреждении",
    "avm.businessUse90.tooltip":
        "Специальная амортизация (§ 7g Abs. 6 Nr. 2 EStG) и инвестиционный вычет (§ 7g Abs. 1 Satz 1 EStG) требуют, чтобы основное средство в хозяйственном году инвестиции и в следующем хозяйственном году сдавалось в аренду или использовалось в отечественном постоянном учреждении исключительно или почти исключительно, то есть не менее чем на 90 %, в бизнесе. Легковой автомобиль, частное использование которого облагается по правилу одного процента, обычно этому не соответствует.",
    "avm.businessUse90.tooltipLabel": "Пояснение к использованию в хозяйственном году инвестиции и в следующем",
    "avm.businessUse90.rests.special": "На этом подтверждении основана проведённая специальная амортизация.",
    "avm.businessUse90.rests.iab": "На этом подтверждении основан привязанный инвестиционный вычет.",
    "avm.businessUse90.rests.both":
        "На этом подтверждении основаны проведённая специальная амортизация и привязанный инвестиционный вычет.",
    "avm.businessUse90.remove.open": "Чтобы снять его, сначала {step}.",
    "avm.businessUse90.remove.closed":
        "Хозяйственный год {year} закрыт; чтобы снять подтверждение, сначала откройте его снова, затем {step}.",
    "avm.businessUse90.remove.closedBefore":
        "Хозяйственный год {year} предшествует закрытому году {latest}; чтобы снять подтверждение, сначала откройте закрытия с {latest} обратно до {year}, затем {step}.",
    "avm.businessUse90.step.special": "сторнируйте специальную амортизацию",
    "avm.businessUse90.step.iab": "отмените привязку инвестиционного вычета",
    "avm.businessUse90.step.both": "сторнируйте специальную амортизацию и отмените привязку",
    "avm.import.field.businessUse90Confirmed": "Аренда или использование в бизнесе не менее 90 %",
    "avm.businessUse90.hint": "Условие для специальной амортизации и инвестиционного вычета по § 7g EStG",
    "avm.wizard.error.businessUse90":
        "Подтвердите использование в бизнесе не менее 90 % или откажитесь от специальной амортизации и инвестиционного вычета",
    "avm.movements.error.businessUse90":
        "Специальная амортизация требует использования в бизнесе не менее 90 % (§ 7g Abs. 6 Nr. 2 EStG). Сначала подтвердите это в основных данных или выберите другой тип движения.",
    "avm.iab.form.assetBusinessUse90": "Использование в бизнесе не менее 90 % не подтверждено в основных данных",
    "avm.assets.method.fullYear": "1 год (полная амортизация в год приобретения)",
    "avm.groups.oneYearChoice": "Выбор 1 год / 3 года",
    "avm.groups.oneYearChoice.none": "Не предлагать",
    "avm.groups.oneYearChoice.always": "Предлагать всегда (ПО)",
    "avm.groups.oneYearChoice.askHardware": "После вопроса об оборудовании (компьютерное оборудование)",
    "avm.groups.oneYearChoice.hint":
        "По письму BMF от 22.02.2022 ПО и компьютерное оборудование можно полностью списать в год приобретения (1 год) или за 3 года.",
    "avm.groups.oneYearChoice.kind": "Только для групп движимых или нематериальных активов",
    "avm.rightKind.label": "Вид права",
    "avm.rightKind.patent": "Патент",
    "avm.rightKind.trademark": "Товарный знак",
    "avm.rightKind.other": "Иное право",
    "avm.rightKind.filingDate": "Дата подачи заявки",
    "avm.rightKind.hint.patent":
        "Патент действует 20 лет с даты подачи заявки (§ 16 PatG). Срок полезного использования заполнен оставшимся сроком с даты приобретения и не может его превышать.",
    "avm.rightKind.hint.trademark":
        "Для приобретённого товарного знака предзаполнено 180 месяцев (письмо BMF от 12.07.1999); более короткий срок возможен.",
    "avm.rightKind.hint.other":
        "Для иного права значения по умолчанию нет. Укажите срок полезного использования по сроку договора.",
    "avm.rightKind.error.required": "Выберите вид права: патент, товарный знак или иное право.",
    "avm.rightKind.error.filingDate":
        "Для патента максимальный срок зависит от даты подачи заявки (§ 16 PatG). Укажите дату подачи или выберите другой вид права.",
    "avm.rightKind.error.expired":
        "На дату приобретения патент уже истёк; оформите его как иное право или проверьте дату подачи заявки",
    "avm.rightKind.error.lifeAbovePatent":
        "Патент действует 20 лет с даты подачи заявки (§ 16 PatG); с даты приобретения это не более {max} месяцев. Укажите не более {max} месяцев или проверьте дату подачи.",
    "avm.rightKind.error.remainingAbovePatent":
        "Патент действует 20 лет с даты подачи заявки (§ 16 PatG); с {start} это не более {max} месяцев. Укажите не более {max} месяцев или проверьте дату подачи.",
    "avm.rightKind.error.movementExpired":
        "На {start} патент уже истёк. Оставьте остаточный срок пустым или проверьте дату подачи.",
    "avm.rightKind.error.openingExpired":
        "На {start} патент уже истёк. Оформите объект как иное право или проверьте дату подачи.",
    "avm.groups.asksRightKind": "Запрашивать вид права",
    "avm.groups.asksRightKind.hint":
        "Каждый объект этой группы выбирает патент, товарный знак или иное право; вид права задаёт предзаполнение срока.",
    "avm.groups.asksRightKind.kind":
        'Настройка "Запрашивать вид права" доступна только для групп нематериальных активов. Отключите её.',
    "avm.import.field.fullYearAfa": "1 год (полная амортизация)",
    "avm.import.field.hardwareBmf": "Компьютерное оборудование (BMF)",
    "avm.import.field.rightKind": "Вид права (Patent, Marke, Sonstiges Recht)",
    "avm.import.field.patentFilingDate": "Дата подачи заявки (патент)",
    "avm.import.row.error.flag": "Значение да/нет не распознано (ja, nein, x или пусто)",
    "avm.import.row.error.fullYearAfa":
        "Эта группа не предлагает 1 год (только ПО или подтверждённое компьютерное оборудование)",
    "avm.import.row.error.fullYearAfaTerms": "1 год требует линейной амортизации на 12 месяцев",
    "avm.import.row.error.fullYearAfaPool":
        "1 год невозможен: стоимость попадает в сводную позицию (Sammelposten), предписанную выбором компании",
    "avm.import.row.error.hardwareBmf": "Ответ об оборудовании возможен только в группе с вопросом об оборудовании",
    "avm.import.row.error.rightKind":
        "Вид права не распознан или не запрашивается в этой группе; укажите Patent, Marke или Sonstiges Recht в группе с этим вопросом",
    "avm.import.row.error.patentFilingDate":
        "Патент без читаемой даты подачи; укажите дату подачи или выберите другой вид права",
    "avm.import.row.error.patentExpired":
        "На дату приобретения патент уже истёк; оформите его как иное право или проверьте дату подачи заявки",
    "avm.import.row.error.patentLife":
        "Срок дольше оставшегося срока патента (20 лет с даты подачи, § 16 PatG); сократите его или проверьте дату подачи",
    "avm.wizard.preview.title": "Предварительный просмотр",
    "avm.wizard.preview.summary": "{years} лет, амортизация в первом году {afa}",
    "avm.wizard.preview.col.year": "Год",
    "avm.wizard.preview.col.months": "Месяцы",
    "avm.wizard.preview.col.afa": "Амортизация",
    "avm.wizard.preview.col.bookValueEnd": "Стоимость на конец",
    "avm.wizard.preview.none":
        "Для этих данных предпросмотр не рассчитывается. Sammelposten списывается как группа, а дата приобретения вне загруженных хозяйственных лет не даёт плана.",
    "avm.wizard.preview.buildingMissing": "Для предпросмотра укажите использование и дату (или окончание аренды).",
    "avm.wizard.review.title": "Будет сохранено",
    "avm.wizard.review.inventoryNum": "Инвентарный номер",
    "avm.wizard.review.inventoryAuto": "присваивается автоматически",
    "avm.wizard.review.konto": "Счёт",
    "avm.wizard.review.method": "Метод",
    "avm.wizard.review.afaFirstYear": "Амортизация {year}",
    "avm.wizard.review.postingTitle": "Проводка поступления",
    "avm.wizard.review.postingNote":
        "Входящий счёт уже проводится на счёт основных средств. Реестр не создаёт проводку поступления, привязанный документ подтверждает поступление.",
    "avm.wizard.review.linkedRecord": "Привязанный документ",
    "avm.wizard.review.noRecord": "документ не привязан",
    "avm.wizard.review.specialDepreciation": "Специальная амортизация § 7g Abs. 5",
    "avm.wizard.review.businessUse90": "Аренда или использование в бизнесе не менее 90 %",
    "avm.wizard.review.confirmed": "подтверждено",
    "avm.wizard.review.notConfirmed": "не подтверждено",
    "avm.wizard.review.iabAssigned": "Инвестиционный вычет назначен",
    "avm.wizard.error.nameRequired": "Требуется наименование",
    "avm.wizard.error.groupRequired": "Требуется группа основных средств",
    "avm.wizard.error.quantity": "Количество должно быть не менее 1",
    "avm.wizard.error.dateRequired": "Требуется дата приобретения",
    "avm.wizard.error.amountRequired": "Требуется стоимость приобретения",
    "avm.wizard.error.recordAnyway": "Подтвердите, что объект нужно учесть несмотря на это",
    "avm.wizard.error.usefulLife": "Требуется срок использования",
    "avm.wizard.error.method": "Выбранный метод недопустим для этой суммы",
    "avm.wizard.error.specialMethod": "Специальная амортизация возможна только при линейной амортизации",
    "avm.wizard.error.acquisitionDateTooEarly":
        "Дата приобретения раньше самого раннего года с налоговыми параметрами {year}. Выберите дату не ранее {year}-01-01.",
    "avm.noAccounting.proposals":
        "Предложения по поступлениям берутся из бухгалтерии и доступны только при наличии доступа к бухгалтерскому продукту.",
    "avm.noAccounting.recordDocuments":
        "Документы связанной проводки доступны только при наличии доступа к бухгалтерскому продукту.",
    "avm.noAccounting.costCenter":
        "Центры затрат берутся из бухгалтерии и доступны только при наличии доступа к бухгалтерскому продукту.",
    "avm.noAccounting.record":
        "Привязка документа из бухгалтерии доступна только при наличии доступа к бухгалтерскому продукту.",
    "avm.noAccounting.batches":
        "Пакет проводок передаёт амортизацию в бухгалтерию и доступен только при наличии доступа к бухгалтерскому продукту.",
    "avm.proposals.title": "Открытые предложения из бухгалтерии",
    "avm.proposals.empty": "Нет открытых предложений",
    "avm.proposals.loading": "Предложения загружаются",
    "avm.proposals.take": "принять",
    "avm.proposals.dismiss": "скрыть",
    "avm.proposals.net": "нетто {amount}",
    "avm.proposals.reason.noAsset": "Счёт {konto}, основное средство не заведено",
    "avm.proposals.reason.gwg": "Счёт {konto}, ниже {limit}, предложение: малоценный объект",
    "avm.proposals.reason.expense": "Счёт {konto}, ниже {limit}, возможно сразу в расходы",
    "avm.import.eyebrow": "Первичный ввод",
    "avm.import.title": "Импорт и существующие основные средства",
    "avm.import.lead":
        "Существующие реестры основных средств загружаются из файла Excel или CSV. Столбцы распознаются и могут быть сопоставлены, перед импортом система проверяет достоверность и суммы.",
    "avm.import.drop": "Перетащите файл сюда или нажмите (.xlsx, .xls, .csv)",
    "avm.import.dropActive": "Отпустите файл",
    "avm.import.rejected": "Этот формат файла не поддерживается. Разрешены .xlsx, .xls и .csv.",
    "avm.import.file": "{fileName}, строк: {count}",
    "avm.import.clear": "Выбрать другой файл",
    "avm.import.parseError": "Не удалось прочитать файл",
    "avm.import.headerRow.label": "Строка заголовка",
    "avm.import.headerRow.hint":
        "Строка, распознанная как заголовок. Если названия столбцов ниже выглядят неверно, выберите правильную строку.",
    "avm.import.headerRow.option": "Строка {row}: {preview}",
    "avm.import.headerRow.emptyRow": "(пустая строка)",
    "avm.import.mapping.title": "Сопоставление столбцов",
    "avm.import.mapping.col.column": "Столбец в файле",
    "avm.import.mapping.col.sample": "Пример значения",
    "avm.import.mapping.col.field": "Поле в реестре",
    "avm.import.mapping.col.status": "Статус",
    "avm.import.mapping.status.recognized": "распознано",
    "avm.import.mapping.status.optional": "необязательно",
    "avm.import.mapping.status.required": "обязательно",
    "avm.import.mapping.ignore": "не импортировать",
    "avm.import.mapping.missing": "Обязательное поле не сопоставлено: {field}",
    "avm.import.mapping.missingGroup": "Должен быть сопоставлен столбец группы основных средств",
    "avm.import.mapping.duplicateColumn": "Сопоставлено с тем же столбцом, что и другое поле",
    "avm.import.field.inventoryNum": "Инвентарный номер",
    "avm.import.field.name": "Объект",
    "avm.import.field.group": "Группа основных средств",
    "avm.import.field.acquisitionDate": "Дата приобретения",
    "avm.import.field.acquisitionCost": "Стоимость приобретения",
    "avm.import.field.usefulLifeYears": "Срок использования (годы)",
    "avm.import.field.usefulLifeMonths": "Срок использования (месяцы)",
    "avm.import.field.openingBookValue": "Балансовая стоимость прошлого года",
    "avm.import.field.remainingMonths": "Оставшийся срок (месяцы)",
    "avm.import.field.supplier": "Поставщик",
    "avm.import.field.location": "Местонахождение",
    "avm.import.field.costCenter": "Центр затрат",
    "avm.import.field.quantity": "Количество",
    "avm.import.field.usedBy": "Использует",
    "avm.import.field.note": "Заметка",
    "avm.import.field.method": "Метод амортизации",
    "avm.import.field.memoValue": "Памятная стоимость",
    "avm.import.field.roundingMode": "Округление",
    "avm.import.checks.title": "Проверка перед импортом",
    "avm.import.checks.ok": "Строк без ошибок: {count}.",
    "avm.import.checks.needsLife": "Строк без срока использования: {count}. Предложение из группы, подтвердите.",
    "avm.import.checks.acceptLife": "Принять предложенные сроки использования",
    "avm.import.checks.errors": "Строк с ошибками, которые не будут импортированы: {count}.",
    "avm.import.checks.expectedTotal": "Ожидаемая сумма остаточных стоимостей",
    "avm.import.checks.computedTotal": "Сумма по файлу: {amount}",
    "avm.import.checks.totalMatches": "совпадает с закрытием прошлого года",
    "avm.import.checks.totalDiffers": "отклоняется от закрытия прошлого года на {delta}",
    "avm.import.checks.openingYear": "Начальный остаток на начало хозяйственного года {year}",
    "avm.import.submit": "Импортировать строк: {count}",
    "avm.import.rows.title": "Строки",
    "avm.import.rows.col.row": "Строка",
    "avm.import.rows.col.status": "Статус",
    "avm.import.rows.col.problems": "Замечания",
    "avm.import.rows.status.ok": "ок",
    "avm.import.rows.status.needsLife": "подтвердить срок использования",
    "avm.import.rows.status.error": "ошибка",
    "avm.import.row.error.name": "Отсутствует наименование",
    "avm.import.row.error.group":
        "Группа основных средств «{value}» не найдена. Укажите название существующей группы: {groups}",
    "avm.import.row.error.groupAmbiguous":
        "Счёт актива «{value}» относится к нескольким группам основных средств: {candidates}. Укажите название группы.",
    "avm.import.row.error.date": "Недопустимая дата приобретения",
    "avm.import.row.error.cost": "Недопустимая стоимость приобретения",
    "avm.import.row.error.bookValue": "Недопустимая балансовая стоимость",
    "avm.import.row.error.bookValueAboveCost": "Балансовая стоимость выше стоимости приобретения",
    "avm.import.row.error.usefulLife": "Срок использования отсутствует, и у группы нет значения по умолчанию",
    "avm.import.row.error.costCenter": "Центр затрат длиннее 8 символов",
    "avm.import.row.error.quantity": "Недопустимое количество",
    "avm.import.row.error.memoValue":
        "Недопустимая памятная стоимость: допустимы 1, 1,00, 0 или 0,00; пустое поле берёт значение по умолчанию из настроек",
    "avm.import.row.error.roundingMode":
        "Недопустимое округление: разрешены Euro (до полного евро) или Cent (до цента); пустое значение берётся из настроек",
    "avm.import.row.error.inventoryNum": "Недопустимый инвентарный номер",
    "avm.import.row.error.degressiveWindow": "Дегрессивная амортизация вне установленного законом периода",
    "avm.import.row.error.methodKind":
        "Метод амортизации недопустим в этой группе. Укажите в файле допустимый метод или отнесите строку к другой группе.",
    "avm.import.row.error.poolGroup":
        "Сборная позиция без группы сборных позиций. Создайте группу сборных позиций в настройках и загрузите файл снова.",
    "avm.import.row.note.poolGroup":
        "Перенесено в группу сборных позиций {name}: правило пула охватывает каждое средство в этом диапазоне стоимости.",
    "avm.import.row.note.linearForKind":
        "Применена линейная амортизация, так как группа не допускает выведенный метод.",
    "avm.import.row.error.acquisitionDateTooEarly": "Дата приобретения раньше самого раннего налогового года {year}",
    "avm.import.ways.title": "Пути в реестр",
    "avm.import.ways.excel": "Импорт из Excel",
    "avm.import.ways.excelDesc": "Существующие объекты с остаточной стоимостью и оставшимся сроком на дату перехода.",
    "avm.import.ways.wizard": "Мастер ввода",
    "avm.import.ways.wizardDesc": "Отдельные поступления в четыре шага.",
    "avm.import.ways.proposals": "Предложение из бухгалтерии",
    "avm.import.ways.proposalsDesc": "Проводки на счета основных средств без объекта предлагаются как поступления.",
    "avm.building.title": "Данные здания",
    "avm.building.titleOptional": "Данные здания для ввода в эксплуатацию",
    "avm.building.optionalHint": "Нужны, только если при вводе в эксплуатацию объект переносится в группу зданий.",
    "avm.building.basis": "Основа срока использования",
    "avm.building.basis.building": "Здание (§ 7 абз. 4 EStG)",
    "avm.building.basis.lease": "Неотделимое улучшение арендованного объекта (остаток срока аренды)",
    "avm.building.type.building": "Амортизация здания по § 7 Abs. 4 EStG",
    "avm.building.type.buildingDesc":
        "срок полезного использования по использованию, заявке на строительство и вводу в эксплуатацию",
    "avm.building.type.lease": "Неотделимое улучшение арендованного объекта (остаток срока аренды)",
    "avm.building.type.leaseDesc": "срок полезного использования до окончания аренды, не более 400 месяцев",
    "avm.building.use": "Использование здания",
    "avm.building.use.nonResidentialBusiness":
        "Производственное здание в составе коммерческого имущества, не для жилья",
    "avm.building.use.other": "Другое здание, например жилое",
    "avm.building.applicationDate": "Заявка на строительство подана",
    "avm.building.completionDate": "Дата завершения строительства",
    "avm.building.leaseEnd": "Договор аренды заканчивается",
    "avm.building.limit.building":
        "Законный срок использования: {months} мес. Более короткий фактический срок допустим при наличии подтверждения.",
    "avm.building.limit.lease": "Остаток срока аренды: {months} мес. (не более 400). Более короткий срок допустим.",
    "avm.building.error.missingUse":
        "Укажите использование здания с датами заявки и завершения строительства или дату окончания аренды.",
    "avm.building.error.missingApplicationDate":
        "Ставка амортизации производственного здания зависит от даты заявки на строительство (§ 7 абз. 4 предл. 1 № 1 EStG). Укажите дату заявки.",
    "avm.building.error.missingCompletionDate":
        "Ставка амортизации здания зависит от года завершения строительства (§ 7 абз. 4 предл. 1 № 2 EStG). Укажите дату завершения.",
    "avm.building.error.missingLeaseEnd": "Укажите дату окончания аренды.",
    "avm.building.error.leaseBeforeStart":
        "Аренда заканчивается до начала амортизации. Проверьте дату окончания аренды.",
    "avm.building.error.completionLifeTooLong":
        "Ввод в эксплуатацию задаёт срок {life} мес.; по этим данным здания допустимо не более {max} мес. Проверьте данные здания или сторнируйте перенос и проведите его снова со сроком не более {max} мес.",
    "avm.building.error.completionDateDiffers":
        "Здание введено в эксплуатацию переносом от {date}; этот перенос и есть дата завершения. Установите дату завершения на {date} или оставьте поле пустым.",
    "avm.building.split.landFailed":
        "Здание сохранено, доля земли {amount} нет ({reason}). Учтите её как отдельный объект в группе {name}.",
    "avm.building.error.completionDateDiffersTransfer":
        "Этим переносом здание вводится в эксплуатацию {date}; перенос и есть дата завершения. Дата завершения в данных здания отличается. Установите её в основных данных на {date} или оставьте пустой.",
    "avm.movements.form.targetGroup.buildingCompletionDate":
        "Дата завершения отличается от переноса: исправьте её в основных данных",
    "avm.building.error.flipClosed":
        "Изменение переключает амортизацию здания между законной ставкой (§ 7 абз. 4 предл. 1 EStG) и распределением на остаточный срок; это меняет суммы начиная с движения от {date} в закрытом финансовом году {year}. Откройте снова {latest} и сначала сторнируйте движение от {date}.",
    "avm.building.error.flipRemaining":
        "Изменение переключает амортизацию здания между законной ставкой (§ 7 абз. 4 предл. 1 EStG) и распределением на остаточный срок; движение от {date} задаёт остаточный срок {months} мес., который больше не действовал бы. Сначала сторнируйте движение от {date}.",
    "avm.movements.storno.lifeRests":
        "На этом вводе в эксплуатацию основан остаточный срок движения от {date}. Сначала сторнируйте движение от {date}.",
    "avm.building.error.quantityOneDisposed":
        "Здание ведётся как одно основное средство с количеством 1; частичная продажа определяется долей площади и проводится вручную в бухгалтерии. Частичное выбытие уже проведено, поэтому количество не может стать 1. Выберите другую группу.",
    "avm.assets.quantity.error.belowDisposed":
        "Количество не может стать {quantity}: {count, plural, one {частичным выбытием} other {частичными выбытиями}} от {dates} уже выбыло {units} шт. Введите количество не менее {min} или сначала сторнируйте {count, plural, one {частичное выбытие} other {частичные выбытия}} от {dates}.",
    "avm.building.error.quantityOne":
        "Здание ведётся как один объект с количеством 1; частичная продажа определяется долей площади и проводится вручную в бухгалтерии. Укажите количество 1 и учтите каждое следующее здание как отдельный объект.",
    "avm.building.error.flipForward":
        "Если объект должен числиться в новой группе только с этого момента, оставьте здесь группу без изменений и проведите перенос в новую группу с датой после последнего движения от {date} в открытом финансовом году.",
    "avm.building.error.flipRemainingTransfer":
        "Перенос переключает амортизацию здания между законной ставкой (§ 7 абз. 4 предл. 1 EStG) и распределением на остаточный срок; движение от {date} задаёт остаточный срок {months} мес., который больше не действовал бы. Датируйте перенос позже {date} или сначала сторнируйте движение от {date}.",
    "avm.building.error.flipRemainingStorno":
        "Сторно переноса переключает амортизацию здания между законной ставкой (§ 7 абз. 4 предл. 1 EStG) и распределением на остаточный срок; движение от {date} задаёт остаточный срок {months} мес., который больше не действовал бы. Сначала сторнируйте движение от {date}, затем перенос.",
    "avm.movements.form.targetGroup.buildingQuantity":
        "Количество больше 1: у здания количество 1, сначала исправьте его в основных данных",
    "avm.movements.form.targetGroup.buildingQuantityDisposed":
        "Количество больше 1 и проведено частичное выбытие: у здания количество 1, выберите другую целевую группу",
    "avm.movements.error.beforeOpening":
        "Основное средство принято с начальным остатком {openingYear}; движение до финансового года {openingYear} уже учтено в принятой балансовой стоимости. Выберите дату в {openingYear} финансовом году или позже.",
    "avm.movements.error.buildingPartialDisposal":
        "Здание ведётся как один объект с количеством 1; частичная продажа определяется долей площади и проводится вручную в бухгалтерии. Проведите выбытие всего здания или проведите частичную продажу вручную.",
    "avm.building.error.lifeTooLong": "Срок использования превышает допустимые {max} мес. Укажите не более {max} мес.",
    "avm.building.error.completionAttributes":
        "Для переноса в группу зданий не хватает данных здания. Сначала укажите в основных данных объекта использование с датами заявки и завершения или дату окончания аренды.",
    "avm.building.remainingMonths":
        "Здание продолжает амортизироваться по законной ставке, в том числе после дополнительных затрат (R 7.4 абз. 9 EStR). Остаточный срок здесь не задаётся.",
    "avm.movements.form.targetGroup.buildingAttributes": "Нет данных здания: сначала укажите их в основных данных",
    "avm.movements.form.targetGroup.buildingLife": "Срок использования больше допустимого по § 7 абз. 4 EStG",
    "avm.building.split.label": "Разделить цену покупки на землю и здание",
    "avm.building.split.hint":
        "Доля земли учитывается как отдельный объект без амортизации в группе с ролью «земля». Наружные сооружения и производственное оборудование учитывайте отдельно.",
    "avm.building.split.land": "Доля земли",
    "avm.building.split.building": "Доля здания",
    "avm.building.split.sum": "Земля и здание в сумме дают {total}. Разделите доли так, чтобы сумма была ровно {cost}.",
    "avm.building.split.amount": "Укажите обе доли больше 0,00 или сохраните без разделения.",
    "avm.building.split.noLandGroup":
        "Нет группы с ролью «земля» для доли земли застроенных участков. Создайте стандартные группы в настройках, назначьте эту роль собственной неамортизируемой группе или сохраните без разделения.",
    "avm.building.split.landName": "{name}, земля",
    "avm.building.split.review": "Земля {land} в группе {name}, здание {building}",
    "avm.import.field.buildingUse": "Использование (хозяйственное здание или другое здание)",
    "avm.import.field.buildingApplicationDate": "Заявка на строительство",
    "avm.import.field.completionDate": "Завершение строительства",
    "avm.import.field.leaseEnd": "Окончание аренды",
    "avm.import.field.openingAfaBase": "База амортизации",
    "avm.import.field.openingUnimpairedBookValue": "Балансовая стоимость без частичного списания",
    "avm.import.field.specialBuildingAfa": "Использована специальная или дегрессивная амортизация здания",
    "avm.import.row.error.buildingUse":
        "Использование не распознано: укажите точно „Wirtschaftsgebäude im Betriebsvermögen, nicht zu Wohnzwecken“ или „Anderes Gebäude, zum Beispiel Wohngebäude“ (или NON_RESIDENTIAL_BUSINESS / OTHER)",
    "avm.import.row.error.buildingDate": "Заявка, завершение или окончание аренды не является датой",
    "avm.import.row.error.buildingUseOrLease":
        "Использование и окончание аренды исключают друг друга: укажите только одно",
    "avm.import.row.error.buildingMissing":
        "Нет данных здания: хозяйственному зданию нужна дата заявки, другому зданию дата завершения, неотделимому улучшению окончание аренды",
    "avm.import.row.error.buildingLife":
        "Срок полезного использования больше допустимого по § 7 абз. 4 EStG или окончание аренды до приобретения",
    "avm.import.row.error.buildingColumns":
        "Использование, заявка, завершение и окончание аренды относятся к группе зданий: проверьте группу или очистите ячейки",
    "avm.import.row.error.specialBuildingAfa":
        "Специальная или дегрессивная амортизация здания до принятия: отразите её в бухгалтерии",
    "avm.import.row.error.openingBase":
        "База амортизации только для принятого здания, между балансовой стоимостью прошлого года и стоимостью приобретения",
    "avm.import.row.error.openingUnimpaired":
        "Балансовая стоимость без частичного списания только для принятого здания, между балансовой стоимостью прошлого года и стоимостью приобретения",
    "avm.import.rows.col.building": "Здание",
    "avm.import.rows.building.lease": "Окончание аренды {date}",
    "avm.import.rows.building.base": "База амортизации {amount}",
    "avm.import.rows.building.unimpaired": "без частичного списания {amount}",
    "avm.assets.openingAfaBase": "База амортизации",
    "avm.assets.openingAfaBase.hint":
        "Оставьте пустым, если она равна стоимости приобретения. После частичного списания или специальной амортизации до принятия укажите уменьшенную базу.",
    "avm.assets.openingUnimpairedBookValue": "Балансовая стоимость без частичного списания",
    "avm.assets.openingUnimpairedBookValue.hint":
        "Балансовая стоимость на начало года открытия без частичных списаний; она ограничивает последующую дооценку.",
    "avm.import.field.openingCumulativeAfa": "Накопленная амортизация",
    "avm.import.row.error.cumulativeAfa":
        "Стоимость приобретения {cost} за вычетом накопленной амортизации {cumulative} не даёт балансовую стоимость прошлого года {bookValue}: исправьте балансовую стоимость или накопленную амортизацию",
    "avm.import.row.error.cumulativeAfaColumn":
        "Накопленная амортизация только как сумма от 0,00 и только для строки с начальным остатком: проверьте сумму или очистите ячейку",
    "app.agent.skippedNoRight": "Нет прав на {product}, эта часть пропущена.",
    "app.agent.stepFailed": "Шаг {step} не выполнен, продолжаем со следующего",
    "app.agent.stepFailedAsk": "Шаг {step} не выполнен.",
    "app.agent.stepFailedRetry": "Хотите повторить попытку?",
    "app.agent.stepFailedRetry.go": "Повторить",
    "app.agent.stepFailedRetry.continue": "Продолжить",
    "app.agent.startFailed":
        "Не удалось прочитать обзор, поэтому дальнейшие шаги не выполнялись. Закройте агента и запустите новый запуск.",
    "app.agent.recordsNotLoaded":
        "Шаг {step} не выполнен. Проводки за {year} сейчас не загружены. Выберите {year} год и попробуйте снова.",
    "app.agent.skippedBecause": "{step} отменяется, потому что {previous} пропущен.",
    "app.agent.approve.skip": "Пропустить",
    "app.agent.approve.granted": "Одобрено",
    "app.agent.mode.continue": "Далее",
    "app.agent.mode.group": "Режим работы",
    "app.agent.approve.learnMore": "Подробнее",
    "app.agent.approve.skipped": "Пропущено",
    "app.agent.approve.auto": "Выполняется автоматически",
    "app.agent.approve.waiting": "Ожидаю вашего ответа",
    "app.agent.mode.question": "Как мне действовать?",
    "app.agent.mode.approval": "С вопросами",
    "app.agent.mode.approval.badge": "Рекомендуется",
    "app.agent.mode.approval.desc":
        "Я спрашиваю перед каждым шагом, который что-то меняет. Вы заранее видите, что произойдет.",
    "app.agent.mode.quick": "Быстро",
    "app.agent.mode.quick.badge": "Автоматически",
    "app.agent.mode.quick.desc":
        "Я работаю без вопросов и спрашиваю, только если нужен ваш ввод: перед проведением кассовых документов без даты или перед объединением банковских проводок.",
    "app.agent.mode.quickSwitch": "Быстрый режим",
    "app.agent.mode.nextStep": "Со следующего шага: {mode}",
    "app.agent.skippedDependency": "Шаг {step} пропущен, потому что предыдущий шаг не выполнялся",
    "app.agent.nothingToDo": "Для шага {step} нечего делать",
    "app.agent.nothingOpen": "На шаге {step} ничего не сделано. Открыто: {count}",
    "app.agent.continuesOnServer": "Задача продолжает работу в фоне, результат будет в Binale",
    "app.agent.step.start": "Старт",
    "app.agent.step.upload": "Загрузка",
    "app.agent.step.aiReading": "Чтение ИИ",
    "app.agent.step.aiRetry": "Повторное чтение ИИ",
    "app.agent.step.autoSort": "Автосортировка",
    "app.agent.step.sortQuestions": "Вопросы по сортировке",
    "app.agent.step.documentContacts": "Контакты документов",
    "app.agent.step.kasseFromDocuments": "Касса из документов",
    "app.agent.step.bankImport": "Импорт банка",
    "app.agent.step.bankContacts": "Контакты банка",
    "app.agent.step.draftsFromDocuments": "Черновики из документов",
    "app.agent.step.draftsFromTransactions": "Черновики из транзакций",
    "app.agent.step.fillBank": "Сопоставление банка",
    "app.agent.step.reconcile": "Сверка счетов",
    "app.agent.step.aiCheck": "Проверка ИИ",
    "app.agent.step.postingRules": "Правила проводок",
    "app.agent.step.report": "Отчёт",
    "app.agent.title": "Binale Agent",
    "app.agent.button": "Binale Agent",
    "app.agent.stepOf": "Шаг {step} из {total}",
    "app.agent.phase.prepare": "Подготовка",
    "app.agent.phase.documents": "Документы",
    "app.agent.phase.bank": "Банк",
    "app.agent.phase.bookings": "Проводки",
    "app.agent.phase.review": "Проверка",
    "app.agent.stepList.nothing": "нечего делать",
    "app.agent.stepList.open": "открыто: {count}",
    "app.agent.stepList.skipped": "пропущено",
    "app.agent.stepList.noRight": "нет прав",
    "app.agent.stepList.failed": "сбой",
    "app.agent.stepList.running": "выполняется",
    "app.agent.stepList.asking": "ждёт ответа",
    "app.agent.stepList.pending": "ожидает",
    "app.agent.stepList.paused": "на паузе",
    "app.agent.stepList.pausing": "пауза после этого шага",
    "app.agent.state.pausing": "Пауза после этого шага",
    "app.agent.state.paused": "На паузе",
    "app.agent.minimize": "Свернуть",
    "app.agent.closeLocked": "Агент ещё работает. Закрыть можно после этого шага.",
    "app.agent.pill.step": "Шаг {step}/{total}",
    "app.agent.pill.progress": "{done} из {total}",
    "app.agent.pill.waiting": "Ждёт вас",
    "app.agent.companyLocked": "Сначала завершите Binale Agent.",
    "app.agent.finished": "Готово",
    "app.agent.progress": "{done} из {total} готово",
    "app.agent.pause": "Пауза после этого шага",
    "app.agent.resume": "Продолжить",
    "app.agent.stop": "Завершить",
    "app.agent.close": "Закрыть",
    "app.agent.confirmStop.title": "Завершить агента?",
    "app.agent.confirmStop.body": "Уже выполненные шаги сохраняются. Оставшиеся шаги не будут выполнены.",
    "app.agent.confirmStop.keep": "Продолжить работу",
    "app.agent.panelPlaceholder": "Это окно пока недоступно.",
    "app.agent.panelSkip": "Пропустить",
    "app.agent.start.thinking": "Знакомлюсь с документами, банковскими счетами и почтой. Ничего не изменяется.",
    "app.agent.start.found": "Найдено за {year} год",
    "app.agent.start.chip.documents": "Документов в «Новые документы»: {count}",
    "app.agent.start.chip.banks": "Банковских счетов с finAPI: {count}",
    "app.agent.start.chip.mailboxOk": "Почта подключена",
    "app.agent.start.chip.mailboxError": "Почта сообщает об ошибке",
    "app.agent.start.chip.openDocuments": "Документов к проводке: {count}",
    "app.agent.start.chip.openBank": "Банковских транзакций без проводки: {count}",
    "app.agent.start.chip.openKasse": "Кассовых транзакций без проводки: {count}",
    "app.agent.state.reading": "Читает",
    "app.agent.state.asking": "Вопрос к вам",
    "app.agent.state.running": "Выполняется",
    "app.agent.state.done": "Готово",
    "app.agent.state.nothing": "Нечего делать",
    "app.agent.state.skipped": "Пропущено",
    "app.agent.state.failed": "Сбой",
    "app.agent.state.pending": "Ожидает",
    "app.agent.start.mailboxError":
        "Почтовый ящик сообщает об ошибке, новые документы из почты не поступают. Проверьте подключение почты.",
    "app.agent.start.bankStale": "Банковский счет {bank} не импортировался более 30 дней.",
    "app.agent.start.uploadQuestion": "Загрузить новые документы сейчас?",
    "app.agent.start.upload": "Загрузить документы",
    "app.agent.start.skipUpload": "Продолжить без загрузки",
    "app.agent.upload.done": "Загружено документов: {count}",
    "app.agent.aiReading.progress": "ИИ читает ваши документы",
    "app.agent.aiReading.done": "Прочитано документов: {done}, не удалось прочитать: {failed}",
    "app.agent.aiRetry.thinking": "Запускаю чтение еще раз",
    "app.agent.aiRetry.done": "Прочитано документов: {done}, по-прежнему с ошибкой: {failed}",
    "app.agent.aiRetry.approve.question": "ИИ не смог прочитать документов: {count}. Попробовать еще раз?",
    "app.agent.aiRetry.approve.go": "Повторить",
    "app.agent.aiRetry.learnMore":
        "Повторяется только чтение, ваши проводки не меняются. Это может занять некоторое время. Если снова не получится, документ останется в «Новые документы», и вы сможете обработать его сами.",
    "app.agent.autoSort.thinking": "Сортирую документы из «Новые документы»",
    "app.agent.autoSort.done": "Отсортировано {moved} из {total} документов",
    "app.agent.autoSort.approve.question": "Отсортировать документы из «Новые документы»: {count}?",
    "app.agent.autoSort.approve.go": "Сортировать сейчас",
    "app.agent.autoSort.learnMore":
        "Я сортирую только документы, для которых назначение однозначно. Исходящие счета попадают в исходящие счета. Документы поставщика с единственным назначенным счетом попадают во входящие счета. Кассовые документы попадают в кассу. Документы, которым подходит ровно одна банковская операция, попадают в банк и связываются с этой операцией. При этом может быть дополнен способ оплаты в документе. Все остальное остается на месте, по этим документам я задам вам вопросы на следующем шаге. Ничего не удаляется и не проводится. Папку можно снова изменить в управлении документами; связь с банковской операцией вы снимаете в документе или в операции.",
    "app.agent.report.uploaded": "Загружено документов: {count}",
    "app.agent.report.aiRead": "Документов, прочитанных ИИ: {count}",
    "app.agent.report.aiRetried": "Документов, прочитанных со второй попытки: {count}",
    "app.agent.report.aiFailed": "Документов, которые не удалось прочитать: {count}",
    "app.agent.report.sorted": "Автоматически отсортировано {moved} из {total} документов",
    "app.agent.aiStillRunning": "Документов, которые еще читаются: {count}, результат появится в Binale",
    "app.agent.report.aiNotStarted": "Чтение ИИ не запущено для документов: {count}",
    "app.agent.sortQuestions.intro": "Мне нужна ваша помощь по документам: {count}",
    "app.agent.sortQuestions.later": "Позже",
    "app.agent.sortQuestions.done": "Отвечено по документам: {answered}, отложено: {later}",
    "app.agent.report.sortAnswered": "Документов, отсортированных по вашим ответам: {count}",
    "app.agent.report.sortLater": "Документов, ожидающих вашего решения: {count}",
    "app.agent.sortQuestions.documentMissing": "Документ не найден",
    "app.agent.documentContacts.thinking": "Сопоставляю документы с контактами",
    "app.agent.documentContacts.done":
        "Документов привязано к существующим контактам: {linked}, создано контактов: {created}",
    "app.agent.documentContacts.approveLink.question":
        "Найти существующие контакты и связать их с документами: {count}?",
    "app.agent.documentContacts.approveLink.go": "Связать контакты",
    "app.agent.documentContacts.approveCreate.question":
        "Для документов без существующего контакта: {count}. Создать новые контакты там, где известен идентификатор плательщика НДС?",
    "app.agent.documentContacts.approveCreate.go": "Создать контакты",
    "app.agent.documentContacts.learnMore":
        "Сначала я ищу для каждого документа существующий контакт по идентификатору плательщика НДС, налоговому номеру, IBAN или имени выставителя. Только если контакта нет и в документе указан идентификатор плательщика НДС, я создаю новый контакт с основными данными по этому идентификатору. Без идентификатора или без подходящей записи основных данных контакт не создается. Документы, у которых уже есть контакт, не затрагиваются. У существующего контакта может быть добавлен новый IBAN выставителя, в остальном он не меняется.",
    "app.agent.report.documentContactsLinked": "Документов привязано к существующим контактам: {count}",
    "app.agent.report.documentContactsCreated": "Контактов создано из документов: {count}",
    "app.agent.kasse.thinking": "Провожу кассовые документы по кассе",
    "app.agent.kasse.done": "Кассовых проводок создано для {register}: {count}",
    "app.agent.kasse.approve.question": "Создать кассовые проводки по кассовым документам: {count}?",
    "app.agent.kasse.approve.go": "Создать кассовые проводки",
    "app.agent.kasse.approveUndated.question":
        "У {count} кассовых документов нет даты документа. Провести их с сегодняшней датой?",
    "app.agent.kasse.approveUndated.go": "Провести с сегодняшней датой",
    "app.agent.kasse.learnMore":
        "Из каждого кассового документа я создаю кассовую проводку с датой, суммой и контактом документа и связываю их. Приход это или расход, определяется кассовой папкой. Документы, у которых уже есть кассовая проводка, повторно не проводятся. Без суммы или пока документ еще читается, я ничего не создаю и указываю это в отчете. Если даты документа нет, я использую сегодняшнюю дату, проверьте ее в кассе.",
    "app.agent.report.kasseCreated": "Кассовых проводок создано из документов: {count}",
    "app.agent.report.kasseRefused": "Кассовых документов не удалось провести: {count}, проверьте их в кассе",
    "app.agent.details.show": "Показать подробности",
    "app.agent.details.hide": "Скрыть подробности",
    "app.agent.details.more": "и ещё {count}",
    "app.agent.details.loading": "загружается",
    "app.agent.details.gone": "больше не существует",
    "app.agent.details.unnamed.document": "Документ без названия",
    "app.agent.details.unnamed.record": "Запись без номера документа",
    "app.agent.details.unnamed.bankTransaction": "Банковская операция без данных",
    "app.agent.details.unnamed.kasseTransaction": "Кассовая запись без данных",
    "app.agent.details.unnamed.contact": "Контакт без имени",
    "app.agent.details.autoSort.movedUnknown": "Отсортировано",
    "app.agent.details.group.done": "Выполнено",
    "app.agent.details.group.needsYou": "Нужно ваше решение",
    "app.agent.details.group.refused": "Отклонено",
    "app.agent.details.group.untouched": "Не изменено",
    "app.agent.details.autoSort.moved": "Перемещено в {folder}",
    "app.agent.details.autoSort.movedSub": "Перемещено в {folder} / {subFolder}",
    "app.agent.details.autoSort.reason.bankAmbiguous": "Подходят несколько банковских операций, выберите одну",
    "app.agent.details.autoSort.reason.noBankMatch": "Подходящая банковская операция не найдена",
    "app.agent.details.autoSort.reason.paymentMixed": "Способ оплаты неоднозначен",
    "app.agent.details.autoSort.reason.paymentUnknown": "Способ оплаты неизвестен",
    "app.agent.details.autoSort.reason.informational": "Документ является обзором, а не первичным документом",
    "app.agent.details.autoSort.reason.notProcessed": "ИИ ещё не прочитал документ",
    "app.agent.details.autoSort.reason.notInNewDocuments": "Документа больше нет в папке Новые документы",
    "app.agent.details.autoSort.reason.error": "При сортировке произошла ошибка",
    "app.agent.details.autoSort.reason.unclear": "Нет однозначного соответствия",
    "app.agent.details.documentContacts.linked": "Связан с существующим контактом",
    "app.agent.details.documentContacts.created": "Создан и связан новый контакт",
    "app.agent.details.documentContacts.alreadyLinked": "Контакт уже был",
    "app.agent.details.documentContacts.noMatch": "Подходящий контакт не найден",
    "app.agent.details.documentContacts.noAiResult": "ИИ не нашёл отправителя",
    "app.agent.details.documentContacts.notFound": "Документ не найден",
    "app.agent.details.documentContacts.noVatId": "В документе нет USt-IdNr.",
    "app.agent.details.documentContacts.notInVatRegister": "USt-IdNr. нет в справочных данных",
    "app.agent.details.documentContacts.ownCompanyVat": "USt-IdNr. принадлежит вашей собственной фирме",
    "app.agent.details.kasse.created": "Кассовая запись создана в {register}",
    "app.agent.details.kasse.alreadyLinked": "Кассовая запись уже есть",
    "app.agent.details.kasse.refused.notFound": "Документ не найден",
    "app.agent.details.kasse.refused.notKasseFolder": "Документ не находится в папке кассы",
    "app.agent.details.kasse.refused.notProcessed": "Документ ещё читается",
    "app.agent.details.kasse.refused.noAmount": "В документе нет суммы",
    "app.agent.details.kasse.refused.saveFailed": "Не удалось сохранить",
    "app.agent.details.kasse.refused.unknown": "Не создано",
    "app.agent.details.kasse.undatedManual": "Нет даты документа, проведите в кассе вручную",
    "app.agent.details.kasse.undatedBooked": "Проверьте дату (проведено с сегодняшней датой)",
    "app.agent.report.kasseUndatedManual":
        "{count} кассовых документов без даты документа, проведите их в кассе вручную",
    "app.agent.report.kasseUndatedBooked": "Кассовых проводок с сегодняшней датой, проверьте дату: {count}",
    "app.agent.details.ai.read": "Прочитано ИИ",
    "app.agent.details.ai.failed": "Не удалось прочитать",
    "app.agent.details.ai.notStarted": "Чтение не было запущено",
    "app.agent.details.ai.running": "Ещё читается",
    "app.agent.details.bankImport.imported": "Новый импорт",
    "app.agent.details.bankContacts.matched": "Привязано к существующему контакту",
    "app.agent.details.bankContacts.checkMatch": "Найдено по имени или назначению платежа, проверьте",
    "app.agent.details.bankContacts.created": "Создан новый контакт и привязан",
    "app.agent.details.bankContacts.linkedExisting": "Привязано к уже существующему контакту",
    "app.agent.details.bankContacts.alreadyLinked": "Контакт уже был",
    "app.agent.details.bankContacts.noMatch": "Подходящий контакт не найден",
    "app.agent.details.bankContacts.notFound": "Операция не найдена",
    "app.agent.details.drafts.created": "Черновик проводки создан",
    "app.agent.details.drafts.created.template": "Черновик создан со счётом из шаблона контакта",
    "app.agent.details.drafts.created.predicted": "Черновик создан с предложением ИИ по счёту",
    "app.agent.details.drafts.noSuggestion": "Без предложения счёта, проверьте",
    "app.agent.details.drafts.noAccount": "Не указан счёт",
    "app.agent.details.drafts.alreadyBooked": "Проводка уже есть",
    "app.agent.details.drafts.failed": "Не удалось провести",
    "app.agent.details.drafts.running": "Проводится в фоновом режиме",
    "app.agent.details.txDrafts.created": "Черновик проводки создан",
    "app.agent.details.txDrafts.alreadyExported": "Проводка уже есть",
    "app.agent.details.txDrafts.invalid": "Не проведено: {message}",
    "app.agent.details.txDrafts.invalidNoMessage": "Не проведено, данные неполные",
    "app.agent.details.txDrafts.notFound": "Операция не найдена",
    "app.agent.details.fillBank.unifySum": "Сводная проводка объединена с операцией",
    "app.agent.details.fillBank.unifyMultiple": "Несколько проводок объединены с операцией",
    "app.agent.details.fillBank.gkonto": "Добавлен кредитор или дебитор",
    "app.agent.details.fillBank.connect": "Связано со счётом",
    "app.agent.details.fillBank.ambiguous": "Подходит несколько проводок, выберите одну",
    "app.agent.details.fillBank.journaled": "Зафиксировано, не изменено",
    "app.agent.details.reconcile.applied": "Связано со счётом",
    "app.agent.details.reconcile.alreadyApplied": "Уже было связано",
    "app.agent.details.reconcile.changed": "Счёт изменился, проверьте его в сверке счетов",
    "app.agent.details.reconcile.failed": "Не удалось связать",
    "app.agent.details.reconcile.accountFailed": "Счёт не удалось сверить, проверьте свои права для Bank и Kasse",
    "app.agent.details.reconcile.skipped.MULTIPLE_SOURCES":
        "Подходит несколько счетов, сверьте вручную в сверке счетов",
    "app.agent.details.reconcile.skipped.NO_SOURCE": "Подходящий счёт не найден",
    "app.agent.details.reconcile.skipped.SUM_MISMATCH": "Платежи не покрывают открытую сумму точно",
    "app.agent.details.aiCheck.valid": "Совпадает с документом",
    "app.agent.details.aiCheck.invalid": "Отличается от документа",
    "app.agent.details.aiCheck.notChecked": "Не удалось проверить, нет единственного документа",
    "app.agent.aiCheck.check.booking_date": "Дата проводки отличается от документа",
    "app.agent.aiCheck.check.brutto_amount": "Сумма брутто отличается от документа",
    "app.agent.aiCheck.check.invoice_number": "Номер счёта отличается от документа",
    "app.agent.aiCheck.check.vat_amount": "Сумма НДС отличается от документа",
    "app.agent.details.postingRules.incoming":
        "Правило для {counterparty} (входящие, счёт {account}) принято как черновик",
    "app.agent.details.postingRules.outgoing":
        "Правило для {counterparty} (исходящие, счёт {account}) принято как черновик",
    "app.agent.details.sortQuestions.stillOpen": "Всё ещё в новых документах, будет проверен при следующем запуске",
    "app.agent.details.sortQuestions.left": "Больше не в новых документах",
    "app.agent.bankImport.start": "Импорт банковских операций для {bank}. Запустите импорт кнопкой Обновить.",
    "app.agent.bankImport.done": "{bank}: импортировано банковских операций: {count}",
    "app.agent.bankImport.doneNoCount": "{bank}: банковские операции импортированы",
    "app.agent.bankImport.skipped": "Банк {bank} пропущен",
    "app.agent.bankImport.skipBank": "Пропустить этот банк",
    "app.agent.report.bankImportedNoCount": "{bank}: банковские операции импортированы",
    "app.agent.report.bankImported": "{bank}: импортировано банковских операций: {count}",
    "app.agent.report.bankSkipped": "Банковских счетов пропущено: {count}",
    "app.agent.bankContacts.thinking": "Сопоставляю банковские операции с существующими контактами",
    "app.agent.bankContacts.approveMatch.question":
        "Сопоставить банковские операции с вашими контактами и привязать подходящие: {count}?",
    "app.agent.bankContacts.approveMatch.go": "Привязать контакты",
    "app.agent.bankContacts.learnMoreMatch":
        "Я сравниваю контрагента операции с вашими контактами, сначала по IBAN, затем по имени и в последнюю очередь по назначению платежа. Если по IBAN подходит несколько контактов, операция остаётся без изменений. По имени и назначению платежа я беру первый подходящий контакт, поэтому проверьте привязку при похожих именах. Операции, у которых уже есть контакт, не меняются. К контакту может быть добавлен новый IBAN.",
    "app.agent.bankContacts.approveCreate.question":
        "Из банковских операций ({n}) можно создать новых контактов: {count}. Создать их?",
    "app.agent.bankContacts.approveCreate.go": "Создать контакты",
    "app.agent.bankContacts.learnMoreCreate":
        "Я предлагаю новые контакты, если IBAN операции известен в основных данных компании с USt-IdNr., а такого контакта у вас ещё нет. Контакт создаётся с основными данными и привязывается ко всем подходящим операциям. Если контакт уже есть, он только привязывается.",
    "app.agent.bankContacts.matched": "Банковских операций привязано к контактам: {count}",
    "app.agent.bankContacts.suggesting": "Ищу новые контакты в оставшихся банковских операциях",
    "app.agent.bankContacts.creating": "Создаю контакты",
    "app.agent.bankContacts.created": "Контактов создано: {count}",
    "app.agent.bankContacts.noContactsProduct": "Модуль контактов для этой компании не активен.",
    "app.agent.report.bankContactsMatched": "Банковских операций привязано к контактам: {count}",
    "app.agent.report.bankContactsCreated": "Контактов создано из банковских операций: {count}",
    "app.agent.report.bankContactsLinkedExisting": "Банковских операций привязано к существующим контактам: {count}",
    "app.agent.report.bankContactsOpen": "Контактов из банковских операций ещё не создано: {count}",
    "app.agent.report.bankContactsCheck": "Сопоставлений с контактами на проверку: {count}",
    "app.agent.drafts.thinking": "Ищу документы без черновика проводки",
    "app.agent.drafts.progress": "Черновики из документов ({product})",
    "app.agent.drafts.done": "Черновиков из документов создано: {count} ({product})",
    "app.agent.drafts.approve.question": "Создать черновики проводок по документам: {count}?",
    "app.agent.drafts.approve.go": "Создать черновики",
    "app.agent.drafts.learnMore":
        "Из данных, найденных ИИ в документе, для каждого документа создается черновик проводки с суммой и датой. Счет подставляется из ваших шаблонов контактов или по предложению ИИ; если не получается, он остается пустым, и вы дополняете его. Черновик еще не окончателен: его можно проверить, изменить или удалить. Документы, у которых уже есть проводка или которые относятся к банковской или кассовой операции, повторно не проводятся. Исходящие счета на этом шаге не включены. Не проводятся, например, документы без даты, простые обзоры или документы в годах, которые еще не настроены; это указано в отчете.",
    "app.agent.report.draftsCreated": "Черновиков из документов создано: {count}",
    "app.agent.report.draftRefused": "Документов не проведено: {count}. Причина: {reason}",
    "app.agent.report.draftsFailed": "Документов не удалось провести: {count}",
    "app.agent.report.draftsRunning": "Документов проводится в фоне: {count}, результат будет в Binale",
    "app.agent.txDrafts.bankThinking": "Создаю черновики из банковских операций",
    "app.agent.txDrafts.kasseThinking": "Создаю черновики из кассы",
    "app.agent.txDrafts.approve.question":
        "Создать черновики проводок для операций, которые ещё не проведены: {count}?",
    "app.agent.txDrafts.approve.go": "Создать черновики",
    "app.agent.txDrafts.learnMore":
        "Из каждой операции создаётся черновик проводки с датой, суммой и контрагентом. По возможности я предлагаю корреспондирующий счёт, иначе он остаётся пустым. Операции, у которых уже есть проводка, пропускаются, поэтому повторный запуск не создаёт дублей. Черновики не окончательные, их можно в любой момент изменить или удалить. Операции без суммы, без настроенного года или счёта я пропускаю и называю в отчёте.",
    "app.agent.txDrafts.bankDone": "Черновиков из банковских операций создано: {count}",
    "app.agent.txDrafts.kasseDone": "Черновиков из кассы создано: {count}",
    "app.agent.report.txDraftsBank": "Черновиков из банковских операций создано: {count}",
    "app.agent.report.txDraftsKasse": "Черновиков из кассы создано: {count}",
    "app.agent.report.txDraftsNotFound": "Операций не найдено: {count}, обновите страницу и запустите снова",
    "app.agent.report.txDraftsInvalid": "Операций не проведено, данные неполные: {count}",
    "app.agent.fillBank.thinking": "Сопоставляю банковские операции с вашими проводками",
    "app.agent.fillBank.approve.question":
        "Дополнить кредитора или дебитора для {count} проводок и связать проводки со счетами?",
    "app.agent.fillBank.approve.go": "Сопоставить банк",
    "app.agent.fillBank.approveMerge.question":
        "Объединить сводные и множественные проводки для {count} проводок? Автоматически созданные банковские проводки при этом удаляются.",
    "app.agent.fillBank.approveMerge.go": "Объединить",
    "app.agent.fillBank.learnMore":
        "Я по очереди выполняю функции «Сопоставить банк». При объединении сводных и множественных проводок автоматически созданная банковская проводка заменяется вашей собственной, которая принимает операцию; автоматическая проводка удаляется. Кроме того, я дополняю кредитора или дебитора из ваших шаблонов контактов и связываю проводки с открытыми счетами, если сумма точно совпадает и номер счёта указан в назначении платежа или есть общий документ. Зафиксированные проводки я не меняю. Если возможно несколько вариантов, я не угадываю и оставляю операцию для вашего выбора.",
    "app.agent.fillBank.done": "Банковских операций сопоставлено: {count}",
    "app.agent.report.fillBankMatched": "Банковских операций сопоставлено: {count}",
    "app.agent.report.fillBankAmbiguous":
        "Банковских операций с несколькими вариантами проводок, нужен ваш выбор: {count}",
    "app.agent.report.fillBankJournaled": "Банковских операций закрыто и не изменено: {count}",
    "app.agent.reconcile.thinking": "Сверяю счета",
    "app.agent.reconcile.approve.question":
        "Связать подходящие платежи ({groups}) с открытыми счетами на счетах ({accounts})?",
    "app.agent.reconcile.approve.go": "Связать платежи",
    "app.agent.reconcile.learnMore":
        "Быстрая сверка связывает открытый счёт с платёжными проводками из банка, кассы или бухгалтерии, если номер счёта и счёт совпадают, а платежи точно покрывают открытую сумму. Принимаются только эти однозначные случаи, всё остальное остаётся без изменений и обрабатывается вручную при сверке счетов или в расширенной сверке. Скидка (Skonto) не учитывается. Повторный запуск ничего не дублирует, потому что уже связанные платежи не используются повторно. Если счёт изменился после планирования, он не принимается.",
    "app.agent.reconcile.done": "Платежей связано со счетами: {count}",
    "app.agent.report.reconciled": "Платежей связано со счетами: {count}",
    "app.agent.report.reconcileSkipped": "Групп сверки, требующих вашей проверки: {count}",
    "app.agent.report.reconcileChanged": "Групп сверки, изменившихся и не применённых: {count}",
    "app.agent.report.reconcileFailed": "Групп сверки, которые не удалось создать: {count}",
    "app.agent.report.reconcileAccountFailed":
        "Счетов, которые не удалось сверить, проверьте права на Банк и Кассу: {count}",
    "app.agent.aiCheck.thinking": "Проверяю проводки с помощью ИИ",
    "app.agent.aiCheck.approve.question": "Ещё раз сверить с документами новые проводки: {count}?",
    "app.agent.aiCheck.approve.go": "Проверить проводки",
    "app.agent.aiCheck.learnMore":
        "Я точно сравниваю номер счёта, дату проводки, сумму брутто и сумму НДС каждой новой проводки со значениями, считанными из документа, и отмечаю расхождения. Сама проводка не меняется, сохраняется только результат проверки. Проводки без документа или с несколькими документами проверить нельзя, они указываются в отчёте.",
    "app.agent.aiCheck.done": "Проверено проводок: {checked}, с расхождениями: {invalid}",
    "app.agent.report.aiChecked": "Проводок проверено с помощью ИИ: {count}",
    "app.agent.report.aiCheckInvalid": "Проводок, расходящихся с документом, проверьте их: {count}",
    "app.agent.report.aiCheckNotChecked": "Проводок, которые не удалось проверить, проверьте их сами: {count}",
    "app.agent.postingRules.thinking": "Ищу предложения правил проводок",
    "app.agent.postingRules.approve.question": "Предложений правил проводок: {count}. Принять их как черновики?",
    "app.agent.postingRules.approve.go": "Принять как черновик",
    "app.agent.postingRules.learnMore":
        "Правила проводок определяют, на какой счёт в будущем проводятся документы определённого поставщика или клиента. Предложения основаны на ваших прежних проводках. Для партнёров, у которых уже есть правило, в том числе отклонённое, я новых предложений не делаю. Предложения принимаются только как черновики; они начинают действовать, только когда вы подтвердите их в правилах проводок.",
    "app.agent.postingRules.importing": "Принимаю предложения как черновики",
    "app.agent.postingRules.done": "Правил проводок принято как черновики: {count}",
    "app.agent.report.postingRulesImported": "Правил проводок принято как черновики, активируйте их сами: {count}",
    "app.agent.report.title": "Отчет",
    "app.agent.report.thinking": "Подвожу итоги",
    "app.agent.report.sectionDone": "Готово",
    "app.agent.report.sectionOpen": "Нужно от вас",
    "app.agent.report.nothingDone": "Делать было нечего.",
    "app.agent.report.nothingOpen": "Ничего не осталось.",
    "app.agent.report.continuesInBinale": "{step}: продолжается в фоне, результат будет в Binale",
    "app.agent.report.pending.DOCUMENTS_NEED_ANSWER": "Документов ждут вашего ответа: {count}",
    "app.agent.report.pending.DOCUMENTS_NOT_PROCESSED": "Документов еще не прочитано ИИ: {count}",
    "app.agent.report.pending.DOCUMENTS_READY_TO_BOOK": "Документов готово к проводке: {count}",
    "app.agent.report.pending.BANK_TRANSACTIONS_NOT_BOOKED": "Банковских операций еще не проведено: {count}",
    "app.agent.report.pending.KASSE_TRANSACTIONS_NOT_BOOKED": "Кассовых операций еще не проведено: {count}",
    "app.agent.report.pending.AI_DRAFTS_TO_REVIEW": "Черновиков ИИ ждут вашей проверки: {count}",
    "app.agent.report.pending.DRAFTS_WITHOUT_ACCOUNT": "Черновиков еще без счета: {count}",
    "app.agent.report.ustvaOpen": "В Binale для {period} еще не передана декларация по НДС",
    "app.agent.report.download": "Скачать отчет",
    "app.agent.report.finished": "Готово",
    "app.agent.report.periodChanged": "Год {year}, весь год",
    "app.agent.report.stepDone": "выполнено",
    "app.agent.report.stepsIn": "{count} шагов за {duration}",
    "app.agent.report.counts": "{done} выполнено, {nothing} без изменений, {skipped} пропущено, {failed} с ошибкой",
    "app.agent.report.durationMinutes": "{minutes} мин {seconds} с",
    "app.agent.report.durationSeconds": "{seconds} с",
    "app.agent.report.modeLine": "Режим: {mode}",
    "app.agent.report.summary": "Сводка",
    "app.agent.report.tile.sorted": "Документов рассортировано",
    "app.agent.report.tile.drafts": "Черновиков создано",
    "app.agent.report.tile.bankImported": "Банковских операций импортировано",
    "app.agent.report.tile.needsYou": "Требуют вашего внимания",
    "app.agent.report.link.documents": "Открыть документы",
    "app.agent.report.link.drafts": "Проверить черновики",
    "app.agent.report.link.draftsCount": "Проверить черновики ({count})",
    "app.agent.report.link.bank": "Открыть операции",
    "app.agent.report.link.kasse": "Открыть кассу",
    "app.agent.report.link.contacts": "Открыть контакты",
    "app.agent.report.link.rules": "Открыть правила",
    "app.agent.report.link.list": "К списку",
    "app.agent.report.todoTitle": "Что сделать сейчас",
    "app.agent.report.todo.failed": "{step}: ошибка",
    "app.agent.report.todo.skipped": "{step}: пропущено",
    "app.agent.report.action.retry": "Повторить",
    "app.agent.report.action.rerun": "Выполнить сейчас",
    "app.agent.report.action.check": "Проверить",
    "app.agent.report.action.resolve": "Разобрать",
    "app.agent.report.bucketsTitle": "Открытые задачи до и после",
    "app.agent.report.bucketsLegend": "до → после",
    "app.agent.report.stepsTitle": "Подробности по шагам",
    "app.agent.report.phaseChip.done": "{count} выполнено",
    "app.agent.report.phaseChip.nothing": "{count} без изменений",
    "app.agent.report.phaseChip.skipped": "{count} пропущено",
    "app.agent.report.phaseChip.failed": "{count} с ошибкой",
    "app.agent.report.bucket.DOCUMENTS_NEED_ANSWER": "Документы с открытым вопросом",
    "app.agent.report.bucket.DOCUMENTS_NOT_PROCESSED": "Документы ещё не прочитаны",
    "app.agent.report.bucket.DOCUMENTS_READY_TO_BOOK": "Документы готовы к проводке",
    "app.agent.report.bucket.BANK_TRANSACTIONS_NOT_BOOKED": "Банковские операции не проведены",
    "app.agent.report.bucket.BANK_TRANSACTIONS_WITHOUT_DOCUMENT": "Банковские операции без документа",
    "app.agent.report.bucket.KASSE_TRANSACTIONS_NOT_BOOKED": "Кассовые операции не проведены",
    "app.agent.report.bucket.KASSE_TRANSACTIONS_WITHOUT_DOCUMENT": "Кассовые операции без документа",
    "app.agent.report.bucket.AI_DRAFTS_TO_REVIEW": "Черновики ИИ на проверку",
    "app.agent.report.bucket.DRAFTS_WITHOUT_ACCOUNT": "Черновики без счёта",
    "app.agent.report.bucket.OPEN_INVOICES": "Открытые счета",
    "app.agent.details.open": "Открыть",
    "app.agent.details.notLoaded": "не загружено",
    "app.fields.istNonGeldkontoHint":
        "Этот счёт не является денежным/платёжным счётом и не делает Umsatzsteuer подлежащей уплате при Ist-Versteuerung.",
};
